
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("6Wkby", function(module, exports) {
$parcel$export(module.exports, "getClickUrl", () => $c9f0f5b3a4594103$export$cf3c5acf9e9d0f02);

var $34cqa = parcelRequire("34cqa");
const $c9f0f5b3a4594103$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $34cqa.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};

});
parcelRegister("34cqa", function(module, exports) {
$parcel$export(module.exports, "extractVisitUrl", () => $0258efc03475914c$export$c81497d3681f24f4);
const $0258efc03475914c$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("7jLk8", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkCrossProductUrlWrapper", () => $10850d467ede2d0d$export$119a84bedaff7b6e);

var $bSJIT = parcelRequire("bSJIT");

var $6RhUR = parcelRequire("6RhUR");

var $6bOBo = parcelRequire("6bOBo");

var $7U8jx = parcelRequire("7U8jx");

var $5PvpU = parcelRequire("5PvpU");
const $10850d467ede2d0d$export$119a84bedaff7b6e = ({ details: details })=>{
    const { product: product, bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct } = (0, $6bOBo.useSmartLinkContext)();
    // xpcProduct takes precedence over product — it identifies the host product for XPC analytics
    // without affecting link resolution (which uses the `product` prop separately).
    const effectiveProduct = xpcProduct ?? product;
    const effectiveBridge = bridgeProduct ?? (0, $7U8jx.XPC_CONSTANTS).SMART_LINKS_XPC_BRIDGE;
    const effectiveProductForWrapper = (effectiveProduct === null || effectiveProduct === void 0 ? void 0 : effectiveProduct.toLowerCase()) ?? 'unknown';
    const wrapUrl = (0, $6RhUR.useCrossProductUrlWrapper)({
        bridge: effectiveBridge,
        product: effectiveProductForWrapper,
        ...xpcSubProduct ? {
            subProduct: xpcSubProduct
        } : {}
    });
    return (0, $bSJIT.useCallback)((url)=>{
        if (typeof window === 'undefined' || !(0, $5PvpU.getIsFirstPartyLink)(details) || !effectiveProduct) return url;
        let parsedUrl;
        try {
            parsedUrl = new URL(url);
        } catch  {
            return url;
        }
        if (parsedUrl.searchParams.has((0, $7U8jx.XPC_CONSTANTS).QUERY_PARAM)) return url;
        return wrapUrl(url);
    }, // Keep bridge/subproduct in the dependency array so consumers that memoize this callback
    // refresh when mini-modal context updates from smartLinks to rovo-chat.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        details,
        effectiveBridge,
        effectiveProduct,
        wrapUrl,
        xpcSubProduct
    ]);
};

});
parcelRegister("6RhUR", function(module, exports) {
$parcel$export(module.exports, "useCrossProductUrlWrapper", () => $61b7faf6396c46cd$export$fc6e9265f8d85c92);
$parcel$export(module.exports, "default", () => $61b7faf6396c46cd$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $3zzvD = parcelRequire("3zzvD");

var $69Cm8 = parcelRequire("69Cm8");

var $d2dvq = parcelRequire("d2dvq");
const $61b7faf6396c46cd$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
/**
 * Kill switch config, defaults to enabled so we fail open if the config can't be resolved.
 * https://switcheroo.atlassian.com/ui/configurations/d3b9839b-0a19-4f81-928e-44fc4fac4c55/key/atlaskit-analytics-cross-product-kill-switch
 */ const $61b7faf6396c46cd$var$KILL_SWITCH_CONFIG = 'atlaskit-analytics-cross-product-kill-switch';
/**
 * This React hook is called with the correct bridge, product and sub-product parameters.
 * It returns a function that can be used to generate URLs with cross-product interaction parameters.
 *
 * @param options - Properties object that contains the following parameters:
 *
 * @returns A function that appends interaction session ID and other cross-product interaction parameters to a given URL.
 */ function $61b7faf6396c46cd$export$fc6e9265f8d85c92(options) {
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    // This is a kill switch rather than an experiment, so no exposure is fired.
    const isEnabled = !(0, $3zzvD.UNSAFE_expValNoExposure)($61b7faf6396c46cd$var$KILL_SWITCH_CONFIG, 'value', false);
    // `useRef(initialValue)` evaluates `initialValue` on every render but only uses the result on
    // the first render. Populate the ref imperatively the first time we need it so we don't call
    // `getInstance()` on every render (per Billy Chen's review suggestion).
    const interactionSessionClientRef = (0, $bSJIT.useRef)(undefined);
    if (isEnabled && !interactionSessionClientRef.current) interactionSessionClientRef.current = (0, $d2dvq.default).getInstance();
    const [interactionSessionId, setInteractionSessionId] = (0, $bSJIT.useState)(()=>{
        var _interactionSessionCl;
        return ((_interactionSessionCl = interactionSessionClientRef.current) === null || _interactionSessionCl === void 0 ? void 0 : _interactionSessionCl.getCurrentInteractionSessionId()) ?? '';
    });
    (0, $bSJIT.useEffect)(()=>{
        if (!isEnabled) return ()=>{};
        // Add event listener that subscribes to any future interaction session ID updates
        const unbind = (0, $bAB3U.bind)(document, {
            type: $61b7faf6396c46cd$export$5d4c4eab0863aae3,
            listener: ()=>{
                // Re-attempt fetch Global interactionSessionClient if not present already
                if (!interactionSessionClientRef.current) interactionSessionClientRef.current = (0, $d2dvq.default).getInstance();
                if (interactionSessionClientRef.current) {
                    const currentSessionId = interactionSessionClientRef.current.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            }
        });
        return unbind;
    }, [
        isEnabled
    ]);
    return (0, $bSJIT.useCallback)((url)=>{
        if (!isEnabled || !interactionSessionId) return url;
        return (0, $69Cm8.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
    }, [
        isEnabled,
        bridge,
        interactionSessionId,
        product,
        subProduct
    ]);
}
var $61b7faf6396c46cd$export$2e2bcd8739ae039 = $61b7faf6396c46cd$export$fc6e9265f8d85c92;

});
parcelRegister("69Cm8", function(module, exports) {
$parcel$export(module.exports, "generateUrlWithParams", () => $e46f1c17b911b2e4$export$2e3999ec51334ffe);
const $e46f1c17b911b2e4$export$81d16f1428ce0486 = 'xpis';
const $e46f1c17b911b2e4$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($e46f1c17b911b2e4$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("d2dvq", function(module, exports) {
$parcel$export(module.exports, "default", () => $398bedd584222cdd$export$2e2bcd8739ae039);
// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
const $398bedd584222cdd$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $398bedd584222cdd$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($398bedd584222cdd$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$398bedd584222cdd$export$7bc189309d2ad463];
        } catch (err) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

});


parcelRegister("7U8jx", function(module, exports) {
$parcel$export(module.exports, "XPC_CONSTANTS", () => $5c6802a3a813bbfd$export$77dc2792a6ac896b);
const $5c6802a3a813bbfd$export$77dc2792a6ac896b = {
    SMART_LINKS_XPC_BRIDGE: 'smartLinks',
    QUERY_PARAM: 'xpis'
};

});

parcelRegister("5PvpU", function(module, exports) {
$parcel$export(module.exports, "getIsFirstPartyLink", () => $d86e1e38cf7631b3$export$189e6ab4f1c74893);
const $d86e1e38cf7631b3$export$189e6ab4f1c74893 = (details)=>{
    var _details$meta;
    return ((details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.is1PLink) ?? false) === true;
};

});


parcelRegister("4zQGY", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkRenderers", () => $9ec234d86d8c87b7$export$c3514c024fefef57);

var $bSJIT = parcelRequire("bSJIT");

var $6bOBo = parcelRequire("6bOBo");
const $9ec234d86d8c87b7$export$c3514c024fefef57 = ()=>{
    const context = (0, $6bOBo.useSmartLinkContext)();
    let renderers = context === null || context === void 0 ? void 0 : context.renderers;
    renderers = (0, $bSJIT.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});

parcelRegister("iTFEF", function(module, exports) {
$parcel$export(module.exports, "SmartLinkModalProvider", () => $da9fd017114aea20$export$bb4eb02a83e1a0f8);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $lddvR = parcelRequire("lddvR");

var $d078P = parcelRequire("d078P");
const $da9fd017114aea20$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $bSJIT.useState)(null);
    const api = (0, $bSJIT.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lddvR.StopPropagation), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $bSJIT.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $bSJIT.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d078P.SmartLinkModalContext).Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};

});
parcelRegister("lddvR", function(module, exports) {
$parcel$export(module.exports, "StopPropagation", () => $8a452777b224fdde$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");
const $8a452777b224fdde$var$styles = {
    wrapper: "_c71lidpf _p12fidpf _kqswstnw"
};
const $8a452777b224fdde$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $bSJIT.useCallback)((e)=>{
        // Prevent click events from bubbling up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        role: "none",
        xcss: $8a452777b224fdde$var$styles.wrapper,
        onClick: onClick
    }, children);
};

});


parcelRegister("aiGES", function(module, exports) {
$parcel$export(module.exports, "getAnchorAttributesFromEvent", () => $b558c3a85c91f8a7$export$bd1e92a09497f497);
const $b558c3a85c91f8a7$export$bd1e92a09497f497 = (event)=>{
    const currentTarget = event.currentTarget;
    if (!(currentTarget instanceof HTMLAnchorElement)) return {
        href: undefined,
        target: '_self'
    };
    return {
        href: currentTarget.href,
        target: currentTarget.target || '_self'
    };
};

});

parcelRegister("qHDjo", function(module, exports) {
$parcel$export(module.exports, "isSpecialClick", () => $deea01cad1be0bfa$export$5b1771037ab7c451);
parcelRequire("bSJIT");
const $deea01cad1be0bfa$export$5b1771037ab7c451 = (event)=>event.button === 1;

});

parcelRegister("hNqc2", function(module, exports) {
$parcel$export(module.exports, "isSpecialEvent", () => $7a7b469f2bc5209f$export$efca2c4705678489);
parcelRequire("bSJIT");

var $3nhAQ = parcelRequire("3nhAQ");

var $qHDjo = parcelRequire("qHDjo");

var $lRg5h = parcelRequire("lRg5h");
const $7a7b469f2bc5209f$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ((0, $3nhAQ.isIframe)() || (0, $lRg5h.isSpecialKey)(evt) || (0, $qHDjo.isSpecialClick)(evt));

});
parcelRegister("3nhAQ", function(module, exports) {
$parcel$export(module.exports, "isIframe", () => $bce36817e4ff6a58$export$e6c5ffa684aac4d7);
const $bce36817e4ff6a58$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;

});

parcelRegister("lRg5h", function(module, exports) {
$parcel$export(module.exports, "isSpecialKey", () => $391b131ba2fae7e3$export$d8de0cd37d316fdf);
parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");
const $391b131ba2fae7e3$export$d8de0cd37d316fdf = (event)=>{
    return (0, $gdUUy.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};

});


parcelRegister("4zpBM", function(module, exports) {
$parcel$export(module.exports, "updateAnchorHref", () => $3f94e99580e5f5da$export$9853bee72613d48f);
const $3f94e99580e5f5da$export$9853bee72613d48f = (event, href)=>{
    if (!(event.currentTarget instanceof HTMLAnchorElement)) return;
    event.currentTarget.href = href;
};

});

parcelRegister("dkOB1", function(module, exports) {
$parcel$export(module.exports, "default", () => $83175ea13103113e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $6bOBo = parcelRequire("6bOBo");

var $gdUUy = parcelRequire("gdUUy");

var $1qPbZ = parcelRequire("1qPbZ");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $7IXqa = parcelRequire("7IXqa");

var $7avPz = parcelRequire("7avPz");

var $cnUW1 = parcelRequire("cnUW1");

var $1Nceg = parcelRequire("1Nceg");

var $cUXyD = parcelRequire("cUXyD");

var $7jLk8 = parcelRequire("7jLk8");

var $1LfMp = parcelRequire("1LfMp");

var $b653z = parcelRequire("b653z");
const $83175ea13103113e$var$PENDING_LINK_STATUSES = [
    (0, $5kJPq.SmartLinkStatus).Pending,
    (0, $5kJPq.SmartLinkStatus).Resolving
];
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $83175ea13103113e$var$FlexibleCard = ({ appearance: appearance = 'flexible', navigation: navigation, cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, onError: onError, onResolve: onResolve, origin: origin, placeholderData: placeholderData, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url, title: ssrTitle })=>{
    var _details$meta2, _flexibleCardContext$;
    const aiSummaryConfig = (0, $cnUW1.useAISummaryConfig)();
    const resolve = (0, $1Nceg.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, product: product } = (0, $6bOBo.useSmartLinkContext)();
    const rovoConfig = (0, $cUXyD.default)();
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const appendCrossProductAnalyticsParams = (0, $7jLk8.useSmartLinkCrossProductUrlWrapper)({
        details: details
    });
    const transformUrl = (0, $bSJIT.useCallback)((destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl), [
        appendCrossProductAnalyticsParams,
        url
    ]);
    // if we have placeholder state it means we can internally use it
    // as temporary resolved data until the actual data comes back as one of the final statuses
    const placeholderCardState = (0, $bSJIT.useMemo)(()=>$83175ea13103113e$var$PENDING_LINK_STATUSES.includes(status) && placeholderData && (0, $7IXqa.extractPlaceHolderCardState)(placeholderData), [
        placeholderData,
        status
    ]);
    const placeHolderStatus = placeholderCardState ? placeholderCardState.status : undefined;
    const context = (0, $bSJIT.useMemo)(()=>(0, $b653z.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: placeholderCardState ? placeholderCardState.details : details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            product: product,
            rovoConfig: rovoConfig,
            actionOptions: actionOptions,
            status: placeholderCardState ? placeHolderStatus : status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $gdUUy.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }), [
        aiSummaryConfig,
        appearance,
        actionOptions,
        details,
        id,
        isPreviewPanelAvailable,
        isPreviewRestricted,
        onAuthorize,
        onClick,
        onAuxClick,
        onContextMenu,
        openPreviewPanel,
        origin,
        placeholderCardState,
        placeHolderStatus,
        product,
        renderers,
        resolve,
        rovoConfig,
        status,
        transformUrl,
        url,
        fireEvent
    ]);
    const flexibleCardContext = (0, $bSJIT.useMemo)(()=>({
            data: context,
            navigation: context ? navigation : undefined,
            status: placeHolderStatus ?? status,
            ui: ui
        }), [
        context,
        placeHolderStatus,
        status,
        ui,
        navigation
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle === null || linkTitle === void 0 ? void 0 : linkTitle.text;
    (0, $bSJIT.useEffect)(()=>{
        switch(status){
            case (0, $5kJPq.SmartLinkStatus).Resolved:
                if (onResolve) {
                    var _details$meta;
                    onResolve({
                        title: title,
                        url: url,
                        extensionKey: details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key
                    });
                }
                break;
            case (0, $5kJPq.SmartLinkStatus).Errored:
            case (0, $5kJPq.SmartLinkStatus).Fallback:
            case (0, $5kJPq.SmartLinkStatus).Forbidden:
            case (0, $5kJPq.SmartLinkStatus).NotFound:
            case (0, $5kJPq.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url,
        details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key
    ]);
    const retry = (_flexibleCardContext$ = flexibleCardContext.data) === null || _flexibleCardContext$ === void 0 || (_flexibleCardContext$ = _flexibleCardContext$.actions) === null || _flexibleCardContext$ === void 0 ? void 0 : _flexibleCardContext$[(0, $5kJPq.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7avPz.FlexibleCardContext).Provider, {
        value: flexibleCardContext
    }, $83175ea13103113e$var$PENDING_LINK_STATUSES.includes(status) && !Boolean(placeholderCardState) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: "smart-card-flexible-card"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1LfMp.default), {
        testId: testId,
        ...ui,
        title: ssrTitle,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        actionOptions: actionOptions,
        status: status,
        retry: retry
    }, children));
};
var $83175ea13103113e$export$2e2bcd8739ae039 = $83175ea13103113e$var$FlexibleCard;

});
parcelRegister("7IXqa", function(module, exports) {
$parcel$export(module.exports, "extractPlaceHolderCardState", () => $0ffa4c8bfd5ca137$export$684541b2632ffbbc);
const $0ffa4c8bfd5ca137$var$isValidPlaceholderData = (placeholderData)=>(placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.data) && 'url' in placeholderData.data && 'name' in placeholderData.data;
const $0ffa4c8bfd5ca137$export$684541b2632ffbbc = (placeholderData)=>{
    return $0ffa4c8bfd5ca137$var$isValidPlaceholderData(placeholderData) ? {
        status: 'resolved',
        metadataStatus: undefined,
        details: placeholderData
    } : undefined;
};

});

parcelRegister("1LfMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $14afc9ee5415c625$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $5kJPq = parcelRequire("5kJPq");

var $eAoOt = parcelRequire("eAoOt");

var $6kISs = parcelRequire("6kISs");

var $hFMCA = parcelRequire("hFMCA");

var $2bcMy = parcelRequire("2bcMy");

var $hMPgy = parcelRequire("hMPgy");

var $9HFNL = parcelRequire("9HFNL");
const $14afc9ee5415c625$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child) && (0, $6kISs.isFlexibleUiBlock)(child) ? child : undefined);
};
const $14afc9ee5415c625$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(children).map((child)=>(0, $2bcMy.getFlexibleUiBlock)(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(block)) return block.props;
};
const $14afc9ee5415c625$var$getLayeredLink = (testId, context, children, onClick, onAuxClick, onContextMenu, title, navigation)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    // SSR cannot reliably extract TitleBlock props from children, so `title` is
    // provided from CardSSR as a stable server/client value to prevent hydration
    // text mismatches for the clickable container link.
    const { anchorTarget: target, text: text } = $14afc9ee5415c625$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9HFNL.default), {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        target: (0, $gdUUy.fg)('confluence_ep_shim_macro_links_v2') ? target ?? (navigation === null || navigation === void 0 ? void 0 : navigation.target) : target,
        testId: testId,
        text: title || text || (linkTitle === null || linkTitle === void 0 ? void 0 : linkTitle.text),
        url: (0, $gdUUy.fg)('confluence_ep_shim_macro_links_v2') ? (navigation === null || navigation === void 0 ? void 0 : navigation.url) ?? url : url
    });
};
const $14afc9ee5415c625$var$baseStyleCommon = null;
const $14afc9ee5415c625$var$backgroundStyles = null;
const $14afc9ee5415c625$var$elevationStyles = null;
const $14afc9ee5415c625$var$clickableContainerStyles = null;
const $14afc9ee5415c625$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $14afc9ee5415c625$var$getPadding = (size)=>{
    switch(size){
        case (0, $5kJPq.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5kJPq.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5kJPq.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5kJPq.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $14afc9ee5415c625$var$getGap = (size)=>{
    switch(size){
        case (0, $5kJPq.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5kJPq.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5kJPq.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5kJPq.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $14afc9ee5415c625$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $14afc9ee5415c625$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $14afc9ee5415c625$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5kJPq.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', title: title })=>{
    const padding = hidePadding ? '0px' : $14afc9ee5415c625$var$getPadding(size);
    const gap = $14afc9ee5415c625$var$getGap(size);
    const cardContext = (0, $eAoOt.useFlexibleCardContext)();
    const context = cardContext === null || cardContext === void 0 ? void 0 : cardContext.data;
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = (0, $hFMCA.getChildrenOptions)(children, context);
    const isResolved = status === 'resolved';
    const isUnresolvedWithAuthFlow = status !== 'resolved' && retry !== undefined;
    const hasHoverCardOverride = (hoverPreviewOptions === null || hoverPreviewOptions === void 0 ? void 0 : hoverPreviewOptions.render) !== undefined;
    const canShowHoverCard = showHoverPreview && (isResolved || isUnresolvedWithAuthFlow || hasHoverCardOverride);
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $14afc9ee5415c625$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $14afc9ee5415c625$var$previewOnLeftStyleMap[size],
            previewOnRight && $14afc9ee5415c625$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itia51 _2rkopb1k _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $3zY6O.default)(padding),
            "--_73mooq": (0, $3zY6O.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $3zY6O.default)(previewOnRight ? gap : padding)
        }
    }, clickableContainer ? $14afc9ee5415c625$var$getLayeredLink(testId, context, children, onClick, onAuxClick, onContextMenu, title, cardContext === null || cardContext === void 0 ? void 0 : cardContext.navigation) : null, $14afc9ee5415c625$var$filterChildren(children, removeBlockRestriction));
    if (context !== null && context !== void 0 && context.url && canShowHoverCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hMPgy.default), {
        isHoverPreview: isResolved || hasHoverCardOverride,
        isAuthTooltip: isUnresolvedWithAuthFlow,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions
    }, container);
    return container;
};
var $14afc9ee5415c625$export$2e2bcd8739ae039 = $14afc9ee5415c625$var$Container;

});
parcelRegister("6kISs", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiBlock", () => $492e873e6117f548$export$b56fc89cf6e7d1e9);

var $bSJIT = parcelRequire("bSJIT");

var $aLRXN = parcelRequire("aLRXN");

var $7YS4o = parcelRequire("7YS4o");

var $8dLhi = parcelRequire("8dLhi");

var $iJgrE = parcelRequire("iJgrE");

var $pelji = parcelRequire("pelji");

var $igIuZ = parcelRequire("igIuZ");

var $3Qn1E = parcelRequire("3Qn1E");

var $8WdDM = parcelRequire("8WdDM");

var $iD4XW = parcelRequire("iD4XW");

var $eaAgR = parcelRequire("eaAgR");
const $492e873e6117f548$var$Blocks = {
    ActionBlock: $aLRXN.default,
    AIFooterBlock: $7YS4o.default,
    Block: $8dLhi.default,
    FooterBlock: $iJgrE.default,
    MetadataBlock: $igIuZ.default,
    PreviewBlock: $3Qn1E.default,
    SnippetBlock: $8WdDM.default,
    TitleBlock: $iD4XW.default,
    ResolvedHoverCardFooterBlock: $pelji.default
};
const $492e873e6117f548$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(node)) return false;
    if ((0, $eaAgR.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(node.props.children, (child)=>{
            var _child$type;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) !== 'Style') isChildrenValid = $492e873e6117f548$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($492e873e6117f548$var$Blocks).some((type)=>type === node.type)) return true;
    return false;
};

});
parcelRegister("aLRXN", function(module, exports) {
$parcel$export(module.exports, "default", () => $16ae55555ac4d073$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $3P7qX = parcelRequire("3P7qX");

var $8bEg5 = parcelRequire("8bEg5");

var $6mQ6U = parcelRequire("6mQ6U");

var $kop7u = parcelRequire("kop7u");

var $asa4T = parcelRequire("asa4T");

var $14on2 = parcelRequire("14on2");

var $8bLs2 = parcelRequire("8bLs2");

var $6StZP = parcelRequire("6StZP");

var $8zn38 = parcelRequire("8zn38");

var $4iLYG = parcelRequire("4iLYG");

var $4uDT5 = parcelRequire("4uDT5");

var $kXAHP = parcelRequire("kXAHP");

var $j04u5 = parcelRequire("j04u5");

var $4WobS = parcelRequire("4WobS");

var $h6UCB = parcelRequire("h6UCB");
const $16ae55555ac4d073$var$ignoreContainerPaddingStyles = null;
const $16ae55555ac4d073$var$Actions = {
    [(0, $5kJPq.ActionName).AutomationAction]: (0, $kop7u.default),
    [(0, $5kJPq.ActionName).CopyLinkAction]: (0, $asa4T.default),
    [(0, $5kJPq.ActionName).CustomAction]: (0, $8bEg5.default),
    [(0, $5kJPq.ActionName).DeleteAction]: (0, $8bLs2.default),
    [(0, $5kJPq.ActionName).DownloadAction]: (0, $6StZP.default),
    [(0, $5kJPq.ActionName).EditAction]: (0, $8zn38.default),
    [(0, $5kJPq.ActionName).FollowAction]: (0, $4iLYG.default),
    [(0, $5kJPq.ActionName).PreviewAction]: (0, $4uDT5.default),
    [(0, $5kJPq.ActionName).RovoChatAction]: (0, $kXAHP.default),
    [(0, $5kJPq.InternalActionName).AISummaryAction]: (0, $6mQ6U.default),
    [(0, $5kJPq.InternalActionName).UnresolvedAction]: (0, $14on2.default),
    [(0, $5kJPq.InternalActionName).ViewRelatedLinksAction]: (0, $j04u5.default)
};
const $16ae55555ac4d073$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $16ae55555ac4d073$var$sort = (a, b)=>{
    let idxA = $16ae55555ac4d073$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $16ae55555ac4d073$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $16ae55555ac4d073$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $16ae55555ac4d073$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $16ae55555ac4d073$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const ui = (0, $3P7qX.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $bSJIT.useState)();
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(false);
    const onLoadingChange = (0, $bSJIT.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !(ui !== null && ui !== void 0 && ui.hidePadding) ? (0, $h6UCB.getPrimitivesPaddingSpaceBySize)((ui === null || ui === void 0 ? void 0 : ui.size) || (0, $5kJPq.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $bSJIT.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback === null || onClickCallback === void 0 || onClickCallback(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $bSJIT.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $bSJIT.useMemo)(()=>{
        if (!(context !== null && context !== void 0 && context.actions)) return;
        const arr = Object.keys(context.actions).filter((name)=>name !== (0, $5kJPq.ActionName).RovoChatAction);
        arr.sort($16ae55555ac4d073$var$sort);
        const renderAction = (name)=>{
            const Action = name in $16ae55555ac4d073$var$Actions ? $16ae55555ac4d073$var$Actions[name] : undefined;
            if (!Action) return null;
            return /*#__PURE__*/ $bSJIT.createElement(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || (ui === null || ui === void 0 ? void 0 : ui.size),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: padding ? {
                    paddingInline: padding
                } : undefined,
                hideTooltip: isLoading
            });
        };
        return arr.map((name)=>renderAction(name));
    }, [
        context === null || context === void 0 ? void 0 : context.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui === null || ui === void 0 ? void 0 : ui.size,
        padding,
        isLoading,
        onClick
    ]);
    if (!actions) return null;
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ])
    }, actions, /*#__PURE__*/ $bSJIT.createElement((0, $4WobS.ActionFooter), {
        message: message,
        testId: testId
    }));
};
var $16ae55555ac4d073$export$2e2bcd8739ae039 = $16ae55555ac4d073$var$ActionBlock;

});
parcelRegister("4WobS", function(module, exports) {
$parcel$export(module.exports, "ActionFooter", () => $374d5e54d56bcbd8$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $hkLEY = parcelRequire("hkLEY");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8rz1h = parcelRequire("8rz1h");
const $374d5e54d56bcbd8$var$styles = {
    containerStyles: "_kkk2n7od _2rko12b0 _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8wadc _syazazsu"
};
const $374d5e54d56bcbd8$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                testId: "action-error-icon",
                size: "small"
            });
        default:
            return null;
    }
};
const $374d5e54d56bcbd8$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $374d5e54d56bcbd8$var$styles.containerStyles
    }, /*#__PURE__*/ $bSJIT.createElement((0, $8rz1h.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ $bSJIT.createElement((0, $fZ0ZI.Inline), {
        alignBlock: "start",
        grow: "fill",
        space: "space.075",
        xcss: $374d5e54d56bcbd8$var$styles.errorContentStyles
    }, message.icon || $374d5e54d56bcbd8$var$getIcon(message.appearance), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $374d5e54d56bcbd8$var$styles.titleStyles
    }, message.title))));
};

});
parcelRegister("8rz1h", function(module, exports) {
$parcel$export(module.exports, "default", () => $284aaca7d2f280ab$export$2e2bcd8739ae039);

var $lj2TX = parcelRequire("lj2TX");
var $284aaca7d2f280ab$export$2e2bcd8739ae039 = (0, $lj2TX.MotionWrapper);

});
parcelRegister("lj2TX", function(module, exports) {
$parcel$export(module.exports, "MotionWrapper", () => $bda69598cc0e1d60$export$6118ed0013927eb2);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");
const $bda69598cc0e1d60$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $bSJIT.useState)(0);
    const ref = (0, $bSJIT.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $bSJIT.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};

});



parcelRegister("h6UCB", function(module, exports) {
$parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", () => $546685a47d393549$export$1af10e3728e3a644);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5kJPq = parcelRequire("5kJPq");
const $546685a47d393549$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5kJPq.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5kJPq.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5kJPq.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5kJPq.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};

});


parcelRegister("7YS4o", function(module, exports) {
$parcel$export(module.exports, "default", () => $65b6b0892784fb34$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $eAoOt = parcelRequire("eAoOt");

var $6YrND = parcelRequire("6YrND");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $65b6b0892784fb34$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    var _cardContext$ui;
    const cardContext = (0, $eAoOt.useFlexibleCardContext)();
    if ((cardContext === null || cardContext === void 0 ? void 0 : cardContext.status) !== (0, $5kJPq.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6YrND.default), {
        ...props,
        size: props.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size),
        testId: testId
    });
};
var $65b6b0892784fb34$export$2e2bcd8739ae039 = $65b6b0892784fb34$var$AIFooterBlock;

});
parcelRegister("6YrND", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9b6dd495667fdde$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $beIZm = parcelRequire("beIZm");

var $8dLhi = parcelRequire("8dLhi");

var $7C2Ec = parcelRequire("7C2Ec");
const $e9b6dd495667fdde$var$AIFooterBlockResolvedView = (props)=>{
    var _context$actions;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8dLhi.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $beIZm.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7C2Ec.AIFooterMetadata), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $e9b6dd495667fdde$export$2e2bcd8739ae039 = $e9b6dd495667fdde$var$AIFooterBlockResolvedView;

});
parcelRegister("7C2Ec", function(module, exports) {
$parcel$export(module.exports, "AIFooterMetadata", () => $d4e498faed3120e2$export$175228cc2c92b3b6);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $74KHX = parcelRequire("74KHX");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $lavtv = parcelRequire("lavtv");

var $7wYyA = parcelRequire("7wYyA");

var $jsMV5 = parcelRequire("jsMV5");

var $74buR = parcelRequire("74buR");
const $d4e498faed3120e2$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    const { state: { status: status } } = (0, $jsMV5.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $74buR.InfoIcon), {
            label: "Information",
            color: "var(--ds-icon-subtle, #505258)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($74KHX))), {
        label: "AI",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};

});
parcelRegister("74buR", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", () => $a0c161589ef97d2e$export$2957fc44b3d2481);

var $bSJIT = parcelRequire("bSJIT");

var $68E0O = parcelRequire("68E0O");
const $a0c161589ef97d2e$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($68E0O))), {
        color: props.color || 'currentColor',
        ...props
    });

});




parcelRegister("iJgrE", function(module, exports) {
$parcel$export(module.exports, "default", () => $34302a455d1bcfd0$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $gMURw = parcelRequire("gMURw");
var $34302a455d1bcfd0$export$2e2bcd8739ae039 = (0, $gMURw.FooterBlock);

});
parcelRegister("gMURw", function(module, exports) {
$parcel$export(module.exports, "FooterBlock", () => $2228000358ea30ae$export$f83744e65a5b0c8f);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $eAoOt = parcelRequire("eAoOt");

var $fdcVg = parcelRequire("fdcVg");
const $2228000358ea30ae$export$f83744e65a5b0c8f = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    var _cardContext$ui;
    const cardContext = (0, $eAoOt.useFlexibleCardContext)();
    if ((cardContext === null || cardContext === void 0 ? void 0 : cardContext.status) !== (0, $5kJPq.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fdcVg.default), {
        ...props,
        size: props.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size),
        testId: testId
    });
};

});
parcelRegister("fdcVg", function(module, exports) {
$parcel$export(module.exports, "default", () => $90a7dd14acf703ed$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $faVqX = parcelRequire("faVqX");

var $8Mb7N = parcelRequire("8Mb7N");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $beIZm = parcelRequire("beIZm");

var $goesr = parcelRequire("goesr");

var $8dLhi = parcelRequire("8dLhi");

var $94O41 = parcelRequire("94O41");

var $jSDhC = parcelRequire("jSDhC");
const $90a7dd14acf703ed$var$actionGroupStyles = null;
const $90a7dd14acf703ed$var$safariStyles = null;
const $90a7dd14acf703ed$var$providerStyles = null;
const $90a7dd14acf703ed$var$rovoActionStyles = null;
const $90a7dd14acf703ed$var$FooterBlockResolvedView = (props)=>{
    var _context$actions;
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5kJPq.SmartLinkSize).Medium, hideProvider: hideProvider, isPreviewBlockErrored: isPreviewBlockErrored } = props;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const rovoChatAction = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.ActionName).RovoChatAction];
    const isRovoActionsEnabled = (0, $bSJIT.useMemo)(()=>{
        return !!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' && (actions === null || actions === void 0 ? void 0 : actions.some((action)=>action.name === 'RovoChatAction'));
    }, [
        rovoChatAction,
        actions
    ]);
    const hasPreview = isRovoActionsEnabled && !!(context !== null && context !== void 0 && context.preview) && !isPreviewBlockErrored;
    const hasActions = (0, $bSJIT.useMemo)(()=>{
        var _filterActionItems;
        return ((_filterActionItems = (0, $jSDhC.filterActionItems)(actions, context)) === null || _filterActionItems === void 0 ? void 0 : _filterActionItems.length) > 0;
    }, [
        actions,
        context
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $bSJIT.useMemo)(()=>(0, $faVqX.browser)(), []);
    const onDropdownOpenChange = (0, $bSJIT.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    // WidthObserver fires whenever the footer's available width changes.
    const [containerWidth, setContainerWidth] = (0, $bSJIT.useState)(undefined);
    return /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ $bSJIT.createElement((0, $beIZm.default), {
        appearance: "subtle",
        testId: `${testId}-provider`,
        hideLabel: hasPreview,
        className: (0, $9fU1q.default)([
            isRovoActionsEnabled && "_1wpz1h6o"
        ])
    }), actions && hasActions ? /*#__PURE__*/ $bSJIT.createElement((0, $94O41.default), {
        testId: "smart-element-group-actions",
        align: (0, $5kJPq.SmartLinkAlignment).Right,
        direction: (0, $5kJPq.SmartLinkDirection).Horizontal,
        width: (0, $5kJPq.SmartLinkWidth).Flexible,
        className: (0, $9fU1q.default)([
            size === (0, $5kJPq.SmartLinkSize).XLarge && "_c71lxy5q",
            safari && "_4t3i1osq",
            isRovoActionsEnabled && "_kqswh2mm"
        ])
    }, !!rovoChatAction && (rovoChatAction === null || rovoChatAction === void 0 ? void 0 : rovoChatAction.product) === 'CONFLUENCE' && /*#__PURE__*/ $bSJIT.createElement((0, $8Mb7N.WidthObserver), {
        setWidth: setContainerWidth,
        offscreen: true
    }), /*#__PURE__*/ $bSJIT.createElement((0, $goesr.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: isRovoActionsEnabled ? 'subtle' : 'default',
        size: isRovoActionsEnabled ? (0, $5kJPq.SmartLinkSize).Small : size,
        containerWidth: isRovoActionsEnabled ? containerWidth : undefined
    })) : null);
};
var $90a7dd14acf703ed$export$2e2bcd8739ae039 = $90a7dd14acf703ed$var$FooterBlockResolvedView;

});



parcelRegister("pelji", function(module, exports) {
$parcel$export(module.exports, "default", () => $86e096ecd9b945f3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5kJPq = parcelRequire("5kJPq");

var $eAoOt = parcelRequire("eAoOt");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $6mQ6U = parcelRequire("6mQ6U");

var $kop7u = parcelRequire("kop7u");

var $asa4T = parcelRequire("asa4T");

var $14on2 = parcelRequire("14on2");

var $6StZP = parcelRequire("6StZP");

var $4iLYG = parcelRequire("4iLYG");

var $4uDT5 = parcelRequire("4uDT5");

var $kXAHP = parcelRequire("kXAHP");

var $j04u5 = parcelRequire("j04u5");

var $beIZm = parcelRequire("beIZm");

var $8dLhi = parcelRequire("8dLhi");
/**
 * Allowed footer actions for HoverCard, in display order. Fetched from context.
 */ const $86e096ecd9b945f3$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS = [
    (0, $5kJPq.ActionName).RovoChatAction
];
const $86e096ecd9b945f3$var$Actions = {
    [(0, $5kJPq.ActionName).AutomationAction]: (0, $kop7u.default),
    [(0, $5kJPq.ActionName).CopyLinkAction]: (0, $asa4T.default),
    [(0, $5kJPq.ActionName).DownloadAction]: (0, $6StZP.default),
    [(0, $5kJPq.ActionName).FollowAction]: (0, $4iLYG.default),
    [(0, $5kJPq.ActionName).PreviewAction]: (0, $4uDT5.default),
    [(0, $5kJPq.ActionName).RovoChatAction]: (0, $kXAHP.default),
    [(0, $5kJPq.InternalActionName).AISummaryAction]: (0, $6mQ6U.default),
    [(0, $5kJPq.InternalActionName).UnresolvedAction]: (0, $14on2.default),
    [(0, $5kJPq.InternalActionName).ViewRelatedLinksAction]: (0, $j04u5.default)
};
const $86e096ecd9b945f3$var$ignoreContainerMarginStyles = null;
const $86e096ecd9b945f3$var$elevatedFooterStyles = null;
const $86e096ecd9b945f3$var$providerStyles = null;
const $86e096ecd9b945f3$var$actionsStyles = null;
/**
 * Footer block for HoverCard resolved view: Provider on the left, ActionGroup (up to 4 actions) on the right.
 * @internal
 * @param {ResolvedHoverCardFooterBlockProps} ResolvedHoverCardFooterBlockProps
 * @see Block
 */ const $86e096ecd9b945f3$var$ResolvedHoverCardFooterBlock = ({ testId: testId = 'smart-hover-card-footer-block', onActionClick: onActionClick, hideProvider: hideProvider, ...props })=>{
    var _cardContext$ui;
    const cardContext = (0, $eAoOt.useFlexibleCardContext)();
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const size = props.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size);
    const actions = (0, $bSJIT.useMemo)(()=>{
        if (!(context !== null && context !== void 0 && context.actions)) return [];
        let arr = Object.keys(context.actions);
        arr = arr.filter((name)=>!$86e096ecd9b945f3$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS.includes(name));
        return arr.map((name)=>{
            const Action = name in $86e096ecd9b945f3$var$Actions ? $86e096ecd9b945f3$var$Actions[name] : undefined;
            // Note: For the spinner to render properly, e.g. AI summary action,
            // the spinner need to be updated. See FIX-ME comment on ActionButton
            return Action ? /*#__PURE__*/ $bSJIT.createElement(Action, {
                key: name,
                as: "stack-item",
                content: "",
                onClick: ()=>onActionClick === null || onActionClick === void 0 ? void 0 : onActionClick(name),
                size: size,
                iconSize: 'small'
            }) : null;
        });
    }, [
        context === null || context === void 0 ? void 0 : context.actions,
        onActionClick,
        size
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        ...props,
        size: size,
        testId: `${testId}-resolved-view`,
        className: (0, $9fU1q.default)([
            "_18zrpxbi _1rjcutpp _vchhusvi _1bsb129b _18u01ivi _2hwxc10g _otyr1ya9 _4t3ioahv",
            "_zulpu2gc _x3doj0fz _bfhkhfxm _mrkb1mok _1o0z1mok"
        ])
    }, !hideProvider && /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_4t3i1ejb _1e0c1txw _4cvr1h6o _1bah1y6m _vchhusvi _16jlkb7n"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $beIZm.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    })), actions.length > 0 ? /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": `${testId}-actions`,
        className: (0, $9fU1q.default)([
            "_zulpidpf _1e0c1txw _18u01wug _4cvr1h6o _vchhusvi _7386ze3t _1xdd12b0 _17zize3t _19p4ze3t _6zimze3t _f9lhze3t _rvy9ze3t _ue4dze3t _zgrbze3t _10cuze3t _6syfze3t _3hv7ze3t"
        ])
    }, actions) : null);
};
var $86e096ecd9b945f3$export$2e2bcd8739ae039 = $86e096ecd9b945f3$var$ResolvedHoverCardFooterBlock;

});

parcelRegister("igIuZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $074dd6a0b0f7c4d0$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $kvV43 = parcelRequire("kvV43");
var $074dd6a0b0f7c4d0$export$2e2bcd8739ae039 = (0, $kvV43.MetadataBlock);

});
parcelRegister("kvV43", function(module, exports) {
$parcel$export(module.exports, "MetadataBlock", () => $65725a9355a15a4b$export$2e4ce4ce734f69e1);
/* MetadataBlock.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5kJPq = parcelRequire("5kJPq");

var $eAoOt = parcelRequire("eAoOt");

var $8dLhi = parcelRequire("8dLhi");

var $94O41 = parcelRequire("94O41");

var $TSDzJ = parcelRequire("TSDzJ");

var $bBN3d = parcelRequire("bBN3d");
const $65725a9355a15a4b$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $65725a9355a15a4b$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $65725a9355a15a4b$var$getMaxLines = (maxLines)=>{
    if (maxLines > (0, $bBN3d.METADATA_BLOCK_CONSTANTS).MAXIMUM_MAX_LINES) return (0, $bBN3d.METADATA_BLOCK_CONSTANTS).DEFAULT_MAX_LINES;
    if (maxLines < (0, $bBN3d.METADATA_BLOCK_CONSTANTS).MINIMUM_MAX_LINES) return (0, $bBN3d.METADATA_BLOCK_CONSTANTS).MINIMUM_MAX_LINES;
    return maxLines;
};
const $65725a9355a15a4b$var$ElementItemRenderer = ({ align: align = (0, $5kJPq.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5kJPq.SmartLinkSize).Medium, maxLines: maxLines = (0, $bBN3d.METADATA_BLOCK_CONSTANTS).DEFAULT_MAX_LINES })=>{
    const elements = (0, $TSDzJ.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ $bSJIT.createElement((0, $94O41.default), {
        align: align,
        direction: (0, $5kJPq.SmartLinkDirection).Horizontal,
        width: (0, $5kJPq.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $9fU1q.default)([
            $65725a9355a15a4b$var$truncateStyles[maxLines],
            $65725a9355a15a4b$var$sizeStyles[size]
        ])
    }, elements);
};
const $65725a9355a15a4b$export$2e4ce4ce734f69e1 = ({ maxLines: maxLines = (0, $bBN3d.METADATA_BLOCK_CONSTANTS).DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    var _cardContext$ui;
    const cardContext = (0, $eAoOt.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || (cardContext === null || cardContext === void 0 ? void 0 : cardContext.status) !== (0, $5kJPq.SmartLinkStatus).Resolved) return null;
    const size = (blockProps === null || blockProps === void 0 ? void 0 : blockProps.size) ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size) ?? (0, $5kJPq.SmartLinkSize).Medium;
    const maxLinesTotal = $65725a9355a15a4b$var$getMaxLines(maxLines);
    return /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ $bSJIT.createElement($65725a9355a15a4b$var$ElementItemRenderer, {
        items: primary,
        size: size,
        maxLines: maxLinesTotal
    }), /*#__PURE__*/ $bSJIT.createElement($65725a9355a15a4b$var$ElementItemRenderer, {
        align: (0, $5kJPq.SmartLinkAlignment).Right,
        items: secondary,
        size: size,
        maxLines: maxLinesTotal
    }));
};

});
parcelRegister("bBN3d", function(module, exports) {
$parcel$export(module.exports, "METADATA_BLOCK_CONSTANTS", () => $59ed01c8113614f3$export$13bf823ad4713393);
const $59ed01c8113614f3$export$13bf823ad4713393 = {
    DEFAULT_MAX_LINES: 2,
    MAXIMUM_MAX_LINES: 2,
    MINIMUM_MAX_LINES: 1
};

});



parcelRegister("3Qn1E", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fca9d80107b831d$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $IAfjf = parcelRequire("IAfjf");
var $2fca9d80107b831d$export$2e2bcd8739ae039 = (0, $IAfjf.PreviewBlock);

});
parcelRegister("IAfjf", function(module, exports) {
$parcel$export(module.exports, "PreviewBlock", () => $343b3736a00b7454$export$fff1c9c894fd3e9c);

var $bSJIT = parcelRequire("bSJIT");

var $3P7qX = parcelRequire("3P7qX");

var $3UHfS = parcelRequire("3UHfS");
const $343b3736a00b7454$export$fff1c9c894fd3e9c = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $3P7qX.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3UHfS.default), {
        ...blockProps,
        size: blockProps.size ?? (ui === null || ui === void 0 ? void 0 : ui.size),
        testId: testId,
        overrideUrl: overrideUrl
    });
};

});
parcelRegister("3UHfS", function(module, exports) {
$parcel$export(module.exports, "default", () => $c77fe14faba1393f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5kJPq = parcelRequire("5kJPq");

var $f3OWg = parcelRequire("f3OWg");

var $8dLhi = parcelRequire("8dLhi");
const $c77fe14faba1393f$var$previewBlockStyleCommon = null;
const $c77fe14faba1393f$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $c77fe14faba1393f$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $bSJIT.useState)(style ?? {});
    const updateStyles = (0, $bSJIT.useCallback)(()=>{
        if (placement === (0, $5kJPq.MediaPlacement).Left || placement === (0, $5kJPq.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5kJPq.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5kJPq.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    // Should be useLayoutEffect to avoid flicker.
    // Styles should be set before paint.
    (0, $bSJIT.useLayoutEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $bSJIT.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $bSJIT.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $f3OWg.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $c77fe14faba1393f$export$2e2bcd8739ae039 = $c77fe14faba1393f$var$PreviewBlockResolvedView;

});



parcelRegister("8WdDM", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbcb4bc276d9406c$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $d8yyo = parcelRequire("d8yyo");
var $bbcb4bc276d9406c$export$2e2bcd8739ae039 = (0, $d8yyo.SnippetBlock);

});
parcelRegister("d8yyo", function(module, exports) {
$parcel$export(module.exports, "SnippetBlock", () => $4730324cdbfb962a$export$ababd1478ac17bc0);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $eAoOt = parcelRequire("eAoOt");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $3P7qX = parcelRequire("3P7qX");

var $4zQGY = parcelRequire("4zQGY");

var $3DaZe = parcelRequire("3DaZe");

var $92HbE = parcelRequire("92HbE");

var $8dLhi = parcelRequire("8dLhi");

var $18QYF = parcelRequire("18QYF");
const $4730324cdbfb962a$export$ababd1478ac17bc0 = ({ maxLines: maxLines = (0, $18QYF.SNIPPET_BLOCK_CONSTANTS).DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    var _useFlexibleUiOptionC, _cardContext$ui2, _context$meta, _context$meta2, _context$meta3;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const renderers = (0, $4zQGY.useSmartLinkRenderers)();
    const enableSnippetRenderer = (_useFlexibleUiOptionC = (0, $3P7qX.useFlexibleUiOptionContext)()) === null || _useFlexibleUiOptionC === void 0 ? void 0 : _useFlexibleUiOptionC.enableSnippetRenderer;
    const cardContext = (0, $eAoOt.useFlexibleCardContext)();
    if ((cardContext === null || cardContext === void 0 ? void 0 : cardContext.status) !== (0, $5kJPq.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $92HbE.getMaxLines)(maxLines, (0, $18QYF.SNIPPET_BLOCK_CONSTANTS).DEFAULT_MAX_LINES, (0, $18QYF.SNIPPET_BLOCK_CONSTANTS).MAXIMUM_MAX_LINES, (0, $18QYF.SNIPPET_BLOCK_CONSTANTS).MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3DaZe.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!enableSnippetRenderer) {
        var _cardContext$ui;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8dLhi.default), {
            ...blockProps,
            size: blockProps.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size),
            testId: `${testId}-${statusTestId}-view`
        }, snippet);
    }
    const SnippetReplacement = renderers === null || renderers === void 0 ? void 0 : renderers.snippet;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8dLhi.default), {
        ...blockProps,
        size: blockProps.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui2 = cardContext.ui) === null || _cardContext$ui2 === void 0 ? void 0 : _cardContext$ui2.size),
        testId: `${testId}-${statusTestId}-view`
    }, SnippetReplacement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(SnippetReplacement, {
        fallbackText: (text || (context === null || context === void 0 ? void 0 : context.snippet)) ?? '',
        fallbackComponent: snippet,
        contentId: (context === null || context === void 0 || (_context$meta = context.meta) === null || _context$meta === void 0 ? void 0 : _context$meta.objectId) ?? '',
        contentType: (context === null || context === void 0 || (_context$meta2 = context.meta) === null || _context$meta2 === void 0 ? void 0 : _context$meta2.resourceType) ?? '',
        cloudId: (context === null || context === void 0 || (_context$meta3 = context.meta) === null || _context$meta3 === void 0 ? void 0 : _context$meta3.tenantId) ?? '',
        maxLines: snippetMaxLines,
        isHidden: isHidden,
        showFooter: showFooter
    }) : snippet);
};

});
parcelRegister("92HbE", function(module, exports) {
$parcel$export(module.exports, "getMaxLines", () => $b64ff10ddc245825$export$c2293adf1794c09);
const $b64ff10ddc245825$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};

});

parcelRegister("18QYF", function(module, exports) {
$parcel$export(module.exports, "SNIPPET_BLOCK_CONSTANTS", () => $092bc9300801a524$export$ca3749285a470843);
const $092bc9300801a524$export$ca3749285a470843 = {
    DEFAULT_MAX_LINES: 3,
    MAXIMUM_MAX_LINES: 6,
    MINIMUM_MAX_LINES: 1
};

});




parcelRegister("hFMCA", function(module, exports) {
$parcel$export(module.exports, "getChildrenOptions", () => $021b3a80a1961742$export$6f4e0540a2f2295a);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $8uL6v = parcelRequire("8uL6v");

var $itYgK = parcelRequire("itYgK");
const $021b3a80a1961742$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $8uL6v.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child)) {
            if ((0, $itYgK.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5kJPq.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5kJPq.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};

});
parcelRegister("8uL6v", function(module, exports) {
$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $abae58b24cef5d71$export$783c1bf8fee63f80);
const $abae58b24cef5d71$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("itYgK", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $318777e09833f8ab$export$c0547b4405cae584);

var $bSJIT = parcelRequire("bSJIT");

var $3Qn1E = parcelRequire("3Qn1E");

var $eaAgR = parcelRequire("eaAgR");
const $318777e09833f8ab$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(node)) return false;
    if (node.type === (0, $3Qn1E.default)) return true;
    if ((0, $eaAgR.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(node.props.children, (child)=>{
            var _child$type;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) !== 'Style') isChildrenValid = $318777e09833f8ab$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};

});


parcelRegister("2bcMy", function(module, exports) {
$parcel$export(module.exports, "getFlexibleUiBlock", () => $be88ec257963828b$export$f6c7a950371733c8);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $eaAgR = parcelRequire("eaAgR");

var $iD4XW = parcelRequire("iD4XW");
const $be88ec257963828b$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(node)) return undefined;
    if (node.type === (0, $iD4XW.default)) return node;
    if ((0, $eaAgR.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(node.props.children, (child)=>{
            var _child$type;
            if (typeof child.type !== 'string' && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) !== 'Style') isChildrenValid = $be88ec257963828b$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};

});

parcelRegister("hMPgy", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2a784e9f2dbf807$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $bSOi4 = parcelRequire("bSOi4");

var $10h0y = parcelRequire("10h0y");
const $d2a784e9f2dbf807$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $d2a784e9f2dbf807$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $d2a784e9f2dbf807$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $bSJIT.useState)(true);
    const mouseStopTimer = (0, $bSJIT.useRef)();
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $bSJIT.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $bSJIT.useCallback)((e)=>{
        var _e$target$closest;
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || ((_e$target$closest = e.target.closest('[data-smart-link-container]')) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.querySelector('[data-action-open="true"]'));
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5kJPq.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $10h0y.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        onBlur: (0, $bSOi4.noop),
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        "data-testid": `${testId}-hover-card-wrapper`,
        role: 'presentation'
    }, children));
};
var $d2a784e9f2dbf807$export$2e2bcd8739ae039 = $d2a784e9f2dbf807$var$HoverCardControl;

});
parcelRegister("bSOi4", function(module, exports) {
$parcel$export(module.exports, "noop", () => $6edf77b37e06020b$export$8793edee2d425525);
const $6edf77b37e06020b$export$8793edee2d425525 = ()=>undefined;

});

parcelRegister("10h0y", function(module, exports) {
$parcel$export(module.exports, "HoverCard", () => $4b6d101a6f839f1f$export$57a077cc9fbe653e);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $kIbto = parcelRequire("kIbto");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $iq8lm = parcelRequire("iq8lm");

var $jERMp = parcelRequire("jERMp");

var $iTFEF = parcelRequire("iTFEF");

var $LOjqb = parcelRequire("LOjqb");

var $6AkYi = parcelRequire("6AkYi");
const $4b6d101a6f839f1f$var$HoverCardWithErrorBoundary = (props)=>{
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $LOjqb.useSmartLinkAnalyticsContext)({
        display: (0, $5kJPq.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $6AkYi.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $bSJIT.useCallback)((error, info)=>{
        (0, $jERMp.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $iq8lm.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $iq8lm.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.attributes,
            display: (0, $5kJPq.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
        fallback: children,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iTFEF.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6AkYi.HoverCardComponent), props, children)));
};
const $4b6d101a6f839f1f$var$HoverCardWithoutAnalyticsContext = (0, $kIbto.default)()($4b6d101a6f839f1f$var$HoverCardWithErrorBoundary);
const $4b6d101a6f839f1f$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4b6d101a6f839f1f$var$HoverCardWithoutAnalyticsContext, props);
};

});
parcelRegister("6AkYi", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $e5c34a332732af19$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $e5c34a332732af19$export$e2173dafa6a751bb);

var $bSJIT = parcelRequire("bSJIT");

var $3zzvD = parcelRequire("3zzvD");

var $gdUUy = parcelRequire("gdUUy");

var $26Jy2 = parcelRequire("26Jy2");

var $5kJPq = parcelRequire("5kJPq");

var $2JDIg = parcelRequire("2JDIg");

var $dQMDw = parcelRequire("dQMDw");

var $4zQGY = parcelRequire("4zQGY");

var $2TtjQ = parcelRequire("2TtjQ");

var $jnYkh = parcelRequire("jnYkh");

var $bSOi4 = parcelRequire("bSOi4");

var $iopDi = parcelRequire("iopDi");

var $loBKq = parcelRequire("loBKq");

var $9nMlY = parcelRequire("9nMlY");
const $e5c34a332732af19$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $e5c34a332732af19$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $e5c34a332732af19$var$FADE_IN_DELAY = 500;
const $e5c34a332732af19$var$FADE_OUT_DELAY = 300;
const $e5c34a332732af19$var$RESOLVE_DELAY = 100;
const $e5c34a332732af19$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $loBKq.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, placement: placement, role: role, shouldRenderToParent: shouldRenderToParent = false, label: label, titleId: titleId, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = (hoverPreviewOptions === null || hoverPreviewOptions === void 0 ? void 0 : hoverPreviewOptions.fadeInDelay) ?? $e5c34a332732af19$var$FADE_IN_DELAY;
    const gatedPlacement = placement && (0, $3zzvD.UNSAFE_expValNoExposure)('confluence_1p_and_3p_connection_byline_experiment', 'isEnabled', false) ? placement : undefined;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const fadeOutTimeoutId = (0, $bSJIT.useRef)();
    const fadeInTimeoutId = (0, $bSJIT.useRef)();
    const resolveTimeOutId = (0, $bSJIT.useRef)();
    const mousePos = (0, $bSJIT.useRef)();
    const popupOffset = (0, $bSJIT.useRef)();
    const parentSpan = (0, $bSJIT.useRef)(null);
    const renderers = (0, $4zQGY.useSmartLinkRenderers)();
    const linkState = (0, $2TtjQ.useSmartCardState)(url);
    const handleSetIsOpen = (0, $bSJIT.useCallback)((isOpen)=>{
        setIsOpen(isOpen);
        onVisibilityChange === null || onVisibilityChange === void 0 || onVisibilityChange(isOpen);
    }, [
        onVisibilityChange
    ]);
    const { loadMetadata: loadMetadata, register: register } = (0, $2JDIg.useSmartCardActions)(id, url);
    const setMousePosition = (0, $bSJIT.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        // A caller-chosen placement anchors the card to the trigger, so a cursor-relative offset
        // would drag it back over the element the placement was picked to keep clear of.
        if (gatedPlacement) return;
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $loBKq.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $loBKq.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen,
        gatedPlacement
    ]);
    const hideCard = (0, $bSJIT.useCallback)(()=>{
        if (handleSetIsOpen) handleSetIsOpen(false);
        else setIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $bSJIT.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $e5c34a332732af19$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $bSJIT.useEffect)(()=>()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $bSJIT.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus || linkState.status === 'resolved' && linkState.metadataStatus === 'pending' && (0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization');
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            if (linkState.status === 'pending') // Link hasn't been registered yet. Register and resolve link.
            register();
            else // Link has been already been partially resolved. Load metadata.
            loadMetadata();
        }, $e5c34a332732af19$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata,
        register
    ]);
    const initShowCard = (0, $bSJIT.useCallback)((event)=>{
        // Popup events bubble through the enclosing Smart Link, including portals.
        // A second top-layer popup can light-dismiss the spotlight before its click runs.
        if ((0, $gdUUy.fg)('platform_sl_one_click_chat_spotlight_v2_fg') && (0, $dQMDw.isSpotlightActive)()) {
            initHideCard();
            hideCard();
            return;
        }
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) {
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            } else fadeInTimeoutId.current = setTimeout(()=>{
                // The spotlight may mount while this hover delay is pending.
                if ((0, $gdUUy.fg)('platform_sl_one_click_chat_spotlight_v2_fg') && (0, $dQMDw.isSpotlightActive)()) {
                    fadeInTimeoutId.current = undefined;
                    return;
                }
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen,
        initHideCard,
        hideCard
    ]);
    const onActionClick = (0, $bSJIT.useCallback)((actionId)=>{
        if (actionId === (0, $5kJPq.ActionName).PreviewAction || actionId === (0, $5kJPq.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $bSJIT.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $bSJIT.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $bSJIT.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $bSJIT.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onDismiss: hideCard,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id,
            hoverPreviewOptions: hoverPreviewOptions
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnYkh.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5kJPq.CardDisplay).HoverCardPreview,
            id: id,
            source: $e5c34a332732af19$export$421dbc3834daf261
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iopDi.default), hoverCardContentProps));
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        hideCard,
        renderers,
        actionOptions,
        url,
        id,
        hoverPreviewOptions
    ]);
    const handleKeyDown = (0, $bSJIT.useCallback)((e)=>{
        if (e.key === ' ') {
            e.preventDefault();
            initShowCard(e);
        }
    }, [
        initShowCard
    ]);
    const trigger = (0, $bSJIT.useCallback)(({ 'aria-haspopup': _ariaHasPopup, 'aria-expanded': _ariaExpanded, // `aria-controls` is also stripped because the trigger wrapper renders
    // with `role="none"`. axe's `aria-valid-attr-value` rule flags any
    // `aria-controls` value sitting on a presentational element, since the
    // element has no semantic role to control. Removing the attribute
    // keeps the trigger semantically inert without losing functionality.
    'aria-controls': _ariaControls, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
            ref: parentSpan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
            ...triggerProps,
            onMouseOver: initShowCard,
            onMouseLeave: initHideCard,
            onMouseMove: setMousePosition,
            onKeyDown: handleKeyDown,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            "data-testid": $e5c34a332732af19$var$HOVER_CARD_TRIGGER_WRAPPER,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: $e5c34a332732af19$var$HOVER_CARD_TRIGGER_WRAPPER,
            onFocus: (0, $bSOi4.noop),
            onBlur: (0, $bSOi4.noop),
            role: "none"
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition,
        handleKeyDown
    ]);
    const popupComponent = (0, $bSJIT.useMemo)(// Within the Popup component, if shouldRenderToParent, the zIndex prop is ignored
    // as it is assumed that the custom popup container has the desired styles
    ()=>(0, $9nMlY.createCustomPopupContainer)(shouldRenderToParent ? zIndex : undefined), [
        zIndex,
        shouldRenderToParent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: initHideCard,
        placement: gatedPlacement ?? 'bottom-start',
        // A trigger-anchored card keeps the same gap the cursor-anchored one leaves.
        offset: gatedPlacement ? [
            0,
            (0, $loBKq.CARD_GAP_PX)
        ] : popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        shouldRenderToParent: shouldRenderToParent,
        popupComponent: popupComponent
    });
};

});
parcelRegister("dQMDw", function(module, exports) {
$parcel$export(module.exports, "getSuppressionStore", () => $3f43189f4b85be41$export$b7f6300f47ea9879);
$parcel$export(module.exports, "claimSpotlight", () => $3f43189f4b85be41$export$3d9b03f5435b5d3b);
$parcel$export(module.exports, "releaseSpotlight", () => $3f43189f4b85be41$export$3c330b89b4731e96);
$parcel$export(module.exports, "isSpotlightActive", () => $3f43189f4b85be41$export$e96d0e85290a3727);

var $kloza = parcelRequire("kloza");

var $yK53u = parcelRequire("yK53u");
/** Shared across inline cards and accounts on this browser origin. */ let $3f43189f4b85be41$var$store;
let $3f43189f4b85be41$var$activeSpotlight;
const $3f43189f4b85be41$var$isHistory = (value)=>{
    if (typeof value !== 'object' || value === null || !('impressions' in value)) return false;
    return Array.isArray(value.impressions) && value.impressions.every((timestamp)=>typeof timestamp === 'number' && Number.isFinite(timestamp)) && (!('dismissedAt' in value) || value.dismissedAt === undefined || typeof value.dismissedAt === 'number' && Number.isFinite(value.dismissedAt));
};
function $3f43189f4b85be41$export$ef36f29e38816de4(storage, isAvailable = ()=>true) {
    let blocked = false;
    const read = ()=>{
        try {
            const value = storage.getItem('history');
            if (blocked || !isAvailable()) return undefined;
            return value === undefined ? {
                impressions: []
            } : $3f43189f4b85be41$var$isHistory(value) ? value : undefined;
        } catch  {
            return undefined;
        }
    };
    const write = (history)=>{
        try {
            storage.setItemWithExpiry('history', history, (0, $yK53u.SEVEN_DAYS_MS));
            // StorageClient can swallow write failures. Verify persistence before counting delivery.
            const persisted = isAvailable() && JSON.stringify(storage.getItem('history')) === JSON.stringify(history);
            blocked = !persisted;
            return persisted;
        } catch  {
            blocked = true;
            return false;
        }
    };
    return {
        read: read,
        impress: (now)=>{
            const history = read();
            return !!history && write({
                ...history,
                impressions: [
                    ...history.impressions.filter((timestamp)=>timestamp > now - (0, $yK53u.SEVEN_DAYS_MS)),
                    now
                ]
            });
        },
        dismiss: (now)=>{
            const history = read();
            return !!history && write({
                ...history,
                dismissedAt: now
            });
        }
    };
}
function $3f43189f4b85be41$export$b7f6300f47ea9879() {
    if (typeof window === 'undefined') return undefined;
    if (!$3f43189f4b85be41$var$store) try {
        let available = true;
        const storage = new (0, $kloza.StorageClient)('one-click-chat-spotlight-v2', {
            handlers: {
                captureException: ()=>{
                    available = false;
                }
            }
        });
        $3f43189f4b85be41$var$store = $3f43189f4b85be41$export$ef36f29e38816de4(storage, ()=>available);
    } catch  {
        return undefined;
    }
    return $3f43189f4b85be41$var$store;
}
function $3f43189f4b85be41$export$3d9b03f5435b5d3b(owner) {
    if ($3f43189f4b85be41$var$activeSpotlight && $3f43189f4b85be41$var$activeSpotlight !== owner) return false;
    $3f43189f4b85be41$var$activeSpotlight = owner;
    return true;
}
function $3f43189f4b85be41$export$3c330b89b4731e96(owner) {
    if ($3f43189f4b85be41$var$activeSpotlight === owner) $3f43189f4b85be41$var$activeSpotlight = undefined;
}
function $3f43189f4b85be41$export$e96d0e85290a3727(owner) {
    return $3f43189f4b85be41$var$activeSpotlight !== undefined && $3f43189f4b85be41$var$activeSpotlight !== owner;
}

});
parcelRegister("yK53u", function(module, exports) {
$parcel$export(module.exports, "SEVEN_DAYS_MS", () => $ffb63afa32d24b72$export$2e4bc55597d730e0);
$parcel$export(module.exports, "evaluateOpportunity", () => $ffb63afa32d24b72$export$c93023cad6a196ea);
$parcel$export(module.exports, "evaluateExperiment", () => $ffb63afa32d24b72$export$8ac194ac22681b4f);
/** No link, content, or account identifiers belong in eligibility diagnostics. */ const $ffb63afa32d24b72$export$2e4bc55597d730e0 = 604800000;
const $ffb63afa32d24b72$var$result = (reason)=>({
        isEligible: reason === 'eligible',
        reason: reason
    });
function $ffb63afa32d24b72$export$c93023cad6a196ea(input) {
    if (!input.gateEnabled) return $ffb63afa32d24b72$var$result('gate_off');
    if (input.appearance !== 'inline' || input.status !== 'resolved') return $ffb63afa32d24b72$var$result('not_resolved_inline');
    if (input.provider !== 'google-object-provider' && input.provider !== 'github-object-provider') return $ffb63afa32d24b72$var$result('unsupported_provider');
    if (!input.authorized) return $ffb63afa32d24b72$var$result('provider_unauthorized');
    if (!input.hasAccess) return $ffb63afa32d24b72$var$result('object_inaccessible');
    if (!input.rovoAvailable) return $ffb63afa32d24b72$var$result('rovo_unavailable');
    if (!input.consumerOptedIn) return $ffb63afa32d24b72$var$result('consumer_not_opted_in');
    if (input.product !== 'jira_web' && input.product !== 'confluence_web') return $ffb63afa32d24b72$var$result('unsupported_product');
    if (!input.history) return $ffb63afa32d24b72$var$result('suppression_unavailable');
    if (input.spotlightActive) return $ffb63afa32d24b72$var$result('spotlight_active');
    const { dismissedAt: dismissedAt, impressions: impressions } = input.history;
    const cutoff = input.now - $ffb63afa32d24b72$export$2e4bc55597d730e0;
    if (dismissedAt !== undefined && dismissedAt > cutoff) return $ffb63afa32d24b72$var$result('dismissal_cooldown');
    const startOfDay = new Date(input.now);
    startOfDay.setHours(0, 0, 0, 0);
    if (impressions.some((timestamp)=>timestamp >= startOfDay.getTime())) return $ffb63afa32d24b72$var$result('shown_today');
    if (impressions.filter((timestamp)=>timestamp > cutoff).length >= 3) return $ffb63afa32d24b72$var$result('weekly_limit');
    return $ffb63afa32d24b72$var$result('eligible');
}
function $ffb63afa32d24b72$export$8ac194ac22681b4f(value) {
    return $ffb63afa32d24b72$var$result(value === true ? 'eligible' : value === false ? 'control' : 'experiment_unavailable');
}

});


parcelRegister("iopDi", function(module, exports) {
$parcel$export(module.exports, "hoverCardClassName", () => $4f6051054c980f9d$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $4f6051054c980f9d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");

var $6WltM = parcelRequire("6WltM");

var $6bOBo = parcelRequire("6bOBo");

var $3aMs2 = parcelRequire("3aMs2");

var $jT6AP = parcelRequire("jT6AP");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $6Wkby = parcelRequire("6Wkby");

var $3p1gi = parcelRequire("3p1gi");

var $gy3md = parcelRequire("gy3md");

var $bIXTN = parcelRequire("bIXTN");

var $cUXyD = parcelRequire("cUXyD");

var $7jLk8 = parcelRequire("7jLk8");

var $2TtjQ = parcelRequire("2TtjQ");

var $4X9VT = parcelRequire("4X9VT");

var $aiGES = parcelRequire("aiGES");

var $aVZCo = parcelRequire("aVZCo");

var $hNqc2 = parcelRequire("hNqc2");

var $4zpBM = parcelRequire("4zpBM");

var $loBKq = parcelRequire("loBKq");

var $3Mp3H = parcelRequire("3Mp3H");

var $033jF = parcelRequire("033jF");

var $5knHH = parcelRequire("5knHH");

var $lCrle = parcelRequire("lCrle");

var $diK8z = parcelRequire("diK8z");

var $5WhMr = parcelRequire("5WhMr");

var $2oAb9 = parcelRequire("2oAb9");
const $4f6051054c980f9d$export$34883cbaea18402d = 'smart-links-hover-preview';
const $4f6051054c980f9d$var$useIsResolvedView = ({ cardState: cardState, hoverPreviewOptions: hoverPreviewOptions })=>{
    var _hoverPreviewOptions$;
    return !(hoverPreviewOptions !== null && hoverPreviewOptions !== void 0 && (_hoverPreviewOptions$ = hoverPreviewOptions.render) !== null && _hoverPreviewOptions$ !== void 0 && _hoverPreviewOptions$.call(hoverPreviewOptions)) && cardState.status === 'resolved';
};
const $4f6051054c980f9d$var$useServices = ({ url: url })=>{
    const linkState = (0, $2TtjQ.useSmartCardState)(url);
    const services = (0, $bIXTN.getServices)(linkState.details);
    return services;
};
const $4f6051054c980f9d$var$useIsUnauthorisedView = ({ cardState: cardState, url: url, hoverPreviewOptions: hoverPreviewOptions })=>{
    var _hoverPreviewOptions$2;
    const services = $4f6051054c980f9d$var$useServices({
        url: url
    });
    return !(hoverPreviewOptions !== null && hoverPreviewOptions !== void 0 && (_hoverPreviewOptions$2 = hoverPreviewOptions.render) !== null && _hoverPreviewOptions$2 !== void 0 && _hoverPreviewOptions$2.call(hoverPreviewOptions)) && cardState.status === 'unauthorized' && Boolean(services === null || services === void 0 ? void 0 : services.length);
};
const $4f6051054c980f9d$var$useIsShowPreauthBetterHovercard = (props)=>{
    const { rovoOptions: rovoConfig } = (0, $cUXyD.default)();
    return Boolean($4f6051054c980f9d$var$useIsUnauthorisedView(props) && (rovoConfig === null || rovoConfig === void 0 ? void 0 : rovoConfig.isRovoEnabled) && (0, $5N1Y4.expValEquals)('platform_sl_3p_preauth_better_hovercard', 'isEnabled', true));
};
const $4f6051054c980f9d$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onDismiss: onDismiss, actionOptions: actionOptions, hoverPreviewOptions: hoverPreviewOptions })=>{
    var _cardState$details;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const extensionKey = (0, $bSJIT.useMemo)(()=>(0, $gy3md.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $2TtjQ.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $bSJIT.useMemo)(()=>(0, $3p1gi.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, product: product } = (0, $6bOBo.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $aVZCo.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $bIXTN.getServices)(linkState.details);
    const appendCrossProductAnalyticsParams = (0, $7jLk8.useSmartLinkCrossProductUrlWrapper)({
        details: linkState.details
    });
    const statusRef = (0, $bSJIT.useRef)(linkStatus);
    const fireEventRef = (0, $bSJIT.useRef)(fireEvent);
    const definitionIdRef = (0, $bSJIT.useRef)(definitionId);
    (0, $bSJIT.useEffect)(()=>{
        /**
     * Must access object value via ref because its not stable
     * and it can trigger useEffect to re-run below
     */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const getDestinationUrl = (0, $bSJIT.useCallback)(()=>{
        // FIXME: destinationUrl should be rendered in the DOM anchor href instead of derived at click time
        const preferredUrl = (0, $6Wkby.getClickUrl)(url, linkState.details) ?? url;
        return appendCrossProductAnalyticsParams(preferredUrl) ?? preferredUrl;
    }, [
        appendCrossProductAnalyticsParams,
        linkState.details,
        url
    ]);
    // Middle-click handler to trigger fire3PClickEvent on middle-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const onAuxClick = (0, $bSJIT.useCallback)((event)=>{
        const destinationUrl = getDestinationUrl();
        (0, $4zpBM.updateAnchorHref)(event, destinationUrl);
    }, [
        getDestinationUrl
    ]);
    // Right-click handler to trigger fire3PClickEvent on right-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const onContextMenu = (0, $bSJIT.useCallback)((event)=>{
        const destinationUrl = getDestinationUrl();
        (0, $4zpBM.updateAnchorHref)(event, destinationUrl);
    }, [
        getDestinationUrl
    ]);
    const onClick = (0, $bSJIT.useCallback)((event)=>{
        // Prevent the anchor's native navigation so we can open the destination URL
        // with cross-product analytics query parameters appended.
        // The cross-product params are client-only and cannot be rendered
        // server-side. Falls back to the original `url` prop if the event target is
        // not an anchor element.
        event.preventDefault();
        const { target: target } = (0, $aiGES.getAnchorAttributesFromEvent)(event);
        const destinationUrl = getDestinationUrl();
        (0, $4zpBM.updateAnchorHref)(event, destinationUrl);
        window.open(destinationUrl, target);
        const isModifierKeyPressed = (0, $hNqc2.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5kJPq.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $4X9VT.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        getDestinationUrl,
        id,
        fireEvent,
        definitionId
    ]);
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const { subtitle: subtitle } = (0, $3Mp3H.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5kJPq.SmartLinkSize).Large,
        position: (0, $5kJPq.SmartLinkPosition).Center,
        subtitle: subtitle,
        anchorTarget: product === 'ATLAS' ? '_self' : undefined
    };
    const uiOptions = (0, $loBKq.flexibleUiOptions);
    uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5kJPq.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $bSJIT.useCallback)((e)=>e.stopPropagation(), []);
    const useIsResolvedViewGated = (0, $jT6AP.functionUnionWithCondition)(()=>(0, $gdUUy.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $4f6051054c980f9d$var$useIsResolvedView, ()=>undefined);
    const useIsUnauthorisedViewGated = (0, $jT6AP.functionUnionWithCondition)(()=>(0, $gdUUy.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $4f6051054c980f9d$var$useIsUnauthorisedView, ()=>undefined);
    const useIsShowPreauthBetterHovercardGated = (0, $jT6AP.functionUnionWithCondition)(()=>(0, $gdUUy.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $4f6051054c980f9d$var$useIsShowPreauthBetterHovercard, ()=>undefined);
    const isResolved = useIsResolvedViewGated({
        cardState: cardState,
        hoverPreviewOptions: hoverPreviewOptions
    });
    const isUnauthorised = useIsUnauthorisedViewGated({
        cardState: cardState,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    });
    const showPreauthBetterHovercard = useIsShowPreauthBetterHovercardGated({
        cardState: cardState,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    });
    if ((0, $gdUUy.fg)('platform_sl_3p_preauth_better_hovercard_killswitch')) {
        const cardView = ((_hoverPreviewOptions$3)=>{
            const overrideView = hoverPreviewOptions === null || hoverPreviewOptions === void 0 || (_hoverPreviewOptions$3 = hoverPreviewOptions.render) === null || _hoverPreviewOptions$3 === void 0 ? void 0 : _hoverPreviewOptions$3.call(hoverPreviewOptions);
            if (overrideView) return overrideView;
            if (cardState.status === 'errored') return null;
            if (cardState.status === 'resolving' || cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $diK8z.default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (isUnauthorised) {
                if (showPreauthBetterHovercard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2oAb9.default), {
                    extensionKey: extensionKey,
                    id: id,
                    flexibleCardProps: flexibleCardProps,
                    onDismiss: onDismiss,
                    url: url
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5WhMr.default), {
                    extensionKey: extensionKey,
                    id: id,
                    flexibleCardProps: flexibleCardProps,
                    url: url
                });
            }
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5knHH.default), {
                flexibleCardProps: flexibleCardProps
            });
            if (isResolved) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lCrle.default), {
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
            return null;
        })();
        return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $033jF.default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            widthAppearance: showPreauthBetterHovercard ? 'slim' : undefined,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    } else {
        const getCardView = (cardState)=>{
            var _hoverPreviewOptions$4;
            const overrideView = hoverPreviewOptions === null || hoverPreviewOptions === void 0 || (_hoverPreviewOptions$4 = hoverPreviewOptions.render) === null || _hoverPreviewOptions$4 === void 0 ? void 0 : _hoverPreviewOptions$4.call(hoverPreviewOptions);
            if (overrideView) return overrideView;
            if (cardState.status === 'errored') return null;
            if (cardState.status === 'resolving' || cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $diK8z.default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (cardState.status === 'unauthorized' && services !== null && services !== void 0 && services.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5WhMr.default), {
                extensionKey: extensionKey,
                id: id,
                flexibleCardProps: flexibleCardProps,
                url: url
            });
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5knHH.default), {
                flexibleCardProps: flexibleCardProps
            });
            if (cardState.status === 'resolved') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lCrle.default), {
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
            return null;
        };
        const cardView = getCardView(cardState);
        return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $033jF.default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    }
};
const $4f6051054c980f9d$var$HoverCardContentWithViewVariant = (props)=>{
    const showPreauthBetterHovercard = $4f6051054c980f9d$var$useIsShowPreauthBetterHovercard(props);
    const data = (0, $bSJIT.useMemo)(()=>{
        let viewVariant = 'default';
        if (showPreauthBetterHovercard) viewVariant = 'rovo-unauthorised-view';
        return {
            attributes: {
                viewVariant: viewVariant
            }
        };
    }, [
        showPreauthBetterHovercard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4f6051054c980f9d$var$HoverCardContent, props));
};
const $4f6051054c980f9d$var$_default_1 = (0, $3aMs2.componentWithCondition)(()=>{
    return (0, $gdUUy.fg)('platform_sl_3p_preauth_better_hovercard_killswitch');
}, $4f6051054c980f9d$var$HoverCardContentWithViewVariant, $4f6051054c980f9d$var$HoverCardContent);
var $4f6051054c980f9d$export$2e2bcd8739ae039 = $4f6051054c980f9d$var$_default_1;

});
parcelRegister("jT6AP", function(module, exports) {
$parcel$export(module.exports, "functionUnionWithCondition", () => $fa5a0e4fe77feaff$export$c41c28c1d883fcd5);

var $iJ0mL = parcelRequire("iJ0mL");
function $fa5a0e4fe77feaff$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return (0, $iJ0mL.functionWithCondition)(condition, functionTrue, functionFalse);
}

});

parcelRegister("aVZCo", function(module, exports) {
$parcel$export(module.exports, "getIsAISummaryEnabled", () => $6c07253cf45080a9$export$d439c74cb206ff29);
const $6c07253cf45080a9$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>{
    var _response$meta;
    return Boolean(isAdminHubAIEnabled && (response === null || response === void 0 || (_response$meta = response.meta) === null || _response$meta === void 0 || (_response$meta = _response$meta.supportedFeature) === null || _response$meta === void 0 ? void 0 : _response$meta.includes('AISummary')));
};

});

parcelRegister("loBKq", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $d7cd40b3270bdc31$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $d7cd40b3270bdc31$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $d7cd40b3270bdc31$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $d7cd40b3270bdc31$export$e7cae8c75d768024);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-atlaskit-theme

var $juI4y = parcelRequire("juI4y");

var $5kJPq = parcelRequire("5kJPq");
const $d7cd40b3270bdc31$export$8245b0eaabf3440c = (0, $juI4y.layers).modal();
const $d7cd40b3270bdc31$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5kJPq.SmartLinkSize).Medium,
    zIndex: $d7cd40b3270bdc31$export$8245b0eaabf3440c + 1
};
const $d7cd40b3270bdc31$export$a0a37c997fbcd678 = 24;
const $d7cd40b3270bdc31$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("3Mp3H", function(module, exports) {
$parcel$export(module.exports, "getMetadata", () => $15e1c8c8fd64af74$export$8548546c0aa631e6);

var $fZvKv = parcelRequire("fZvKv");

var $5kJPq = parcelRequire("5kJPq");

var $b5RkV = parcelRequire("b5RkV");
const $15e1c8c8fd64af74$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    var _data$Type;
    const types = data ? (0, $fZvKv.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5kJPq.ElementName).AuthorGroup,
            (0, $5kJPq.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types !== null && types !== void 0 && types.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5kJPq.ElementName).AuthorGroup,
                    (0, $5kJPq.ElementName).ModifiedOn,
                    (0, $5kJPq.ElementName).SubscriberCount,
                    (0, $5kJPq.ElementName).State
                ],
                subtitle: [
                    (0, $5kJPq.ElementName).SourceBranch,
                    (0, $5kJPq.ElementName).TargetBranch
                ]
            };
            if (types !== null && types !== void 0 && types.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5kJPq.ElementName).LatestCommit,
                    (0, $5kJPq.ElementName).CollaboratorGroup,
                    (0, $5kJPq.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5kJPq.ElementName).AuthorGroup,
                    (0, $5kJPq.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $b5RkV.extractOwnedBy)(data) ? (0, $5kJPq.ElementName).OwnedByGroup : (0, $5kJPq.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5kJPq.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5kJPq.ElementName).ReactCount,
                    (0, $5kJPq.ElementName).CommentCount,
                    (0, $5kJPq.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = (data === null || data === void 0 || (_data$Type = data['@type']) === null || _data$Type === void 0 ? void 0 : _data$Type.includes('atlassian:Task')) ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5kJPq.ElementName).AssignedToGroup,
                        (0, $5kJPq.ElementName).State,
                        (0, $5kJPq.ElementName).StoryPoints,
                        (0, $5kJPq.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5kJPq.ElementName).CollaboratorGroup,
                    (0, $5kJPq.ElementName).State,
                    (0, $5kJPq.ElementName).DueOn
                ],
                secondary: [
                    (0, $5kJPq.ElementName).ReactCount,
                    (0, $5kJPq.ElementName).CommentCount,
                    (0, $5kJPq.ElementName).AttachmentCount,
                    (0, $5kJPq.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5kJPq.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types !== null && types !== void 0 && types.includes('atlassian:Project')) return {
                primary: [
                    (0, $5kJPq.ElementName).AuthorGroup,
                    (0, $5kJPq.ElementName).ModifiedOn,
                    (0, $5kJPq.ElementName).State,
                    (0, $5kJPq.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5kJPq.ElementName).AuthorGroup,
                    (0, $5kJPq.ElementName).State,
                    (0, $5kJPq.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5kJPq.ElementName).AuthorGroup,
                    (0, $5kJPq.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5kJPq.ElementName).ReactCount,
                    (0, $5kJPq.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5kJPq.ElementName).AuthorGroup,
                    (0, $5kJPq.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $15e1c8c8fd64af74$var$AvatarGroupsWithNamePrefix = [
    (0, $5kJPq.ElementName).AssignedToGroup,
    (0, $5kJPq.ElementName).OwnedByGroup,
    (0, $5kJPq.ElementName).AuthorGroup
];
const $15e1c8c8fd64af74$var$toElementItem = (name)=>{
    const showNamePrefix = $15e1c8c8fd64af74$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $15e1c8c8fd64af74$var$toElementItems = (elementNames)=>{
    if (!(elementNames !== null && elementNames !== void 0 && elementNames.length)) return;
    return elementNames.filter((name)=>name in (0, $5kJPq.ElementName)).map($15e1c8c8fd64af74$var$toElementItem);
};
const $15e1c8c8fd64af74$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $15e1c8c8fd64af74$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $15e1c8c8fd64af74$var$toElementItems(metadata.subtitle),
        primary: $15e1c8c8fd64af74$var$toElementItems(primary),
        secondary: $15e1c8c8fd64af74$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("b5RkV", function(module, exports) {
$parcel$export(module.exports, "extractOwnedBy", () => $98235e32fbac609a$export$75b4b5a156f48ff3);

var $b8gs6 = parcelRequire("b8gs6");
const $98235e32fbac609a$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $b8gs6.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};

});
parcelRegister("b8gs6", function(module, exports) {
$parcel$export(module.exports, "extractPersonOwnedBy", () => $838a7b8586f1ef61$export$19ee667f3f7a6ec3);

var $aVkT0 = parcelRequire("aVkT0");
const $838a7b8586f1ef61$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $aVkT0.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $aVkT0.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};

});
parcelRegister("aVkT0", function(module, exports) {
$parcel$export(module.exports, "extractPersonFromJsonLd", () => $09b7c01b7a5e5675$export$c471ae5fddcf1392);

var $cdeW6 = parcelRequire("cdeW6");
const $09b7c01b7a5e5675$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $cdeW6.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};

});




parcelRegister("033jF", function(module, exports) {
$parcel$export(module.exports, "default", () => $26eb869c618c71c0$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jsMV5 = parcelRequire("jsMV5");

var $g5N06 = parcelRequire("g5N06");

var $iopDi = parcelRequire("iopDi");
const $26eb869c618c71c0$var$HoverCardContainerStyle = null;
const $26eb869c618c71c0$var$hoverCardShellWidthDefault = null;
const $26eb869c618c71c0$var$hoverCardShellWidthSlim = null;
const $26eb869c618c71c0$var$hoverCardShellHideLoadingPlaceholder = null;
const $26eb869c618c71c0$var$popupContainerStyles = null;
const $26eb869c618c71c0$var$ConnectedAIPrismContainer = ({ children: children, widthAppearance: widthAppearance, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    const { state: { status: status } } = (0, $jsMV5.default)(url);
    const [showPrism, setShowPrism] = (0, $bSJIT.useState)(status === 'loading');
    (0, $bSJIT.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const resolvedWidthAppearance = widthAppearance ?? 'default';
    const container = /*#__PURE__*/ $bSJIT.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_11q7glyw _189eidpf _vchhusvi",
            resolvedWidthAppearance === 'slim' ? "_1bsbtye8" : "_1bsb1f23",
            "_9spsglyw",
            !isAIEnabled && "_2rko1mok _bfhk1bhr _16qs130s",
            (0, $iopDi.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props
    }, children);
    return isAIEnabled ? /*#__PURE__*/ $bSJIT.createElement((0, $g5N06.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`
    }, container) : container;
};
const $26eb869c618c71c0$var$ContentContainer = ({ children: children, widthAppearance: widthAppearance, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ $bSJIT.createElement($26eb869c618c71c0$var$ConnectedAIPrismContainer, {
        widthAppearance: widthAppearance,
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props
    }, children);
var $26eb869c618c71c0$export$2e2bcd8739ae039 = $26eb869c618c71c0$var$ContentContainer;

});

parcelRegister("5knHH", function(module, exports) {
$parcel$export(module.exports, "default", () => $53fd0ca5a56333a5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5cKiX = parcelRequire("5cKiX");

var $6WltM = parcelRequire("6WltM");

var $jNJGJ = parcelRequire("jNJGJ");

var $gxIo9 = parcelRequire("gxIo9");

var $fqW9V = parcelRequire("fqW9V");

var $dFiwI = parcelRequire("dFiwI");

var $7wYyA = parcelRequire("7wYyA");

var $dkOB1 = parcelRequire("dkOB1");

var $8dLhi = parcelRequire("8dLhi");

var $3Qn1E = parcelRequire("3Qn1E");
const $53fd0ca5a56333a5$var$titleBlockStyles = null;
const $53fd0ca5a56333a5$var$mainTextStyles = null;
const $53fd0ca5a56333a5$var$connectButtonStyles = null;
const $53fd0ca5a56333a5$var$basePreviewStyles = null;
const $53fd0ca5a56333a5$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    var _cardState$details, _extractSmartLinkProv;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.meta;
    const product = ((_extractSmartLinkProv = (0, $gxIo9.extractSmartLinkProvider)(cardState.details)) === null || _extractSmartLinkProv === void 0 ? void 0 : _extractSmartLinkProv.text) ?? '';
    const hostname = /*#__PURE__*/ $bSJIT.createElement("b", null, (0, $dFiwI.default)(url));
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $fqW9V.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ $bSJIT.createElement((0, $dkOB1.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $bSJIT.createElement((0, $3Qn1E.default), {
        ignoreContainerPadding: true,
        testId: testId,
        className: (0, $9fU1q.default)([
            "_13li1mok _qrwq1mok _otyru2gc"
        ])
    }), /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        testId: `${testId}-title`,
        className: (0, $9fU1q.default)([
            "_1bah1h6o _k48p1pd9 _19pku2gc"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $7wYyA.messages)[titleMessageKey],
        values: {
            product: product
        }
    })), /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        testId: `${testId}-content`,
        className: (0, $9fU1q.default)([
            "_11c8wadc _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $7wYyA.messages)[descriptiveMessageKey],
        values: {
            product: product,
            hostname: hostname
        }
    })), action && /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        className: (0, $9fU1q.default)([
            "_1bah1h6o _19pku2gc"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $jNJGJ.default), {
        testId: `${testId}-button`,
        onClick: action === null || action === void 0 ? void 0 : action.promise,
        appearance: "primary",
        isDisabled: buttonDisabled
    }, action === null || action === void 0 ? void 0 : action.text)));
};
var $53fd0ca5a56333a5$export$2e2bcd8739ae039 = $53fd0ca5a56333a5$var$HoverCardForbiddenView;

});
parcelRegister("fqW9V", function(module, exports) {
$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $8f6522db86c24249$export$846c1540a86749e6);

var $7wYyA = parcelRequire("7wYyA");

var $2hVNZ = parcelRequire("2hVNZ");

var $lQfGn = parcelRequire("lQfGn");

var $dFiwI = parcelRequire("dFiwI");
const $8f6522db86c24249$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _jsonLd$requestAccess;
    const requestAccess = jsonLd !== null && jsonLd !== void 0 && jsonLd.requestAccess ? {
        ...jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.requestAccess,
        hostname: (0, $dFiwI.default)(url)
    } : undefined;
    switch(jsonLd === null || jsonLd === void 0 || (_jsonLd$requestAccess = jsonLd.requestAccess) === null || _jsonLd$requestAccess === void 0 ? void 0 : _jsonLd$requestAccess.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $lQfGn.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $2hVNZ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $7wYyA.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $lQfGn.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $2hVNZ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $7wYyA.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $lQfGn.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $7wYyA.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if ((jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.visibility) === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $lQfGn.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $2hVNZ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $7wYyA.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("lQfGn", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $09c1a4fd29a99b5b$export$59f8830fb5467e35);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $7wYyA = parcelRequire("7wYyA");
const $09c1a4fd29a99b5b$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $7wYyA.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("dFiwI", function(module, exports) {
$parcel$export(module.exports, "default", () => $43f1bcab73850db0$export$2e2bcd8739ae039);
const $43f1bcab73850db0$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $43f1bcab73850db0$export$2e2bcd8739ae039 = $43f1bcab73850db0$var$extractHostname;

});



parcelRegister("lCrle", function(module, exports) {
$parcel$export(module.exports, "default", () => $be2e97d7eaf30cf4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $dXrim = parcelRequire("dXrim");

var $dkOB1 = parcelRequire("dkOB1");

var $aLRXN = parcelRequire("aLRXN");

var $7YS4o = parcelRequire("7YS4o");

var $5LIyM = parcelRequire("5LIyM");

var $igIuZ = parcelRequire("igIuZ");

var $8WdDM = parcelRequire("8WdDM");

var $iD4XW = parcelRequire("iD4XW");

var $3Mp3H = parcelRequire("3Mp3H");

var $cSsro = parcelRequire("cSsro");
const $be2e97d7eaf30cf4$var$hiddenSnippetStyles = null;
const $be2e97d7eaf30cf4$var$titleBlockStyles = null;
const $be2e97d7eaf30cf4$var$snippetBlockCss = null;
const $be2e97d7eaf30cf4$var$actionBlockCss = null;
const $be2e97d7eaf30cf4$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    var _cardState$details;
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    (0, $bSJIT.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $dXrim.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5kJPq.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $dXrim.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5kJPq.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5kJPq.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const { primary: primary, secondary: secondary } = (0, $bSJIT.useMemo)(()=>{
        return (0, $3Mp3H.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(0);
    const snippetBlockRef = (0, $bSJIT.useRef)(null);
    const onSnippetRender = (0, $bSJIT.useCallback)(()=>{
        var _snippetBlockRef$curr;
        snippetHeight.current = ((_snippetBlockRef$curr = snippetBlockRef.current) === null || _snippetBlockRef$curr === void 0 ? void 0 : _snippetBlockRef$curr.getBoundingClientRect().height) ?? 0;
    }, []);
    const imagePreview = (0, $cSsro.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8WdDM.default), {
        className: (0, $9fU1q.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dkOB1.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iD4XW.default), {
        ...titleBlockProps,
        metadataPosition: (0, $5kJPq.SmartLinkPosition).Top,
        className: (0, $9fU1q.default)([
            "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $igIuZ.default), {
        primary: primary,
        secondary: secondary,
        maxLines: 1,
        size: (0, $5kJPq.SmartLinkSize).Medium
    }), isAISummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5LIyM.default), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet
    }) : snippet, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8WdDM.default), {
        testId: "hidden-snippet",
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        isHidden: true,
        className: (0, $9fU1q.default)([
            "_3um015vq _kqswstnw"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aLRXN.default), {
        onClick: onActionClick,
        spaceInline: "space.100",
        className: (0, $9fU1q.default)([
            "_n3td1b66"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7YS4o.default), null));
};
var $be2e97d7eaf30cf4$export$2e2bcd8739ae039 = $be2e97d7eaf30cf4$var$HoverCardResolvedView;

});
parcelRegister("5LIyM", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f9c882854f8f3c8$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $eAoOt = parcelRequire("eAoOt");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $5VleH = parcelRequire("5VleH");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $2f9c882854f8f3c8$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    var _context$actions, _cardContext$ui;
    const cardContext = (0, $eAoOt.useFlexibleCardContext)();
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.InternalActionName).AISummaryAction];
    if ((cardContext === null || cardContext === void 0 ? void 0 : cardContext.status) !== (0, $5kJPq.SmartLinkStatus).Resolved) return null;
    if (!(actionData !== null && actionData !== void 0 && actionData.url)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5VleH.default), {
        ...props,
        size: props.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size),
        testId: testId,
        url: actionData.url
    });
};
var $2f9c882854f8f3c8$export$2e2bcd8739ae039 = $2f9c882854f8f3c8$var$AISummaryBlock;

});
parcelRegister("5VleH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3057eb98ba3bbc03$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5kJPq = parcelRequire("5kJPq");

var $jsMV5 = parcelRequire("jsMV5");

var $hvGsR = parcelRequire("hvGsR");

var $8rz1h = parcelRequire("8rz1h");

var $8dLhi = parcelRequire("8dLhi");

var $eo7PH = parcelRequire("eo7PH");
const $3057eb98ba3bbc03$var$styles = null;
const $3057eb98ba3bbc03$var$AISummaryBlockResolvedView = (props)=>{
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $jsMV5.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $bSJIT.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ $bSJIT.createElement((0, $bSJIT.Fragment), null, placeholder);
    return /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        ...props,
        direction: (0, $5kJPq.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $9fU1q.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, status === 'done' && /*#__PURE__*/ $bSJIT.createElement((0, $eo7PH.default), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $bSJIT.createElement((0, $8rz1h.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hvGsR.default), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
var $3057eb98ba3bbc03$export$2e2bcd8739ae039 = $3057eb98ba3bbc03$var$AISummaryBlockResolvedView;

});
parcelRegister("hvGsR", function(module, exports) {
$parcel$export(module.exports, "default", () => $141125078e9ecc7f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $9HuDI = parcelRequire("9HuDI");

var $3G9Rl = parcelRequire("3G9Rl");
const $141125078e9ecc7f$var$baseStyle = null;
const $141125078e9ecc7f$var$textStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $141125078e9ecc7f$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ $bSJIT.createElement((0, $9HuDI.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_11c8wadc _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            "_syazazsu",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $3G9Rl.default)
            },
            disableParsingRawHTML: true
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $141125078e9ecc7f$export$2e2bcd8739ae039 = $141125078e9ecc7f$var$AISummary;

});
parcelRegister("9HuDI", function(module, exports) {
$parcel$export(module.exports, "default", () => $70ffe59a062c58e0$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $70ffe59a062c58e0$var$n() {
    return $70ffe59a062c58e0$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, $70ffe59a062c58e0$var$n.apply(this, arguments);
}
const $70ffe59a062c58e0$var$r = [
    "children",
    "options"
], $70ffe59a062c58e0$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
}, $70ffe59a062c58e0$var$o = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    class: "className",
    for: "htmlFor"
}), $70ffe59a062c58e0$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $70ffe59a062c58e0$var$c = [
    "style",
    "script",
    "pre"
], $70ffe59a062c58e0$var$i = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $70ffe59a062c58e0$var$u = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $70ffe59a062c58e0$var$l = /\n{2,}$/, $70ffe59a062c58e0$var$s = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $70ffe59a062c58e0$var$f = /^ *> ?/gm, $70ffe59a062c58e0$var$_ = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $70ffe59a062c58e0$var$d = /^ {2,}\n/, $70ffe59a062c58e0$var$p = /^(?:([-*_])( *\1){2,}) *(?:\n *)+\n/, $70ffe59a062c58e0$var$y = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $70ffe59a062c58e0$var$h = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $70ffe59a062c58e0$var$g = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $70ffe59a062c58e0$var$m = /^(?:\n *)*\n/, $70ffe59a062c58e0$var$k = /\r\n?/g, $70ffe59a062c58e0$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $70ffe59a062c58e0$var$q = /^\[\^([^\]]+)]/, $70ffe59a062c58e0$var$v = /\f/g, $70ffe59a062c58e0$var$b = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $70ffe59a062c58e0$var$$ = /^\s*?\[(x|\s)\]/, $70ffe59a062c58e0$var$S = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $70ffe59a062c58e0$var$z = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $70ffe59a062c58e0$var$E = /^([^\n]+)\n *(=|-)\2{2,} *\n/, $70ffe59a062c58e0$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $70ffe59a062c58e0$var$R = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $70ffe59a062c58e0$var$B = /^<!--[\s\S]*?(?:-->)/, $70ffe59a062c58e0$var$L = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $70ffe59a062c58e0$var$O = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $70ffe59a062c58e0$var$j = /^\{.*\}$/, $70ffe59a062c58e0$var$C = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $70ffe59a062c58e0$var$I = /^<([^ >]+[:@\/][^ >]+)>/, $70ffe59a062c58e0$var$T = /-([a-z])?/gi, $70ffe59a062c58e0$var$M = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $70ffe59a062c58e0$var$w = /^[^\n]+(?:  \n|\n{2,})/, $70ffe59a062c58e0$var$D = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $70ffe59a062c58e0$var$F = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $70ffe59a062c58e0$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $70ffe59a062c58e0$var$Z = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $70ffe59a062c58e0$var$N = /\t/g, $70ffe59a062c58e0$var$G = /(^ *\||\| *$)/g, $70ffe59a062c58e0$var$U = /^ *:-+: *$/, $70ffe59a062c58e0$var$V = /^ *:-+ *$/, $70ffe59a062c58e0$var$H = /^ *-+: *$/, $70ffe59a062c58e0$var$Q = (e)=>`(?=[\\s\\S]+?\\1${e ? "\\1" : ""})`, $70ffe59a062c58e0$var$W = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $70ffe59a062c58e0$var$J = RegExp(`^([*_])\\1${$70ffe59a062c58e0$var$Q(1)}${$70ffe59a062c58e0$var$W}\\1\\1(?!\\1)`), $70ffe59a062c58e0$var$K = RegExp(`^([*_])${$70ffe59a062c58e0$var$Q(0)}${$70ffe59a062c58e0$var$W}\\1(?!\\1)`), $70ffe59a062c58e0$var$X = RegExp(`^(==)${$70ffe59a062c58e0$var$Q(0)}${$70ffe59a062c58e0$var$W}\\1`), $70ffe59a062c58e0$var$Y = RegExp(`^(~~)${$70ffe59a062c58e0$var$Q(0)}${$70ffe59a062c58e0$var$W}\\1`), $70ffe59a062c58e0$var$ee = /^(:[a-zA-Z0-9-_]+:)/, $70ffe59a062c58e0$var$ne = /^\\([^0-9A-Za-z\s])/, $70ffe59a062c58e0$var$re = /\\([^0-9A-Za-z\s])/g, $70ffe59a062c58e0$var$te = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, $70ffe59a062c58e0$var$oe = /^\n+/, $70ffe59a062c58e0$var$ae = /^([ \t]*)/, $70ffe59a062c58e0$var$ce = /(?:^|\n)( *)$/, $70ffe59a062c58e0$var$ie = "(?:\\d+\\.)", $70ffe59a062c58e0$var$ue = "(?:[*+-])";
function $70ffe59a062c58e0$var$le(e) {
    return "( *)(" + (1 === e ? $70ffe59a062c58e0$var$ie : $70ffe59a062c58e0$var$ue) + ") +";
}
const $70ffe59a062c58e0$var$se = $70ffe59a062c58e0$var$le(1), $70ffe59a062c58e0$var$fe = $70ffe59a062c58e0$var$le(2);
function $70ffe59a062c58e0$var$_e(e) {
    return RegExp("^" + (1 === e ? $70ffe59a062c58e0$var$se : $70ffe59a062c58e0$var$fe));
}
const $70ffe59a062c58e0$var$de = $70ffe59a062c58e0$var$_e(1), $70ffe59a062c58e0$var$pe = $70ffe59a062c58e0$var$_e(2);
function $70ffe59a062c58e0$var$ye(e) {
    return RegExp("^" + (1 === e ? $70ffe59a062c58e0$var$se : $70ffe59a062c58e0$var$fe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $70ffe59a062c58e0$var$ie : $70ffe59a062c58e0$var$ue) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $70ffe59a062c58e0$var$he = $70ffe59a062c58e0$var$ye(1), $70ffe59a062c58e0$var$ge = $70ffe59a062c58e0$var$ye(2);
function $70ffe59a062c58e0$var$me(e) {
    const n = 1 === e ? $70ffe59a062c58e0$var$ie : $70ffe59a062c58e0$var$ue;
    return RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $70ffe59a062c58e0$var$ke = $70ffe59a062c58e0$var$me(1), $70ffe59a062c58e0$var$xe = $70ffe59a062c58e0$var$me(2);
function $70ffe59a062c58e0$var$qe(e, n) {
    const r = 1 === n, t = r ? $70ffe59a062c58e0$var$ke : $70ffe59a062c58e0$var$xe, o = r ? $70ffe59a062c58e0$var$he : $70ffe59a062c58e0$var$ge, a = r ? $70ffe59a062c58e0$var$de : $70ffe59a062c58e0$var$pe;
    return {
        t: (e)=>a.test(e),
        o: $70ffe59a062c58e0$var$je(function(e, n) {
            const r = $70ffe59a062c58e0$var$ce.exec(n.prevCapture);
            return r && (n.list || !n.inline && !n.simple) ? t.exec(e = r[1] + e) : null;
        }),
        i: 1,
        u (e, n, t) {
            const c = r ? +e[2] : void 0, i = e[0].replace($70ffe59a062c58e0$var$l, "\n").match(o);
            let u = !1;
            return {
                items: i.map(function(e, r) {
                    const o = a.exec(e)[0].length, c = RegExp("^ {1," + o + "}", "gm"), l = e.replace(c, "").replace(a, ""), s = r === i.length - 1, f = -1 !== l.indexOf("\n\n") || s && u;
                    u = f;
                    const _ = t.inline, d = t.list;
                    let p;
                    t.list = !0, f ? (t.inline = !1, p = $70ffe59a062c58e0$var$Se(l) + "\n\n") : (t.inline = !0, p = $70ffe59a062c58e0$var$Se(l));
                    const y = n(p, t);
                    return t.inline = _, t.list = d, y;
                }),
                ordered: r,
                start: c
            };
        },
        l: (n, r, t)=>e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, o) {
                return e("li", {
                    key: o
                }, r(n, t));
            }))
    };
}
const $70ffe59a062c58e0$var$ve = RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $70ffe59a062c58e0$var$be = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $70ffe59a062c58e0$var$$e(e) {
    return "string" == typeof e;
}
function $70ffe59a062c58e0$var$Se(e) {
    let n = e.length;
    for(; n > 0 && e[n - 1] <= " ";)n--;
    return e.slice(0, n);
}
function $70ffe59a062c58e0$var$ze(e, n) {
    return e.startsWith(n);
}
function $70ffe59a062c58e0$var$Ee(e, n, r) {
    if (Array.isArray(r)) {
        for(let n = 0; n < r.length; n++)if ($70ffe59a062c58e0$var$ze(e, r[n])) return !0;
        return !1;
    }
    return r(e, n);
}
function $70ffe59a062c58e0$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $70ffe59a062c58e0$var$Re(e) {
    return $70ffe59a062c58e0$var$H.test(e) ? "right" : $70ffe59a062c58e0$var$U.test(e) ? "center" : $70ffe59a062c58e0$var$V.test(e) ? "left" : null;
}
function $70ffe59a062c58e0$var$Be(e, n, r, t) {
    const o = r.inTable;
    r.inTable = !0;
    let a = [
        []
    ], c = "";
    function i() {
        if (!c) return;
        const e = a[a.length - 1];
        e.push.apply(e, n(c, r)), c = "";
    }
    return e.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((e, n, r)=>{
        "|" === e.trim() && (i(), t) ? 0 !== n && n !== r.length - 1 && a.push([]) : c += e;
    }), i(), r.inTable = o, a;
}
function $70ffe59a062c58e0$var$Le(e, n, r) {
    r.inline = !0;
    const t = e[2] ? e[2].replace($70ffe59a062c58e0$var$G, "").split("|").map($70ffe59a062c58e0$var$Re) : [], o = e[3] ? function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return $70ffe59a062c58e0$var$Be(e, n, r, !0);
        });
    }(e[3], n, r) : [], a = $70ffe59a062c58e0$var$Be(e[1], n, r, !!o.length);
    return r.inline = !1, o.length ? {
        align: t,
        cells: o,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function $70ffe59a062c58e0$var$Oe(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $70ffe59a062c58e0$var$je(e) {
    return e.inline = 1, e;
}
function $70ffe59a062c58e0$var$Ce(e) {
    return $70ffe59a062c58e0$var$je(function(n, r) {
        return r.inline ? e.exec(n) : null;
    });
}
function $70ffe59a062c58e0$var$Ie(e) {
    return $70ffe59a062c58e0$var$je(function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    });
}
function $70ffe59a062c58e0$var$Te(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function $70ffe59a062c58e0$var$Me(e) {
    return $70ffe59a062c58e0$var$je(function(n) {
        return e.exec(n);
    });
}
const $70ffe59a062c58e0$var$we = /(javascript|vbscript|data(?!:image)):/i;
function $70ffe59a062c58e0$export$3e2338ea76b578c9(e) {
    try {
        const n = decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "");
        if ($70ffe59a062c58e0$var$we.test(n)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $70ffe59a062c58e0$var$Fe(e) {
    return e ? e.replace($70ffe59a062c58e0$var$re, "$1") : e;
}
function $70ffe59a062c58e0$var$Pe(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !0, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $70ffe59a062c58e0$var$Ze(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !1, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $70ffe59a062c58e0$var$Ne(e, n, r) {
    const t = r.inline || !1;
    r.inline = !1;
    const o = e(n, r);
    return r.inline = t, o;
}
const $70ffe59a062c58e0$var$Ge = (e, n, r)=>({
        children: $70ffe59a062c58e0$var$Pe(n, e[2], r)
    });
function $70ffe59a062c58e0$var$Ue() {
    return {};
}
function $70ffe59a062c58e0$var$Ve() {
    return null;
}
function $70ffe59a062c58e0$var$He(...e) {
    return e.filter(Boolean).join(" ");
}
function $70ffe59a062c58e0$var$Qe(e, n, r) {
    let t = e;
    const o = n.split(".");
    for(; o.length && (t = t[o[0]], void 0 !== t);)o.shift();
    return t || r;
}
function $70ffe59a062c58e0$export$69f434acfbdb0b32(r = "", t = {}) {
    t.overrides = t.overrides || {}, t.namedCodesToUnicode = t.namedCodesToUnicode ? $70ffe59a062c58e0$var$n({}, $70ffe59a062c58e0$var$a, t.namedCodesToUnicode) : $70ffe59a062c58e0$var$a;
    const l = t.slugify || $70ffe59a062c58e0$export$c383cdd2a518017a, G = t.sanitizer || $70ffe59a062c58e0$export$3e2338ea76b578c9, U = t.createElement || $bSJIT.createElement, V = [
        $70ffe59a062c58e0$var$s,
        $70ffe59a062c58e0$var$y,
        $70ffe59a062c58e0$var$h,
        t.enforceAtxHeadings ? $70ffe59a062c58e0$var$z : $70ffe59a062c58e0$var$S,
        $70ffe59a062c58e0$var$E,
        $70ffe59a062c58e0$var$M,
        $70ffe59a062c58e0$var$ke,
        $70ffe59a062c58e0$var$xe
    ], H = [
        ...V,
        $70ffe59a062c58e0$var$w,
        $70ffe59a062c58e0$var$A,
        $70ffe59a062c58e0$var$B,
        $70ffe59a062c58e0$var$O
    ];
    function Q(e, n) {
        for(let r = 0; r < e.length; r++)if (e[r].test(n)) return !0;
        return !1;
    }
    function W(e, r, ...o) {
        const a = $70ffe59a062c58e0$var$Qe(t.overrides, e + ".props", {});
        return U(function(e, n) {
            const r = $70ffe59a062c58e0$var$Qe(n, e);
            return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : $70ffe59a062c58e0$var$Qe(n, e + ".component", e) : e;
        }(e, t.overrides), $70ffe59a062c58e0$var$n({}, r, a, {
            className: $70ffe59a062c58e0$var$He(null == r ? void 0 : r.className, a.className) || void 0
        }), ...o);
    }
    function re(e) {
        e = e.replace($70ffe59a062c58e0$var$b, "");
        let n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $70ffe59a062c58e0$var$Z.test(e));
        const r = fe(se(n ? e : $70ffe59a062c58e0$var$Se(e).replace($70ffe59a062c58e0$var$oe, "") + "\n\n", {
            inline: n
        }));
        for(; $70ffe59a062c58e0$var$$e(r[r.length - 1]) && !r[r.length - 1].trim();)r.pop();
        if (null === t.wrapper) return r;
        const o = t.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || t.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? W("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return U(o, {
            key: "outer"
        }, a);
    }
    function ce(e, n) {
        if (!n || !n.trim()) return null;
        const r = n.match($70ffe59a062c58e0$var$u);
        return r ? r.reduce(function(n, r) {
            const t = r.indexOf("=");
            if (-1 !== t) {
                const a = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($70ffe59a062c58e0$var$L) && (e = e.replace($70ffe59a062c58e0$var$T, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, t)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(t + 1).trim()), u = $70ffe59a062c58e0$var$o[a] || a;
                if ("ref" === u) return n;
                const l = n[u] = function(e, n, r, t) {
                    return "style" === n ? (function(e) {
                        const n = [];
                        let r = "", t = !1, o = !1, a = "";
                        if (!e) return n;
                        for(let c = 0; c < e.length; c++){
                            const i = e[c];
                            if ('"' !== i && "'" !== i || t || (o ? i === a && (o = !1, a = "") : (o = !0, a = i)), "(" === i && r.endsWith("url") ? t = !0 : ")" === i && t && (t = !1), ";" !== i || o || t) r += i;
                            else {
                                const e = r.trim();
                                if (e) {
                                    const r = e.indexOf(":");
                                    if (r > 0) {
                                        const t = e.slice(0, r).trim(), o = e.slice(r + 1).trim();
                                        n.push([
                                            t,
                                            o
                                        ]);
                                    }
                                }
                                r = "";
                            }
                        }
                        const c = r.trim();
                        if (c) {
                            const e = c.indexOf(":");
                            if (e > 0) {
                                const r = c.slice(0, e).trim(), t = c.slice(e + 1).trim();
                                n.push([
                                    r,
                                    t
                                ]);
                            }
                        }
                        return n;
                    })(r).reduce(function(n, [r, o]) {
                        return n[r.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t(o, e, r), n;
                    }, {}) : -1 !== $70ffe59a062c58e0$var$i.indexOf(n) ? t($70ffe59a062c58e0$var$Fe(r), e, n) : (r.match($70ffe59a062c58e0$var$j) && (r = $70ffe59a062c58e0$var$Fe(r.slice(1, r.length - 1))), "true" === r || "false" !== r && r);
                }(e, a, c, G);
                "string" == typeof l && ($70ffe59a062c58e0$var$A.test(l) || $70ffe59a062c58e0$var$O.test(l)) && (n[u] = re(l.trim()));
            } else "style" !== r && (n[$70ffe59a062c58e0$var$o[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    const ie = [], ue = {}, le = {
        0: {
            t: [
                ">"
            ],
            o: $70ffe59a062c58e0$var$Te($70ffe59a062c58e0$var$s),
            i: 1,
            u (e, n, r) {
                const [, t, o] = e[0].replace($70ffe59a062c58e0$var$f, "").match($70ffe59a062c58e0$var$_);
                return {
                    alert: t,
                    children: n(o, r)
                };
            },
            l (e, n, r) {
                const t = {
                    key: r.key
                };
                return e.alert && (t.className = "markdown-alert-" + l(e.alert.toLowerCase(), $70ffe59a062c58e0$export$c383cdd2a518017a), e.children.unshift({
                    attrs: {},
                    children: [
                        {
                            type: "27",
                            text: e.alert
                        }
                    ],
                    noInnerParse: !0,
                    type: "11",
                    tag: "header"
                })), W("blockquote", t, n(e.children, r));
            }
        },
        1: {
            t: [
                "  "
            ],
            o: $70ffe59a062c58e0$var$Me($70ffe59a062c58e0$var$d),
            i: 1,
            u: $70ffe59a062c58e0$var$Ue,
            l: (e, n, r)=>W("br", {
                    key: r.key
                })
        },
        2: {
            t: [
                "--",
                "__",
                "**",
                "- ",
                "* ",
                "_ "
            ],
            o: $70ffe59a062c58e0$var$Te($70ffe59a062c58e0$var$p),
            i: 1,
            u: $70ffe59a062c58e0$var$Ue,
            l: (e, n, r)=>W("hr", {
                    key: r.key
                })
        },
        3: {
            t: [
                "    "
            ],
            o: $70ffe59a062c58e0$var$Te($70ffe59a062c58e0$var$h),
            i: 0,
            u: (e)=>({
                    lang: void 0,
                    text: $70ffe59a062c58e0$var$Fe($70ffe59a062c58e0$var$Se(e[0].replace(/^ {4}/gm, "")))
                }),
            l: (e, r, t)=>W("pre", {
                    key: t.key
                }, W("code", $70ffe59a062c58e0$var$n({}, e.attrs, {
                    className: e.lang ? "lang-" + e.lang : ""
                }), e.text))
        },
        4: {
            t: [
                "```",
                "~~~"
            ],
            o: $70ffe59a062c58e0$var$Te($70ffe59a062c58e0$var$y),
            i: 0,
            u: (e)=>({
                    attrs: ce("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            t: [
                "`"
            ],
            o: $70ffe59a062c58e0$var$Ie($70ffe59a062c58e0$var$g),
            i: 3,
            u: (e)=>({
                    text: $70ffe59a062c58e0$var$Fe(e[2])
                }),
            l: (e, n, r)=>W("code", {
                    key: r.key
                }, e.text)
        },
        6: {
            t: [
                "[^"
            ],
            o: $70ffe59a062c58e0$var$Te($70ffe59a062c58e0$var$x),
            i: 0,
            u: (e)=>(ie.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            l: $70ffe59a062c58e0$var$Ve
        },
        7: {
            t: [
                "[^"
            ],
            o: $70ffe59a062c58e0$var$Ce($70ffe59a062c58e0$var$q),
            i: 1,
            u: (e)=>({
                    target: "#" + l(e[1], $70ffe59a062c58e0$export$c383cdd2a518017a),
                    text: e[1]
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href")
                }, W("sup", {
                    key: r.key
                }, e.text))
        },
        8: {
            t: [
                "[ ]",
                "[x]"
            ],
            o: $70ffe59a062c58e0$var$Ce($70ffe59a062c58e0$var$$),
            i: 1,
            u: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            l: (e, n, r)=>W("input", {
                    checked: e.completed,
                    key: r.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            t: [
                "#"
            ],
            o: $70ffe59a062c58e0$var$Te(t.enforceAtxHeadings ? $70ffe59a062c58e0$var$z : $70ffe59a062c58e0$var$S),
            i: 1,
            u: (e, n, r)=>({
                    children: $70ffe59a062c58e0$var$Pe(n, e[2], r),
                    id: l(e[2], $70ffe59a062c58e0$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            l: (e, n, r)=>W("h" + e.level, {
                    id: e.id,
                    key: r.key
                }, n(e.children, r))
        },
        10: {
            t: (e)=>{
                const n = e.indexOf("\n");
                return n > 0 && n < e.length - 1 && ("=" === e[n + 1] || "-" === e[n + 1]);
            },
            o: $70ffe59a062c58e0$var$Te($70ffe59a062c58e0$var$E),
            i: 1,
            u: (e, n, r)=>({
                    children: $70ffe59a062c58e0$var$Pe(n, e[1], r),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            t: [
                "<"
            ],
            o: $70ffe59a062c58e0$var$Me($70ffe59a062c58e0$var$A),
            i: 1,
            u (e, n, r) {
                const [, t] = e[3].match($70ffe59a062c58e0$var$ae), o = RegExp("^" + t, "gm"), a = e[3].replace(o, ""), i = Q(H, a) ? $70ffe59a062c58e0$var$Ne : $70ffe59a062c58e0$var$Pe, u = e[1].toLowerCase(), l = -1 !== $70ffe59a062c58e0$var$c.indexOf(u), s = (l ? u : e[1]).trim(), f = {
                    attrs: ce(s, e[2]),
                    noInnerParse: l,
                    tag: s
                };
                if (r.inAnchor = r.inAnchor || "a" === u, l) f.text = e[3];
                else {
                    const e = r.inHTML;
                    r.inHTML = !0, f.children = i(n, a, r), r.inHTML = e;
                }
                return r.inAnchor = !1, f;
            },
            l: (e, r, t)=>W(e.tag, $70ffe59a062c58e0$var$n({
                    key: t.key
                }, e.attrs), e.text || (e.children ? r(e.children, t) : ""))
        },
        13: {
            t: [
                "<"
            ],
            o: $70ffe59a062c58e0$var$Me($70ffe59a062c58e0$var$O),
            i: 1,
            u (e) {
                const n = e[1].trim();
                return {
                    attrs: ce(n, e[2] || ""),
                    tag: n
                };
            },
            l: (e, r, t)=>W(e.tag, $70ffe59a062c58e0$var$n({}, e.attrs, {
                    key: t.key
                }))
        },
        12: {
            t: [
                "\x3c!--"
            ],
            o: $70ffe59a062c58e0$var$Me($70ffe59a062c58e0$var$B),
            i: 1,
            u: ()=>({}),
            l: $70ffe59a062c58e0$var$Ve
        },
        14: {
            t: [
                "!["
            ],
            o: $70ffe59a062c58e0$var$Ie($70ffe59a062c58e0$var$be),
            i: 1,
            u: (e)=>({
                    alt: $70ffe59a062c58e0$var$Fe(e[1]),
                    target: $70ffe59a062c58e0$var$Fe(e[2]),
                    title: $70ffe59a062c58e0$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("img", {
                    key: r.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: G(e.target, "img", "src")
                })
        },
        15: {
            t: [
                "["
            ],
            o: $70ffe59a062c58e0$var$Ce($70ffe59a062c58e0$var$ve),
            i: 3,
            u: (e, n, r)=>({
                    children: $70ffe59a062c58e0$var$Ze(n, e[1], r),
                    target: $70ffe59a062c58e0$var$Fe(e[2]),
                    title: $70ffe59a062c58e0$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href"),
                    title: e.title
                }, n(e.children, r))
        },
        16: {
            t: [
                "<"
            ],
            o: $70ffe59a062c58e0$var$Ce($70ffe59a062c58e0$var$I),
            i: 0,
            u (e) {
                let n = e[1], r = !1;
                return -1 !== n.indexOf("@") && -1 === n.indexOf("//") && (r = !0, n = n.replace("mailto:", "")), {
                    children: [
                        {
                            text: n,
                            type: "27"
                        }
                    ],
                    target: r ? "mailto:" + n : n,
                    type: "15"
                };
            }
        },
        17: {
            t: (e, n)=>!n.inAnchor && !t.disableAutoLink && ($70ffe59a062c58e0$var$ze(e, "http://") || $70ffe59a062c58e0$var$ze(e, "https://")),
            o: $70ffe59a062c58e0$var$Ce($70ffe59a062c58e0$var$C),
            i: 0,
            u: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        20: $70ffe59a062c58e0$var$qe(W, 1),
        33: $70ffe59a062c58e0$var$qe(W, 2),
        19: {
            t: [
                "\n"
            ],
            o: $70ffe59a062c58e0$var$Te($70ffe59a062c58e0$var$m),
            i: 3,
            u: $70ffe59a062c58e0$var$Ue,
            l: ()=>"\n"
        },
        21: {
            o: $70ffe59a062c58e0$var$je(function(e, n) {
                if (n.inline || n.simple || n.inHTML && -1 === e.indexOf("\n\n") && -1 === n.prevCapture.indexOf("\n\n")) return null;
                let r = "", t = 0;
                for(;;){
                    const n = e.indexOf("\n", t), o = e.slice(t, -1 === n ? void 0 : n + 1);
                    if (Q(V, o)) break;
                    if (r += o, -1 === n || !o.trim()) break;
                    t = n + 1;
                }
                const o = $70ffe59a062c58e0$var$Se(r);
                return "" === o ? null : [
                    r,
                    ,
                    o
                ];
            }),
            i: 3,
            u: $70ffe59a062c58e0$var$Ge,
            l: (e, n, r)=>W("p", {
                    key: r.key
                }, n(e.children, r))
        },
        22: {
            t: [
                "["
            ],
            o: $70ffe59a062c58e0$var$Ce($70ffe59a062c58e0$var$D),
            i: 0,
            u: (e)=>(ue[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            l: $70ffe59a062c58e0$var$Ve
        },
        23: {
            t: [
                "!["
            ],
            o: $70ffe59a062c58e0$var$Ie($70ffe59a062c58e0$var$F),
            i: 0,
            u: (e)=>({
                    alt: e[1] ? $70ffe59a062c58e0$var$Fe(e[1]) : void 0,
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("img", {
                    key: r.key,
                    alt: e.alt,
                    src: G(ue[e.ref].target, "img", "src"),
                    title: ue[e.ref].title
                }) : null
        },
        24: {
            t: (e)=>"[" === e[0] && -1 === e.indexOf("]("),
            o: $70ffe59a062c58e0$var$Ce($70ffe59a062c58e0$var$P),
            i: 0,
            u: (e, n, r)=>({
                    children: n(e[1], r),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("a", {
                    key: r.key,
                    href: G(ue[e.ref].target, "a", "href"),
                    title: ue[e.ref].title
                }, n(e.children, r)) : W("span", {
                    key: r.key
                }, e.fallbackChildren)
        },
        25: {
            t: [
                "|"
            ],
            o: $70ffe59a062c58e0$var$Te($70ffe59a062c58e0$var$M),
            i: 1,
            u: $70ffe59a062c58e0$var$Le,
            l (e, n, r) {
                const t = e;
                return W("table", {
                    key: r.key
                }, W("thead", null, W("tr", null, t.header.map(function(e, o) {
                    return W("th", {
                        key: o,
                        style: $70ffe59a062c58e0$var$Oe(t, o)
                    }, n(e, r));
                }))), W("tbody", null, t.cells.map(function(e, o) {
                    return W("tr", {
                        key: o
                    }, e.map(function(e, o) {
                        return W("td", {
                            key: o,
                            style: $70ffe59a062c58e0$var$Oe(t, o)
                        }, n(e, r));
                    }));
                })));
            }
        },
        27: {
            o: $70ffe59a062c58e0$var$je(function(e, n) {
                let r;
                return $70ffe59a062c58e0$var$ze(e, ":") && (r = $70ffe59a062c58e0$var$ee.exec(e)), r || $70ffe59a062c58e0$var$te.exec(e);
            }),
            i: 4,
            u (e) {
                const n = e[0];
                return {
                    text: -1 === n.indexOf("&") ? n : n.replace($70ffe59a062c58e0$var$R, (e, n)=>t.namedCodesToUnicode[n] || e)
                };
            },
            l: (e)=>e.text
        },
        28: {
            t: [
                "**",
                "__"
            ],
            o: $70ffe59a062c58e0$var$Ie($70ffe59a062c58e0$var$J),
            i: 2,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("strong", {
                    key: r.key
                }, n(e.children, r))
        },
        29: {
            t: (e)=>{
                const n = e[0];
                return ("*" === n || "_" === n) && e[1] !== n;
            },
            o: $70ffe59a062c58e0$var$Ie($70ffe59a062c58e0$var$K),
            i: 3,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("em", {
                    key: r.key
                }, n(e.children, r))
        },
        30: {
            t: [
                "\\"
            ],
            o: $70ffe59a062c58e0$var$Ie($70ffe59a062c58e0$var$ne),
            i: 1,
            u: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            t: [
                "=="
            ],
            o: $70ffe59a062c58e0$var$Ie($70ffe59a062c58e0$var$X),
            i: 3,
            u: $70ffe59a062c58e0$var$Ge,
            l: (e, n, r)=>W("mark", {
                    key: r.key
                }, n(e.children, r))
        },
        32: {
            t: [
                "~~"
            ],
            o: $70ffe59a062c58e0$var$Ie($70ffe59a062c58e0$var$Y),
            i: 3,
            u: $70ffe59a062c58e0$var$Ge,
            l: (e, n, r)=>W("del", {
                    key: r.key
                }, n(e.children, r))
        }
    };
    !0 === t.disableParsingRawHTML && (delete le[11], delete le[13]);
    const se = function(e) {
        var n = Object.keys(e);
        function r(t, o) {
            var a = [];
            if (o.prevCapture = o.prevCapture || "", t.trim()) for(; t;)for(var c = 0; c < n.length;){
                var i = n[c], u = e[i];
                if (!u.t || $70ffe59a062c58e0$var$Ee(t, o, u.t)) {
                    var l = u.o(t, o);
                    if (l && l[0]) {
                        t = t.substring(l[0].length);
                        var s = u.u(l, r, o);
                        o.prevCapture += l[0], s.type || (s.type = i), a.push(s);
                        break;
                    }
                    c++;
                } else c++;
            }
            return o.prevCapture = "", a;
        }
        return n.sort(function(n, r) {
            return e[n].i - e[r].i || (n < r ? -1 : 1);
        }), function(e, n) {
            return r(function(e) {
                return e.replace($70ffe59a062c58e0$var$k, "\n").replace($70ffe59a062c58e0$var$v, "").replace($70ffe59a062c58e0$var$N, "    ");
            }(e), n);
        };
    }(le), fe = function(e, n) {
        return function r(t, o = {}) {
            if (Array.isArray(t)) {
                const e = o.key, n = [];
                let a = !1;
                for(let e = 0; e < t.length; e++){
                    o.key = e;
                    const c = r(t[e], o), i = $70ffe59a062c58e0$var$$e(c);
                    i && a ? n[n.length - 1] += c : null !== c && n.push(c), a = i;
                }
                return o.key = e, n;
            }
            return function(r, t, o) {
                const a = e[r.type].l;
                return n ? n(()=>a(r, t, o), r, t, o) : a(r, t, o);
            }(t, r, o);
        };
    }(le, t.renderRule), _e = re(r);
    return ie.length ? W("div", null, _e, W("footer", {
        key: "footer"
    }, ie.map(function(e) {
        return W("div", {
            id: l(e.identifier, $70ffe59a062c58e0$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, fe(se(e.footnote, {
            inline: !0
        })));
    }))) : _e;
}
var $70ffe59a062c58e0$export$2e2bcd8739ae039 = (n)=>{
    let { children: t, options: o } = n, a = function(e, n) {
        if (null == e) return {};
        var r, t, o = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (o[r] = e[r]);
        return o;
    }(n, $70ffe59a062c58e0$var$r);
    return $bSJIT.cloneElement($70ffe59a062c58e0$export$69f434acfbdb0b32(null == t ? "" : t, o), a);
};

});

parcelRegister("3G9Rl", function(module, exports) {
$parcel$export(module.exports, "default", () => $0774f04dd9bd85ea$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $0774f04dd9bd85ea$var$listStyles = null;
const $0774f04dd9bd85ea$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("ul", {
        ...props,
        className: (0, $9fU1q.default)([
            "_19bvv47k _bozgv47k"
        ])
    }, children);
var $0774f04dd9bd85ea$export$2e2bcd8739ae039 = $0774f04dd9bd85ea$var$UList;

});


parcelRegister("eo7PH", function(module, exports) {
$parcel$export(module.exports, "default", () => $efd765e9d5640c34$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $2fwRK = parcelRequire("2fwRK");
const $efd765e9d5640c34$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    (0, $bSJIT.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $efd765e9d5640c34$export$2e2bcd8739ae039 = $efd765e9d5640c34$var$AIEventSummaryViewed;

});



parcelRegister("cSsro", function(module, exports) {
$parcel$export(module.exports, "default", () => $01fae2075dc55b00$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $3rqjK = parcelRequire("3rqjK");

var $3Qn1E = parcelRequire("3Qn1E");
const $01fae2075dc55b00$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $bSJIT.useRef)(false);
    const previewBlockRef = (0, $bSJIT.useRef)(null);
    const [showPreview, setShowPreview] = (0, $bSJIT.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $bSJIT.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $bSJIT.useCallback)(()=>{
        if (previewBlockRef.current) {
            var _previewBlockRef$curr;
            const previewHeight = (_previewBlockRef$curr = previewBlockRef.current) === null || _previewBlockRef$curr === void 0 ? void 0 : _previewBlockRef$curr.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $bSJIT.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $bSJIT.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $3rqjK.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3Qn1E.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $01fae2075dc55b00$export$2e2bcd8739ae039 = $01fae2075dc55b00$var$ImagePreview;

});
parcelRegister("3rqjK", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $70666405dbbd3a3d$export$a79836076066b8b6);

var $3pz0i = parcelRequire("3pz0i");

var $4gDvk = parcelRequire("4gDvk");

var $5kJPq = parcelRequire("5kJPq");

var $45tZT = parcelRequire("45tZT");
const $70666405dbbd3a3d$export$a79836076066b8b6 = (response)=>{
    if (!response || !(response !== null && response !== void 0 && response.data)) return undefined;
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _entity$thumbnail;
        const entity = (0, $3pz0i.extractEntity)(response);
        let url = entity === null || entity === void 0 || (_entity$thumbnail = entity.thumbnail) === null || _entity$thumbnail === void 0 ? void 0 : _entity$thumbnail.externalUrl;
        return url ? {
            type: (0, $5kJPq.MediaType).Image,
            url: url
        } : undefined;
    }
    return (0, $45tZT.extractPreview)(response.data);
};

});
parcelRegister("45tZT", function(module, exports) {
$parcel$export(module.exports, "extractPreview", () => $23f34b6a6194f555$export$4b0d98b1b7f6d115);

var $3PfqO = parcelRequire("3PfqO");

var $5kJPq = parcelRequire("5kJPq");
const $23f34b6a6194f555$export$4b0d98b1b7f6d115 = (data)=>{
    if (!data) return undefined;
    const url = (0, $3PfqO.extractImage)(data);
    return url ? {
        type: (0, $5kJPq.MediaType).Image,
        url: url
    } : undefined;
};

});
parcelRegister("3PfqO", function(module, exports) {
$parcel$export(module.exports, "extractImage", () => $46ab8d6931940a8d$export$4c753a1297cb9805);

var $dtKl2 = parcelRequire("dtKl2");
const $46ab8d6931940a8d$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $dtKl2.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $dtKl2.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};

});





parcelRegister("diK8z", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc57c4ed17b42108$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $18x1K = parcelRequire("18x1K");

var $goesr = parcelRequire("goesr");

var $8dLhi = parcelRequire("8dLhi");

var $836bz = parcelRequire("836bz");

var $loBKq = parcelRequire("loBKq");
const $dc57c4ed17b42108$var$loadingViewContainer = null;
const $dc57c4ed17b42108$var$skeletonContainer = null;
const $dc57c4ed17b42108$var$titleStyle = null;
const $dc57c4ed17b42108$var$titleBlockStyles = null;
const $dc57c4ed17b42108$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $loBKq.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = (actions === null || actions === void 0 ? void 0 : actions.length) && (actions === null || actions === void 0 ? void 0 : actions.length) > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $goesr.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _2lx21bp4 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8dLhi.default), {
        ...titleBlockProps,
        testId: `${testId}-title-block`,
        className: (0, $9fU1q.default)([
            "_zulpu2gc _1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $836bz.default), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $18x1K.LoadingSkeleton), null),
        size: size
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        "data-testid": `${testId}-title`,
        className: (0, $9fU1q.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $18x1K.LoadingSkeleton), {
        height: `${lineHeightRem}rem`
    })), actionGroup), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $18x1K.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $18x1K.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem * 3}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $18x1K.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }))));
};
var $dc57c4ed17b42108$export$2e2bcd8739ae039 = $dc57c4ed17b42108$var$HoverCardLoadingView;

});

parcelRegister("5WhMr", function(module, exports) {
$parcel$export(module.exports, "default", () => $b49b224b16ecc098$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5cKiX = parcelRequire("5cKiX");

var $gxIo9 = parcelRequire("gxIo9");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $2JDIg = parcelRequire("2JDIg");

var $6sagi = parcelRequire("6sagi");

var $50jzR = parcelRequire("50jzR");

var $dkOB1 = parcelRequire("dkOB1");

var $goesr = parcelRequire("goesr");

var $8dLhi = parcelRequire("8dLhi");

var $lgzQp = parcelRequire("lgzQp");
const $b49b224b16ecc098$var$connectButtonStyles = null;
const $b49b224b16ecc098$var$titleBlockStyles = null;
const $b49b224b16ecc098$var$mainTextStyles = null;
const $b49b224b16ecc098$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    var _extractSmartLinkProv;
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (_extractSmartLinkProv = (0, $gxIo9.extractSmartLinkProvider)(cardState.details)) === null || _extractSmartLinkProv === void 0 ? void 0 : _extractSmartLinkProv.text;
    const isProductIntegrationSupported = (0, $6sagi.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $2JDIg.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const handleAuthorize = (0, $bSJIT.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5kJPq.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $bSJIT.useMemo)(()=>[
            {
                name: (0, $5kJPq.ActionName).CustomAction,
                content: /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
                    ...(0, $7wYyA.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $dkOB1.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        testId: `${testId}-title`,
        className: (0, $9fU1q.default)([
            "_zulpu2gc _13mh1pd9"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $lgzQp.default), null), /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $7wYyA.messages).connect_link_account_card_name,
        values: {
            context: providerName
        }
    })), /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        testId: `${testId}-content`,
        className: (0, $9fU1q.default)([
            "_11c8wadc _19pku2gc"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", null, /*#__PURE__*/ $bSJIT.createElement((0, $50jzR.default), {
        providerName: providerName,
        isProductIntegrationSupported: isProductIntegrationSupported
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        testId: `${testId}-button`,
        className: (0, $9fU1q.default)([
            "_1bahesu3 _19pku2gc"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $goesr.default), {
        items: actions,
        appearance: "primary"
    })));
};
var $b49b224b16ecc098$export$2e2bcd8739ae039 = $b49b224b16ecc098$var$HoverCardUnauthorisedView;

});
parcelRegister("6sagi", function(module, exports) {
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $dd7bc57e56255c4a$export$3f9446bb21b945a0);
const $dd7bc57e56255c4a$export$3f9446bb21b945a0 = (details)=>!!(details !== null && details !== void 0 && details.meta.hasScopeOverrides);

});

parcelRegister("50jzR", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8bfd456c285862e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $gdUUy = parcelRequire("gdUUy");

var $bLXMw = parcelRequire("bLXMw");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $d8bfd456c285862e$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $bSJIT.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $gdUUy.fg)('product-terminology-refresh') ? (0, $7wYyA.messages).learn_more_about_connecting_account_appify : (0, $7wYyA.messages).learn_more_about_connecting_account : (0, $7wYyA.messages).learn_more_about_smart_links;
    const unauthorizedAccountDescriptionMessage = (0, $7wYyA.messages).learn_more_about_connecting_account_experiment_shorter;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...unauthorizedAccountDescriptionMessage,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $gdUUy.fg)('product-terminology-refresh') ? (0, $7wYyA.messages).connect_unauthorised_account_description_no_provider_appify : (0, $7wYyA.messages).connect_unauthorised_account_description_no_provider), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bLXMw.Anchor), {
        href: isProductIntegrationSupported ? (0, $5kJPq.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5kJPq.CONTENT_URL_SECURITY_AND_PERMISSIONS),
        target: "_blank",
        testId: `${testId}-learn-more`,
        onClick: handleLearnMoreClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), learnMoreMessage)));
};
var $d8bfd456c285862e$export$2e2bcd8739ae039 = $d8bfd456c285862e$var$UnauthorisedViewContent;

});


parcelRegister("2oAb9", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ecf331ad352de6a$export$2e2bcd8739ae039);
/* RovoUnauthorisedView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5cKiX = parcelRequire("5cKiX");

var $jNJGJ = parcelRequire("jNJGJ");

var $9H9S7 = parcelRequire("9H9S7");

var $gRfjb = parcelRequire("gRfjb");

var $3Vt8T = parcelRequire("3Vt8T");

var $gxIo9 = parcelRequire("gxIo9");

var $iajVF = parcelRequire("iajVF");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $2JDIg = parcelRequire("2JDIg");

var $dkOB1 = parcelRequire("dkOB1");

var $lgzQp = parcelRequire("lgzQp");

var $dkMrP = parcelRequire("dkMrP");

var $cxA6v = parcelRequire("cxA6v");

var $gRwb1 = parcelRequire("gRwb1");
const $2ecf331ad352de6a$var$ROVO_FEATURES = [
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))),
        message: (0, $7wYyA.messages).rovo_unauthorised_feature_clear_link_names,
        testIdSuffix: 'clear-link-names'
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9H9S7))),
        message: (0, $7wYyA.messages).rovo_unauthorised_feature_understand_linked_docs,
        testIdSuffix: 'understand-linked-docs'
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Vt8T))),
        message: (0, $7wYyA.messages).rovo_unauthorised_feature_go_deeper_smart_suggestions,
        testIdSuffix: 'go-deeper-smart-suggestions'
    }
];
const $2ecf331ad352de6a$var$sparkleWrapBase = null;
const $2ecf331ad352de6a$var$sparkleLeftWrap = null;
const $2ecf331ad352de6a$var$sparkleGreyRightWrap = null;
const $2ecf331ad352de6a$var$sparkleVioletRightWrap = null;
const $2ecf331ad352de6a$var$layoutStyles = {
    connectorStroke: "_syaz1fxt _1e0c1txw _1o9zidpf",
    atlassianIconTile: "_2rko1mok _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _bfhk16e3",
    header: "_bfhk11bn _ca0q1ejb _u5f3pxbi _n3tdutpp _19bvpxbi _13li1mok _qrwq1mok _kqswh2mm",
    headerGraphicRow: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1h6o _otyrutpp",
    headerTitle: "_y3gn1h6o",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    featureIconCell: "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb7vkz",
    footer: "_zulputpp _19pkutpp _ca0q1b66 _1e0c1txw _4cvr1h6o _1bahesu3 _1n261g80"
};
const $2ecf331ad352de6a$var$RovoUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, onDismiss: onDismiss, testId: testId = 'hover-card-rovo-unauthorised-view', url: url })=>{
    const providerName = (0, $bSJIT.useMemo)(()=>{
        var _extractSmartLinkProv;
        return (_extractSmartLinkProv = (0, $gxIo9.extractSmartLinkProvider)(flexibleCardProps.cardState.details)) === null || _extractSmartLinkProv === void 0 ? void 0 : _extractSmartLinkProv.text;
    }, [
        flexibleCardProps.cardState.details
    ]);
    const { authorize: authorize } = (0, $2JDIg.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const handleAuthorize = (0, $bSJIT.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5kJPq.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const handleDismiss = (0, $bSJIT.useCallback)(()=>{
        if (onDismiss) {
            fireEvent('ui.button.clicked.dismiss', {});
            onDismiss();
        }
    }, [
        fireEvent,
        onDismiss
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $dkOB1.default), {
        ...flexibleCardProps,
        testId: testId,
        ui: {
            hideElevation: true,
            hideBackground: true,
            removeBlockRestriction: true,
            hidePadding: true
        }
    }, /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $2ecf331ad352de6a$var$layoutStyles.header
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1o9zidpf _1e0c1txw _kqswstnw",
            "_syaz1yjp _154i1ul9 _1ltv1v6z"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $dkMrP.DenseSparkle), null)), /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1o9zidpf _1e0c1txw _kqswstnw",
            "_syazwejn _154i1crf _1xi2qslr"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cxA6v.SparseSparkle), null)), /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1o9zidpf _1e0c1txw _kqswstnw",
            "_syazuq3u _1bsbqslr _154i1ylp _1xi21v6z"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $dkMrP.DenseSparkle), null)), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $2ecf331ad352de6a$var$layoutStyles.headerGraphicRow
    }, /*#__PURE__*/ $bSJIT.createElement((0, $lgzQp.default), {
        size: (0, $5kJPq.SmartLinkSize).Medium,
        isTiledIcon: true
    }), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $2ecf331ad352de6a$var$layoutStyles.connectorStroke
    }, /*#__PURE__*/ $bSJIT.createElement((0, $gRwb1.SquiglyArrow), null)), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $2ecf331ad352de6a$var$layoutStyles.atlassianIconTile
    }, /*#__PURE__*/ $bSJIT.createElement((0, $iajVF.AtlassianIcon), {
        appearance: "inverse",
        size: "small"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $2ecf331ad352de6a$var$layoutStyles.headerTitle
    }, /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), {
        weight: "bold",
        size: "medium",
        color: "color.text"
    }, providerName ? /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $7wYyA.messages).rovo_unauthorised_title,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).rovo_unauthorised_title_no_provider)))), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $2ecf331ad352de6a$var$layoutStyles.body
    }, /*#__PURE__*/ $bSJIT.createElement((0, $dDEhr.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $dDEhr.Stack), {
        space: "space.200"
    }, $2ecf331ad352de6a$var$ROVO_FEATURES.map((feature)=>{
        const FeatureIcon = feature.icon;
        return /*#__PURE__*/ $bSJIT.createElement((0, $fZ0ZI.Inline), {
            key: feature.testIdSuffix,
            space: "space.150",
            alignBlock: "center",
            testId: `${testId}-feature-${feature.testIdSuffix}`
        }, /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            xcss: $2ecf331ad352de6a$var$layoutStyles.featureIconCell
        }, /*#__PURE__*/ $bSJIT.createElement(FeatureIcon, {
            label: ""
        })), /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), feature.message)));
    })), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $2ecf331ad352de6a$var$layoutStyles.footer
    }, /*#__PURE__*/ $bSJIT.createElement((0, $fZ0ZI.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $jNJGJ.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handleDismiss,
        testId: `${testId}-not-now`
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).rovo_unauthorised_not_now)), /*#__PURE__*/ $bSJIT.createElement((0, $jNJGJ.default), {
        appearance: "primary",
        onClick: handleAuthorize,
        testId: `${testId}-connect-account`
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).rovo_unauthorised_connect_account)))))));
};
var $2ecf331ad352de6a$export$2e2bcd8739ae039 = $2ecf331ad352de6a$var$RovoUnauthorisedView;

});
parcelRegister("dkMrP", function(module, exports) {
$parcel$export(module.exports, "DenseSparkle", () => $9ccf23bc53d5fad9$export$eaa6832866c251cf);
/* DenseSparkle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");
const $9ccf23bc53d5fad9$export$eaa6832866c251cf = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "currentColor",
        d: "M 18.1377,8.5584 C 19.820521,9.7606431 19.569624,7.0234324 19.891314,6.0724492 20.627318,4.4834923 20.654624,2.6485663 20.986387,0.9358225 20.985763,-0.63106096 19.153938,0.29529924 19.30907,1.4628594 18.581402,3.0380165 18.941526,4.9281736 18.3064,6.59809 18.189624,7.241971 17.98497,7.9130416 18.1377,8.5584 Z M 14.048,8.62872 C 16.108587,8.8291383 14.519035,6.5848441 14.323941,5.6001158 14.16595,3.856369 13.270155,2.254813 12.701225,0.60606587 11.918719,-0.74933808 10.791962,0.96396467 11.513059,1.8973545 11.672048,3.6244988 12.925689,5.0825474 13.2127,6.8456 13.436435,7.4621245 13.581302,8.1376081 14.048,8.62872 Z M 10.5438,10.7324 C 12.427639,9.875884 9.9317744,8.7259408 9.2689606,7.9718267 8.2625,6.5396335 6.6886891,5.5966404 5.36875,4.4566662 4.0131223,3.6745583 3.8966957,5.7235932 4.9866023,6.1718516 5.9867147,7.5895644 7.8032328,8.2251817 8.93219,9.61022 9.4294433,10.031063 9.9148481,10.555839 10.5438,10.7324 Z M 8.55828,14.3099 C 9.7604964,12.627122 7.023384,12.877794 6.0723265,12.556262 4.4833477,11.820331 2.6484558,11.792914 0.93570025,11.461212 c -1.5668845,6.26e-4 -0.64052126,1.832452 0.52703915,1.677318 1.5751539,0.727694 3.4653396,0.36738 5.1352306,1.00267 0.6438861,0.116827 1.314933,0.321333 1.96031,0.1687 z m 0.07008,4.0894 C 8.828733,16.338698 6.5844599,17.928323 5.5997508,18.123433 3.8560002,18.281408 2.2543901,19.1771 0.60569938,19.746162 -0.74955704,20.529217 0.96332374,21.653982 1.8969889,20.93548 3.6240071,20.774217 5.0821994,19.522267 6.84523,19.2346 7.4618123,19.010984 8.1372369,18.866007 8.62836,18.3993 Z m 2.10414,3.5072 C 9.8760472,20.022637 8.7260556,22.518484 7.9719398,23.181273 6.5393153,24.18655 5.6000777,25.76278 4.4595963,27.081513 3.6775168,28.437135 5.7265095,28.553572 6.1747816,27.463666 7.5925047,26.463552 8.2280912,24.647029 9.61315,23.5181 c 0.418283,-0.497326 0.951352,-0.985318 1.11935,-1.6116 z m 3.5775,1.9828 c -1.682815,-1.202255 -1.431924,1.534991 -1.753614,2.485976 -0.736023,1.588942 -0.763314,3.423872 -1.095073,5.136612 6.39e-4,1.566887 1.832425,0.640518 1.677317,-0.527032 0.727655,-1.57517 0.367555,-3.465328 1.00267,-5.135256 0.116772,-0.64388 0.321426,-1.314917 0.1687,-1.9603 z m 4.0891,-0.0702 c -2.060649,-0.200406 -0.470945,2.043891 -0.275873,3.028605 0.157937,1.743716 1.053669,3.345319 1.622686,4.994007 0.782496,1.355437 1.909207,-0.357878 1.188142,-1.291274 C 20.77504,28.823312 19.521385,27.365256 19.2344,25.6022 19.010647,24.985692 18.865809,24.310193 18.3991,23.8191 Z m 3.5074,-2.1038 c -1.88386,0.856461 0.611976,2.006423 1.274773,2.760542 1.006466,1.432207 2.580314,2.375182 3.90024,3.515183 1.355682,0.782012 1.472001,-1.26689 0.382153,-1.715209 C 26.463526,24.858147 24.647022,24.222555 23.5181,22.8375 23.02082,22.416678 22.53553,21.891757 21.9065,21.7153 Z m 1.9826,-3.5775 c -1.202233,1.682763 1.53485,1.432123 2.485905,1.753638 1.588978,0.735928 3.423859,0.763338 5.136608,1.095049 1.566893,-5.94e-4 0.640594,-1.832443 -0.527,-1.677317 C 29.409454,18.581486 27.519286,18.941792 25.8494,18.3065 25.205557,18.189667 24.534178,17.985164 23.8891,18.1378 Z m -0.0704,-4.0894 c -0.200405,2.06064 2.043899,0.470968 3.028605,0.275867 1.743759,-0.15797 3.345359,-1.053678 4.994083,-1.622679 1.355308,-0.782551 -0.357965,-1.909199 -1.29135,-1.188185 -1.727151,0.159054 -3.185218,1.412574 -4.948238,1.699697 -0.616574,0.223619 -1.291971,0.368616 -1.7831,0.8353 z M 21.7152,10.544 c 0.85645,1.88385 2.006449,-0.6119565 2.760542,-1.2747918 1.432624,-1.0052563 2.371905,-2.581444 3.512333,-3.9002107 C 28.770204,4.0133778 26.721159,3.8969258 26.272916,4.986848 24.855171,5.9869493 24.21954,7.8034667 22.8345,8.93243 22.416234,9.4297408 21.883198,9.917751 21.7152,10.544 Z"
    }));
};

});

parcelRegister("cxA6v", function(module, exports) {
$parcel$export(module.exports, "SparseSparkle", () => $66f54c09cdb70f19$export$d4cc5913ef36e057);
/* SparseSparkle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");
const $66f54c09cdb70f19$export$d4cc5913ef36e057 = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement("svg", {
        width: "35",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "currentColor",
        d: "m 21.4614,9.02651 c 1.774882,1.267966 1.510442,-1.6188099 1.849578,-2.6219063 0.776223,-1.6758612 0.805105,-3.61111 1.154947,-5.41753458 C 24.447185,-0.68027653 22.513317,0.28790594 22.69688,1.5429258 21.929419,3.2042498 22.309243,5.1977402 21.6394,6.95899 21.51609,7.6380728 21.300546,8.3458903 21.4614,9.02651 Z m -9.1629,0.611 C 14.479174,9.6115402 12.55696,7.4386694 12.239238,6.4296801 11.873994,4.6211661 10.751762,3.0453042 9.9684287,1.3818975 9.0519692,0.02745097 7.9717763,1.9817201 8.8672911,2.872095 9.2298246,4.664959 10.714117,6.0484595 11.2158,7.86365 c 0.30309,0.6222222 0.536236,1.3131609 1.0827,1.77386 z M 9.02651,14.4282 c 1.267976,-1.774848 -1.6188386,-1.510386 -2.6219063,-1.849578 -1.6758612,-0.776223 -3.61111,-0.805105 -5.41753458,-1.154947 -1.66734565,0.01874 -0.69916318,1.952608 0.55585668,1.769045 1.661324,0.767461 3.6548144,0.387637 5.4160642,1.05748 0.6790828,0.12331 1.3869003,0.338854 2.06752,0.178 z m 0.79812,7.0123 C 9.6506342,19.264889 7.6156756,21.33182 6.6290172,21.715218 4.8462675,22.200193 3.3480398,23.427583 1.7425513,24.327425 0.48184315,25.389439 2.4687817,26.243895 3.3047292,25.323131 5.0679233,24.838194 6.3485808,23.265036 8.1279,22.6448 8.727623,22.296964 9.4030508,22.019757 9.82463,21.4405 Z m 4.60367,2.4235 c -1.774857,-1.267999 -1.510322,1.618845 -1.849554,2.621865 -0.776222,1.675869 -0.805026,3.611122 -1.154946,5.417535 0.01882,1.667361 1.952587,0.699167 1.769034,-0.555848 0.767463,-1.661311 0.387597,-3.654815 1.057466,-5.416052 0.123252,-0.679055 0.338956,-1.387036 0.178,-2.0675 z m 5.9772,0.261 c -2.173333,-0.211383 -0.496768,2.155705 -0.291021,3.19429 0.166568,1.839106 1.111399,3.528228 1.711458,5.267122 0.84816,1.433261 2.042749,-0.366933 1.253122,-1.36187 C 22.911487,29.402909 21.589251,27.865123 21.2864,26.0057 21.05053,25.355401 20.897759,24.642984 20.4055,24.125 Z m 4.3514,-4.2566 c -1.918413,1.03763 0.793683,2.065164 1.542216,2.81224 1.163691,1.434148 2.891651,2.307238 4.359284,3.41661 1.503797,0.716781 1.491809,-1.445265 0.281572,-1.83218 C 29.783911,22.847779 27.827538,22.311391 26.5397,20.9362 25.981077,20.526301 25.453402,20.026312 24.7569,19.8684 Z m 0.2667,-6.5645 c -0.61356,2.094147 2.024993,0.892339 3.082584,0.881972 1.837741,0.184903 3.674321,-0.429733 5.494903,-0.694759 1.566146,-0.568664 0.02093,-2.078292 -1.105917,-1.48934 -1.8201,-0.172658 -3.577509,0.836398 -5.46037,0.783027 -0.682737,0.109486 -1.416687,0.125746 -2.0112,0.5191 z"
    }));
};

});

parcelRegister("gRwb1", function(module, exports) {
$parcel$export(module.exports, "SquiglyArrow", () => $01fb7df0b2e32e60$export$940e84768143d382);
/* SquiglyArrow.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");
const $01fb7df0b2e32e60$export$940e84768143d382 = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement("svg", {
        width: "31",
        height: "21",
        viewBox: "0 0 31 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "currentColor",
        d: "M 21.853446,0.12040609 C 20.167706,1.2017532 24.715673,2.4997309 25.755055,3.0673371 25.02723,3.2209011 21.984019,3.856737 20.991485,3.9633568 16.045179,5.5890307 11.446918,7.8287185 9.1072914,12.742806 7.8983204,12.284216 5.7117383,11.960731 4.1643839,12.645906 2.2323901,13.501397 0.58356937,15.13985 0.06015349,17.184987 0.06666279,19.997869 1.7741124,16.035826 2.7542112,15.14763 c 1.6305676,-1.477671 4.7339707,-2.002323 5.8717147,-1.083896 -0.6742412,2.17406 -0.7914961,6.013849 1.8803011,6.750565 2.072285,0.571408 3.768061,-1.977378 2.786707,-4.245231 C 12.524186,14.792533 11.187386,13.937797 10.469825,13.425746 12.484573,8.4842061 19.328854,5.5947574 24.21859,4.6647774 25.288915,4.5397793 29.069777,3.0700705 27.388804,4.826459 26.472831,6.3589647 23.793814,8.1658647 23.628028,9.0737265 23.1618,11.626835 26.092344,8.4605266 26.699318,7.7349157 27.826169,6.2825775 29.856947,4.4211835 30.479445,3.5562506 28.766042,2.8991905 26.575439,1.3555612 24.569756,0.89998649 23.662177,0.65006782 22.790889,0.24992986 21.853446,0.12040609 Z M 9.9983561,14.652336 C 11.498101,15.3957 13.411213,18.565161 11.127761,19.347839 9.1996093,18.911365 9.5916528,16.22149 9.9983561,14.652336 Z"
    }));
};

});



parcelRegister("9nMlY", function(module, exports) {
$parcel$export(module.exports, "createCustomPopupContainer", () => $66d937448e96d2a7$export$c98f335200f1c8df);

var $bSJIT = parcelRequire("bSJIT");
const $66d937448e96d2a7$export$c98f335200f1c8df = (zIndex)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(// FIXME: ...props spreads all props to the div, including isReferenceHidden, which is not a valid prop for a div.
    // Find another way but adding exceptions with _, __, ___ etc.
    ({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            ...props,
            ref: ref,
            ...zIndex !== undefined && {
                style: {
                    ...props.style,
                    zIndex: zIndex
                }
            }
        }, children));
};

});




parcelRegister("9HFNL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad0ce6430181c72e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $e6VxI = parcelRequire("e6VxI");
const $ad0ce6430181c72e$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $ad0ce6430181c72e$var$LayeredLink = ({ onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $e6VxI.useMouseDownEvent)();
    return /*#__PURE__*/ $bSJIT.createElement("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        target: target
    }, text);
};
var $ad0ce6430181c72e$export$2e2bcd8739ae039 = $ad0ce6430181c72e$var$LayeredLink;

});


parcelRegister("b653z", function(module, exports) {
$parcel$export(module.exports, "getContextByStatus", () => $e812ef08e3dcc76a$export$e68aec76e359e401);

var $5kJPq = parcelRequire("5kJPq");

var $2ssPK = parcelRequire("2ssPK");

var $hnrQI = parcelRequire("hnrQI");

var $bA7XK = parcelRequire("bA7XK");

var $2p62B = parcelRequire("2p62B");

var $3rqjK = parcelRequire("3rqjK");

var $tM3zz = parcelRequire("tM3zz");

var $5ppN2 = parcelRequire("5ppN2");
const $e812ef08e3dcc76a$export$e68aec76e359e401 = (params)=>{
    var _response$meta;
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5kJPq.SmartLinkStatus).Pending:
        case (0, $5kJPq.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $bA7XK.default)(status, url, response, onClick),
                url: url
            };
        case (0, $5kJPq.SmartLinkStatus).Resolved:
            return (0, $2ssPK.default)(params);
        case (0, $5kJPq.SmartLinkStatus).Unauthorized:
        case (0, $5kJPq.SmartLinkStatus).Forbidden:
        case (0, $5kJPq.SmartLinkStatus).NotFound:
        case (0, $5kJPq.SmartLinkStatus).Errored:
        case (0, $5kJPq.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $tM3zz.extractErrorIcon)(response, status),
                linkTitle: (0, $bA7XK.default)(status, url, response, onClick),
                preview: (0, $3rqjK.extractSmartLinkPreviewImage)(response),
                provider: (0, $2p62B.default)(response),
                actions: {
                    [(0, $5kJPq.InternalActionName).UnresolvedAction]: (0, $5ppN2.getRetryOptions)(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response === null || response === void 0 || (_response$meta = response.meta) === null || _response$meta === void 0 || (_response$meta = _response$meta.requestAccess) === null || _response$meta === void 0 ? void 0 : _response$meta.accessType
                },
                hostName: (0, $hnrQI.extractHostName)(response)
            };
    }
};

});
parcelRegister("2ssPK", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d415df5647ded83$export$2e2bcd8739ae039);

var $b8gs6 = parcelRequire("b8gs6");

var $2NFkZ = parcelRequire("2NFkZ");

var $5wNiA = parcelRequire("5wNiA");

var $kTwBy = parcelRequire("kTwBy");

var $5iAsx = parcelRequire("5iAsx");

var $dvhqv = parcelRequire("dvhqv");

var $lFzjO = parcelRequire("lFzjO");

var $del70 = parcelRequire("del70");

var $fZvKv = parcelRequire("fZvKv");

var $gdUUy = parcelRequire("gdUUy");

var $iAjUk = parcelRequire("iAjUk");

var $5Fq50 = parcelRequire("5Fq50");

var $T8D3J = parcelRequire("T8D3J");

var $aO9xE = parcelRequire("aO9xE");

var $bvW2k = parcelRequire("bvW2k");

var $ijIpD = parcelRequire("ijIpD");

var $20svu = parcelRequire("20svu");

var $kZSLk = parcelRequire("kZSLk");

var $hnrQI = parcelRequire("hnrQI");

var $bA7XK = parcelRequire("bA7XK");

var $jfEhp = parcelRequire("jfEhp");

var $iUj0p = parcelRequire("iUj0p");

var $bMmmp = parcelRequire("bMmmp");

var $1BKH7 = parcelRequire("1BKH7");

var $b5RkV = parcelRequire("b5RkV");

var $cUGMG = parcelRequire("cUGMG");

var $ipyyL = parcelRequire("ipyyL");

var $lIti3 = parcelRequire("lIti3");

var $2p62B = parcelRequire("2p62B");

var $4JLDa = parcelRequire("4JLDa");

var $Z5RbA = parcelRequire("Z5RbA");

var $3rqjK = parcelRequire("3rqjK");

var $2vry8 = parcelRequire("2vry8");

var $ao6i6 = parcelRequire("ao6i6");

var $f1XV8 = parcelRequire("f1XV8");

var $kXEi5 = parcelRequire("kXEi5");

var $2JwUT = parcelRequire("2JwUT");

var $fkpOf = parcelRequire("fkpOf");

var $fqZU4 = parcelRequire("fqZU4");

var $jhIGk = parcelRequire("jhIGk");

var $dFrGy = parcelRequire("dFrGy");

var $gi9Kl = parcelRequire("gi9Kl");

var $9uq6V = parcelRequire("9uq6V");

var $akWIi = parcelRequire("akWIi");

var $ddr4G = parcelRequire("ddr4G");

var $ldLJp = parcelRequire("ldLJp");
const $4d415df5647ded83$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, origin: origin, product: product, resolve: resolve, rovoConfig: rovoConfig, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, transformUrl: transformUrl, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $del70.extractSmartLinkUrl)(response);
    return {
        actions: (0, $5Fq50.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            product: product,
            rovoConfig: rovoConfig,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: // Use the original URL in edge cases, such as short links for AI summary and copy link actions.
            isPreviewPanelAvailable,
            ...(0, $gdUUy.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }),
        appliedToComponentsCount: (0, $aO9xE.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $cUGMG.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $ijIpD.extractAttachmentCount)(data),
        authorGroup: (0, $5wNiA.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $b8gs6.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $T8D3J.extractPersonsUpdatedBy)(data),
        commentCount: (0, $Z5RbA.extractSmartLinkCommentCount)(response),
        viewCount: (0, $9uq6V.extractViewCount)(data),
        reactCount: (0, $2vry8.extractSmartLinkReactCount)(response),
        voteCount: (0, $akWIi.extractVoteCount)(data),
        checklistProgress: (0, $20svu.extractChecklistProgress)(data),
        createdBy: (0, $kTwBy.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $b5RkV.extractOwnedBy)(data),
        assignedTo: (0, $bvW2k.extractAssignedTo)(data),
        createdOn: (0, $5iAsx.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $kZSLk.extractDueOn)(data),
        latestCommit: (0, $ldLJp.extractLatestCommit)(data),
        linkIcon: (0, $ddr4G.extractSmartLinkIcon)(response),
        linkTitle: (0, $bA7XK.default)(status, props.url, response, onClick, onAuxClick, onContextMenu),
        location: (0, $jfEhp.extractLocation)(data),
        modifiedBy: (0, $dvhqv.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $lFzjO.extractSmartLinkModifiedOn)(response),
        preview: (0, $3rqjK.extractSmartLinkPreviewImage)(response),
        priority: (0, $ipyyL.default)(data),
        provider: (0, $2p62B.default)(response),
        programmingLanguage: (0, $lIti3.extractProgrammingLanguage)(data),
        readTime: (0, $4JLDa.extractReadTime)(data),
        sentOn: (0, $ao6i6.extractSmartLinkSentOn)(response),
        snippet: (0, $iAjUk.extractSmartLinkSummary)(response) || undefined,
        // Explicitly set here to remove an empty string
        sourceBranch: (0, $f1XV8.extractSourceBranch)(data),
        state: (0, $kXEi5.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, (0, $gdUUy.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined),
        subscriberCount: (0, $fqZU4.extractSubscriberCount)(data),
        subTasksProgress: (0, $fkpOf.extractSubTasksProgress)(data),
        storyPoints: (0, $2JwUT.extractStoryPoints)(data),
        targetBranch: (0, $jhIGk.extractTargetBranch)(data),
        userAttributes: (0, $gi9Kl.extractUserAttributes)(data),
        teamMemberCount: (0, $dFrGy.extractTeamMemberCount)(data),
        url: url,
        ari: (0, $2NFkZ.extractSmartLinkAri)(response),
        type: (0, $fZvKv.extractType)(data),
        meta: {
            objectId: (0, $iUj0p.extractMetaObjectId)(meta),
            resourceType: (0, $bMmmp.extractMetaResourceType)(meta),
            tenantId: (0, $1BKH7.extractMetaTenantId)(meta)
        },
        hostName: (0, $hnrQI.extractHostName)(response)
    };
};
var $4d415df5647ded83$export$2e2bcd8739ae039 = $4d415df5647ded83$var$extractFlexibleUiContext;

});
parcelRegister("2NFkZ", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkAri", () => $8a52385947c272f8$export$16b02be3e2bb31ad);

var $4FI6h = parcelRequire("4FI6h");

var $3pz0i = parcelRequire("3pz0i");

var $4gDvk = parcelRequire("4gDvk");
const $8a52385947c272f8$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _extractEntity, _extractEntity2;
        return ((_extractEntity = (0, $3pz0i.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.ari) || ((_extractEntity2 = (0, $3pz0i.extractEntity)(response)) === null || _extractEntity2 === void 0 ? void 0 : _extractEntity2.thirdPartyAri);
    }
    const data = response === null || response === void 0 ? void 0 : response.data;
    return (0, $4FI6h.extractAri)(data);
};

});

parcelRegister("5wNiA", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $b0473060be65b28e$export$41fc716e1bc2dc90);

var $3pz0i = parcelRequire("3pz0i");

var $8AlQf = parcelRequire("8AlQf");

var $4gDvk = parcelRequire("4gDvk");
const $b0473060be65b28e$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $4gDvk.isEntityPresent)(response)) {
        const entity = (0, $3pz0i.extractEntity)(response);
        const owners = entity === null || entity === void 0 ? void 0 : entity.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $8AlQf.extractPersonCreatedBy)(response.data);
};

});
parcelRegister("8AlQf", function(module, exports) {
$parcel$export(module.exports, "extractPersonCreatedBy", () => $0b2113bcddb46676$export$a66235cba0c9d11a);

var $aVkT0 = parcelRequire("aVkT0");
const $0b2113bcddb46676$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $aVkT0.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $aVkT0.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};

});


parcelRegister("kTwBy", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $19359c2e91d609f5$export$242875b46118beb2);

var $3pz0i = parcelRequire("3pz0i");

var $8AlQf = parcelRequire("8AlQf");

var $4gDvk = parcelRequire("4gDvk");
const $19359c2e91d609f5$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $3pz0i.extractEntity)(response)) === null || _extractEntity === void 0 || (_extractEntity = _extractEntity.createdBy) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
    const persons = (0, $8AlQf.extractPersonCreatedBy)(response.data);
    return !!(persons !== null && persons !== void 0 && persons.length) ? persons[0].name : undefined;
};

});

parcelRegister("5iAsx", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $7f75cf2727697377$export$7a685df468cbf38f);

var $cXz7n = parcelRequire("cXz7n");

var $3pz0i = parcelRequire("3pz0i");

var $4gDvk = parcelRequire("4gDvk");
const $7f75cf2727697377$export$7a685df468cbf38f = (response)=>{
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $3pz0i.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.createdAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $cXz7n.extractDateCreated)(response.data);
};

});
parcelRegister("cXz7n", function(module, exports) {
$parcel$export(module.exports, "extractDateCreated", () => $5772e0c9627f6c88$export$e1226a5e0bbbf862);
const $5772e0c9627f6c88$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};

});


parcelRegister("dvhqv", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $b5f07e222125a354$export$7f099a839071a190);

var $3pz0i = parcelRequire("3pz0i");

var $d0PTc = parcelRequire("d0PTc");

var $4gDvk = parcelRequire("4gDvk");
const $b5f07e222125a354$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $3pz0i.extractEntity)(response)) === null || _extractEntity === void 0 || (_extractEntity = _extractEntity.lastUpdatedBy) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
    const person = (0, $d0PTc.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};

});
parcelRegister("d0PTc", function(module, exports) {
$parcel$export(module.exports, "extractPersonUpdatedBy", () => $fa93410115477e3a$export$8a2d1ed7e6f336f0);

var $aVkT0 = parcelRequire("aVkT0");
const $fa93410115477e3a$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $aVkT0.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};

});


parcelRegister("lFzjO", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $92463317ffa234c9$export$75047940e157fd1f);

var $fjPI4 = parcelRequire("fjPI4");

var $3pz0i = parcelRequire("3pz0i");

var $4gDvk = parcelRequire("4gDvk");
const $92463317ffa234c9$export$75047940e157fd1f = (response)=>{
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $3pz0i.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.lastUpdatedAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $fjPI4.extractDateUpdated)(response.data);
};

});
parcelRegister("fjPI4", function(module, exports) {
$parcel$export(module.exports, "extractDateUpdated", () => $bc1f42ef0191780b$export$7fc2f5e6f9d22ae7);
const $bc1f42ef0191780b$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};

});


parcelRegister("del70", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkUrl", () => $fe2d1200d615dfec$export$7ba9b12c6a1b73de);

var $3pz0i = parcelRequire("3pz0i");

var $fLcUZ = parcelRequire("fLcUZ");

var $4gDvk = parcelRequire("4gDvk");
const $fe2d1200d615dfec$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $3pz0i.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.url;
    }
    return (0, $fLcUZ.extractLink)(response === null || response === void 0 ? void 0 : response.data);
};

});

parcelRegister("iAjUk", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkSummary", () => $35bf2bdef81bf383$export$8c6b9b49f358840);

var $3pz0i = parcelRequire("3pz0i");

var $4gDvk = parcelRequire("4gDvk");

var $fXnp3 = parcelRequire("fXnp3");
const $35bf2bdef81bf383$export$8c6b9b49f358840 = (response)=>{
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $3pz0i.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.description;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $fXnp3.extractSummary)(response.data);
};

});
parcelRegister("fXnp3", function(module, exports) {
$parcel$export(module.exports, "extractSummary", () => $3e709fdec79349ca$export$db5a8500f6b6286e);
const $3e709fdec79349ca$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof (jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.summary) === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});


parcelRegister("5Fq50", function(module, exports) {
$parcel$export(module.exports, "extractFlexibleCardActions", () => $b28817e7235149cf$export$abe8d0ca1daa1755);

var $gdUUy = parcelRequire("gdUUy");

var $5kJPq = parcelRequire("5kJPq");

var $dovR8 = parcelRequire("dovR8");

var $9jg8q = parcelRequire("9jg8q");

var $e7Izm = parcelRequire("e7Izm");

var $9nXjb = parcelRequire("9nXjb");

var $96YuD = parcelRequire("96YuD");

var $ka1XL = parcelRequire("ka1XL");

var $abuKh = parcelRequire("abuKh");

var $1ZiPx = parcelRequire("1ZiPx");
const $b28817e7235149cf$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, product: product, response: response, rovoConfig: rovoConfig, transformUrl: transformUrl, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $5kJPq.ActionName).CopyLinkAction]: (0, $e7Izm.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5kJPq.ActionName).DownloadAction]: (0, $9nXjb.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5kJPq.ActionName).FollowAction]: (0, $96YuD.default)(response, actionOptions, id),
        [(0, $5kJPq.ActionName).PreviewAction]: (0, $ka1XL.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $gdUUy.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }),
        [(0, $5kJPq.ActionName).AutomationAction]: (0, $9jg8q.extractAutomationAction)(response),
        [(0, $5kJPq.InternalActionName).AISummaryAction]: (0, $dovR8.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5kJPq.ActionName).RovoChatAction]: (0, $abuKh.default)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            product: product,
            response: response,
            rovoConfig: rovoConfig
        }),
        [(0, $5kJPq.InternalActionName).ViewRelatedLinksAction]: (0, $1ZiPx.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("dovR8", function(module, exports) {
$parcel$export(module.exports, "extractAISummaryAction", () => $19b97656596c50a5$export$e7f7a50a8b8932df);

var $5kJPq = parcelRequire("5kJPq");

var $2BgG1 = parcelRequire("2BgG1");

var $aVZCo = parcelRequire("aVZCo");
const $19b97656596c50a5$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2BgG1.canShowAction)((0, $5kJPq.CardAction).AISummaryAction, actionOptions) || !(0, $aVZCo.getIsAISummaryEnabled)(aiSummaryConfig === null || aiSummaryConfig === void 0 ? void 0 : aiSummaryConfig.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("2BgG1", function(module, exports) {
$parcel$export(module.exports, "canShowAction", () => $e7b485bbd28aacf2$export$2487b058456cca75);
const $e7b485bbd28aacf2$export$2487b058456cca75 = (action, actionOptions)=>{
    var _actionOptions$exclud;
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || (_actionOptions$exclud = actionOptions.exclude) !== null && _actionOptions$exclud !== void 0 && _actionOptions$exclud.includes(action)) return false;
    return true;
};

});


parcelRegister("9jg8q", function(module, exports) {
$parcel$export(module.exports, "extractAutomationAction", () => $604886fa06c6e8df$export$f913cc6abf3ec084);

var $5kJPq = parcelRequire("5kJPq");
const $604886fa06c6e8df$export$f913cc6abf3ec084 = (response)=>{
    var _response$meta;
    if (!response.data) return undefined;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && (_response$meta = _response$meta.supportedFeature) !== null && _response$meta !== void 0 && _response$meta.includes((0, $5kJPq.ActionName).AutomationAction))) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("e7Izm", function(module, exports) {
$parcel$export(module.exports, "extractCopyLinkClientAction", () => $103a74aa86ea7b03$export$31ddd5c40039ce53);

var $eoM4E = parcelRequire("eoM4E");
const $103a74aa86ea7b03$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $eoM4E.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("eoM4E", function(module, exports) {
$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $f67140048abc2ceb$export$5ec86886067a062d);

var $del70 = parcelRequire("del70");

var $5kJPq = parcelRequire("5kJPq");

var $3p1gi = parcelRequire("3p1gi");

var $gy3md = parcelRequire("gy3md");

var $2lrWO = parcelRequire("2lrWO");

var $2BgG1 = parcelRequire("2BgG1");
const $f67140048abc2ceb$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2BgG1.canShowAction)((0, $5kJPq.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $del70.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5kJPq.ActionName).CopyLinkAction,
        definitionId: (0, $3p1gi.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $gy3md.getExtensionKey)(response),
        id: id,
        resourceType: (0, $2lrWO.getResourceType)(response)
    };
};

});


parcelRegister("9nXjb", function(module, exports) {
$parcel$export(module.exports, "extractDownloadClientAction", () => $d10a0bb905474f2d$export$f6c386869a352b1f);

var $ivNjt = parcelRequire("ivNjt");
const $d10a0bb905474f2d$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $ivNjt.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("ivNjt", function(module, exports) {
$parcel$export(module.exports, "extractInvokeDownloadAction", () => $cc3d1d59446c8c3d$export$ea97cd34c2ca86de);

var $aQUqz = parcelRequire("aQUqz");

var $5kJPq = parcelRequire("5kJPq");

var $3p1gi = parcelRequire("3p1gi");

var $gy3md = parcelRequire("gy3md");

var $2lrWO = parcelRequire("2lrWO");

var $2BgG1 = parcelRequire("2BgG1");

var $feMDS = parcelRequire("feMDS");

var $9t0dZ = parcelRequire("9t0dZ");
const $cc3d1d59446c8c3d$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2BgG1.canShowAction)((0, $5kJPq.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $9t0dZ.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $aQUqz.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $feMDS.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5kJPq.ActionName).DownloadAction,
            definitionId: (0, $3p1gi.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $gy3md.getExtensionKey)(response),
            id: id,
            resourceType: (0, $2lrWO.getResourceType)(response)
        };
    }
};

});
parcelRegister("aQUqz", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $7228a2d63a8d9112$export$96ed4c1b14ac210a);

var $3pz0i = parcelRequire("3pz0i");

var $4gDvk = parcelRequire("4gDvk");
const $7228a2d63a8d9112$export$96ed4c1b14ac210a = (response)=>{
    var _response$data;
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _entity$exportLinks;
        const entity = (0, $3pz0i.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity === null || entity === void 0 || (_entity$exportLinks = entity.exportLinks) === null || _entity$exportLinks === void 0 ? void 0 : _entity$exportLinks[0].url : undefined;
    }
    return response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data['atlassian:downloadUrl'];
};

});

parcelRegister("feMDS", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $f56418e150a49230$export$8a96edb1c96563f4);
const $f56418e150a49230$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("9t0dZ", function(module, exports) {
$parcel$export(module.exports, "getActionsFromJsonLd", () => $4be7c977f7dbe12e$export$8f031784a3a03b23);
const $4be7c977f7dbe12e$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});



parcelRegister("96YuD", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d51c02a9c9f0177$export$2e2bcd8739ae039);

var $fLcUZ = parcelRequire("fLcUZ");

var $fZvKv = parcelRequire("fZvKv");

var $6vGM1 = parcelRequire("6vGM1");

var $5kJPq = parcelRequire("5kJPq");

var $gy3md = parcelRequire("gy3md");

var $2BgG1 = parcelRequire("2BgG1");

var $183nD = parcelRequire("183nD");
const $0d51c02a9c9f0177$var$extractFollowAction = (response, actionOptions, id)=>{
    var _action$dataUpdateAct;
    if (!(0, $2BgG1.canShowAction)((0, $5kJPq.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $gy3md.getExtensionKey)(response);
    const data = response === null || response === void 0 ? void 0 : response.data;
    const actions = (0, $183nD.default)(data);
    const type = (0, $fZvKv.extractType)(data);
    const isProject = type === null || type === void 0 ? void 0 : type.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if ((item === null || item === void 0 ? void 0 : item.name) === 'UpdateAction') {
            var _dataUpdateAction;
            const actionName = item === null || item === void 0 || (_dataUpdateAction = item.dataUpdateAction) === null || _dataUpdateAction === void 0 ? void 0 : _dataUpdateAction.name;
            return actionName === (0, $6vGM1.SmartLinkActionType).FollowEntityAction || actionName === (0, $6vGM1.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $fLcUZ.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = (_action$dataUpdateAct = action.dataUpdateAction) === null || _action$dataUpdateAct === void 0 ? void 0 : _action$dataUpdateAct.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $6vGM1.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $0d51c02a9c9f0177$export$2e2bcd8739ae039 = $0d51c02a9c9f0177$var$extractFollowAction;

});
parcelRegister("183nD", function(module, exports) {
$parcel$export(module.exports, "default", () => $79d1df589851fe6e$export$2e2bcd8739ae039);
const $79d1df589851fe6e$var$extractServerAction = (data)=>{
    const actions = data === null || data === void 0 ? void 0 : data['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $79d1df589851fe6e$export$2e2bcd8739ae039 = $79d1df589851fe6e$var$extractServerAction;

});


parcelRegister("ka1XL", function(module, exports) {
$parcel$export(module.exports, "extractPreviewClientAction", () => $25d646784e3a17fe$export$9f0d9100b079448);

var $aQflG = parcelRequire("aQflG");
const $25d646784e3a17fe$export$9f0d9100b079448 = (param)=>{
    const result = (0, $aQflG.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};

});
parcelRegister("aQflG", function(module, exports) {
$parcel$export(module.exports, "extractInvokePreviewAction", () => $c3b6c5efbc2d8830$export$caf83f49e52ac0bb);

var $80uKk = parcelRequire("80uKk");

var $2NFkZ = parcelRequire("2NFkZ");

var $dWNt9 = parcelRequire("dWNt9");

var $gxIo9 = parcelRequire("gxIo9");

var $fUOZn = parcelRequire("fUOZn");

var $del70 = parcelRequire("del70");

var $8y99z = parcelRequire("8y99z");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");

var $5kJPq = parcelRequire("5kJPq");

var $gy3md = parcelRequire("gy3md");

var $2BgG1 = parcelRequire("2BgG1");

var $eJUWZ = parcelRequire("eJUWZ");

var $2dCzp = parcelRequire("2dCzp");

var $hEEr6 = parcelRequire("hEEr6");

var $a7Q8l = parcelRequire("a7Q8l");

var $ddr4G = parcelRequire("ddr4G");

var $ivNjt = parcelRequire("ivNjt");

var $d8hHF = parcelRequire("d8hHF");
const $c3b6c5efbc2d8830$export$caf83f49e52ac0bb = (param)=>{
    var _extractPreviewData;
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $2NFkZ.extractSmartLinkAri)(response);
    const url = (0, $del70.extractSmartLinkUrl)(response);
    const name = (0, $fUOZn.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $8y99z.isWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $2BgG1.canShowAction)((0, $5kJPq.CardAction).PreviewAction, actionOptions)) return;
    // Restricted (e.g. cross-unit) resources must not be previewed at all — suppress
    // the action so it does not fall back to a preview modal.
    if (ari && isPreviewRestricted !== null && isPreviewRestricted !== void 0 && isPreviewRestricted({
        ari: ari
    }) && (0, $gdUUy.fg)('preview_panel_unit_check')) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (_extractPreviewData = (0, $80uKk.extractPreview)(data, 'web')) === null || _extractPreviewData === void 0 ? void 0 : _extractPreviewData.src;
    // disallow preview modals within preview panels
    if (!hasPreviewPanel && isInPreviewPanel) return;
    if (src) {
        const extensionKey = (0, $gy3md.getExtensionKey)(response);
        return {
            hasPreviewPanel: hasPreviewPanel,
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        var _extractSmartLinkEmbe;
                        let resolvedUrl = url;
                        if ((0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined,
                            panelData: {
                                embedUrl: (0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (_extractSmartLinkEmbe = (0, $dWNt9.extractSmartLinkEmbed)(response)) === null || _extractSmartLinkEmbe === void 0 ? void 0 : _extractSmartLinkEmbe.src : undefined
                            }
                        });
                        (0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        var _extractSmartLinkProv, _extractSmartLinkEmbe2, _actionOptions$previe, _actionOptions$previe2;
                        await (0, $eJUWZ.openEmbedModal)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $ivNjt.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $d8hHF.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $2dCzp.extractIsSupportTheming)(meta),
                            isTrusted: (0, $hEEr6.extractIsTrusted)(meta),
                            linkIcon: (0, $gdUUy.fg)('platform_lp_use_generator_icon_for_provider') ? (0, $ddr4G.extractSmartLinkIcon)(response) : (0, $a7Q8l.extractLinkIcon)(response),
                            providerName: (_extractSmartLinkProv = (0, $gxIo9.extractSmartLinkProvider)(response)) === null || _extractSmartLinkProv === void 0 ? void 0 : _extractSmartLinkProv.text,
                            onClose: onClose,
                            origin: origin,
                            src: (_extractSmartLinkEmbe2 = (0, $dWNt9.extractSmartLinkEmbed)(response)) === null || _extractSmartLinkEmbe2 === void 0 ? void 0 : _extractSmartLinkEmbe2.src,
                            title: (0, $fUOZn.extractSmartLinkTitle)(response),
                            url: url,
                            size: actionOptions === null || actionOptions === void 0 || (_actionOptions$previe = actionOptions.previewAction) === null || _actionOptions$previe === void 0 ? void 0 : _actionOptions$previe.size,
                            isBlanketHidden: actionOptions === null || actionOptions === void 0 || (_actionOptions$previe2 = actionOptions.previewAction) === null || _actionOptions$previe2 === void 0 ? void 0 : _actionOptions$previe2.hideBlanket,
                            ...(0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $5kJPq.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            }
        };
    }
};

});
parcelRegister("8y99z", function(module, exports) {
$parcel$export(module.exports, "isWithinPreviewPanelIFrame", () => $9aa3a69a37270e53$export$24def1b22639c691);

var $ciIjZ = parcelRequire("ciIjZ");

var $4yXQ1 = parcelRequire("4yXQ1");
const $9aa3a69a37270e53$export$24def1b22639c691 = ()=>{
    return (0, $ciIjZ.isInIframe)() && (0, $4yXQ1.isWithinPreviewPanel)();
};

});
parcelRegister("ciIjZ", function(module, exports) {
$parcel$export(module.exports, "isInIframe", () => $6a9e2b168715ea6c$export$9f140ed41af5108c);
/**
 * Checks if the current code is running inside an iframe.
 * @returns true if running in an iframe, false otherwise
 */ const $6a9e2b168715ea6c$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};

});

parcelRegister("4yXQ1", function(module, exports) {
$parcel$export(module.exports, "isWithinPreviewPanel", () => $2adba9d493349292$export$f274fcef361fe59d);
/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */ const $2adba9d493349292$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
const $2adba9d493349292$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $2adba9d493349292$var$hasPreviewPanelIndicators = (searchParams)=>{
    return searchParams.has($2adba9d493349292$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($2adba9d493349292$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $2adba9d493349292$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $2adba9d493349292$export$f274fcef361fe59d = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $2adba9d493349292$var$getUrlSearchParams(currentSearch);
            if (currentParams && $2adba9d493349292$var$hasPreviewPanelIndicators(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};

});


parcelRegister("eJUWZ", function(module, exports) {
$parcel$export(module.exports, "openEmbedModal", () => $e8c7eafbe0601ed8$export$7859f96cd8cff034);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $ltkSJ = parcelRequire("ltkSJ");

var $dTM5i = parcelRequire("dTM5i");

var $gdUUy = parcelRequire("gdUUy");
let $e8c7eafbe0601ed8$var$reactRoots = new WeakMap();
/** Mounts `element` into `mountPoint`: uses the React 18/19 `createRoot` API when `nike_r19_render_unmount` is on, else the legacy render path. */ const $e8c7eafbe0601ed8$var$renderToMountPoint = (element, mountPoint)=>{
    if ((0, $gdUUy.fg)('nike_r19_render_unmount')) {
        let root = $e8c7eafbe0601ed8$var$reactRoots.get(mountPoint);
        if (!root) {
            root = (0, $ltkSJ.createRoot)(mountPoint);
            $e8c7eafbe0601ed8$var$reactRoots.set(mountPoint, root);
        }
        root.render(element);
    } else (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).render(element, mountPoint);
};
/** Unmounts the tree at `mountPoint`: uses `root.unmount()` when `nike_r19_render_unmount` is on, else the legacy unmount path. */ const $e8c7eafbe0601ed8$var$unmountFromMountPoint = (mountPoint)=>{
    if ((0, $gdUUy.fg)('nike_r19_render_unmount')) {
        const root = $e8c7eafbe0601ed8$var$reactRoots.get(mountPoint);
        if (root) {
            root.unmount();
            $e8c7eafbe0601ed8$var$reactRoots.delete(mountPoint);
        }
    } else (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).unmountComponentAtNode(mountPoint);
};
const $e8c7eafbe0601ed8$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $e8c7eafbe0601ed8$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $e8c7eafbe0601ed8$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($e8c7eafbe0601ed8$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $e8c7eafbe0601ed8$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("4k7bL"));
    $e8c7eafbe0601ed8$var$renderToMountPoint(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Modal.default, {
        ...props,
        iframeName: $e8c7eafbe0601ed8$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) $e8c7eafbe0601ed8$var$unmountFromMountPoint(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}

});
parcelRegister("4k7bL", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9hJYz"),
    $kOunM("3SC8I"),
    $kOunM("aHc5N"),
    $kOunM("7g4Sw")
]).then(()=>parcelRequire('bL7OV'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});




parcelRegister("2dCzp", function(module, exports) {
$parcel$export(module.exports, "extractIsSupportTheming", () => $6679b7d9ea02a44d$export$38d755f52cdf4acb);

var $68DJM = parcelRequire("68DJM");
const $6679b7d9ea02a44d$export$38d755f52cdf4acb = (meta)=>{
    return Boolean((meta === null || meta === void 0 ? void 0 : meta.key) && (0, $68DJM.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("68DJM", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $67d2ea09ca8214aa$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $67d2ea09ca8214aa$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $67d2ea09ca8214aa$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $67d2ea09ca8214aa$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $67d2ea09ca8214aa$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $67d2ea09ca8214aa$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $67d2ea09ca8214aa$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $67d2ea09ca8214aa$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $67d2ea09ca8214aa$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $67d2ea09ca8214aa$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $67d2ea09ca8214aa$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $67d2ea09ca8214aa$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $67d2ea09ca8214aa$export$fe44ce30fd8d131b);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_HOSTPRODUCT_CONTEXT", () => $67d2ea09ca8214aa$export$3740f371d9ab7d4);
const $67d2ea09ca8214aa$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $67d2ea09ca8214aa$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $67d2ea09ca8214aa$export$84a73a0383f58180 = 'JiraTask';
const $67d2ea09ca8214aa$export$c6c83963a9378a67 = 'JiraSubTask';
const $67d2ea09ca8214aa$export$58af3c426c111a6d = 'JiraStory';
const $67d2ea09ca8214aa$export$ac9898a63417219e = 'JiraBug';
const $67d2ea09ca8214aa$export$54db5e3fb12e39cd = 'JiraEpic';
const $67d2ea09ca8214aa$export$2f54a5a217202c85 = 'JiraIncident';
const $67d2ea09ca8214aa$export$d097371052bfc411 = 'JiraServiceRequest';
const $67d2ea09ca8214aa$export$efd9452ad16c6676 = 'JiraChange';
const $67d2ea09ca8214aa$export$2e7e70abb5d81f67 = 'JiraProblem';
const $67d2ea09ca8214aa$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $67d2ea09ca8214aa$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider',
    'avpplatform-object-provider'
];
const $67d2ea09ca8214aa$export$3740f371d9ab7d4 = [
    'avpplatform-object-provider'
];

});


parcelRegister("hEEr6", function(module, exports) {
$parcel$export(module.exports, "extractIsTrusted", () => $c4ee0fc6322e6586$export$4f3ffbb500daac5a);
const $c4ee0fc6322e6586$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean((meta === null || meta === void 0 ? void 0 : meta.key) && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("a7Q8l", function(module, exports) {
$parcel$export(module.exports, "extractLinkIcon", () => $bf63226247af280f$export$43612bed147eae48);

var $cDS8O = parcelRequire("cDS8O");

var $6Jgbo = parcelRequire("6Jgbo");
const $bf63226247af280f$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $cDS8O.default)(data, renderers);
    return {
        ...(0, $6Jgbo.default)(data),
        render: render
    };
};

});
parcelRegister("cDS8O", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0e5cb702aad77f2$export$2e2bcd8739ae039);
const $e0e5cb702aad77f2$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $e0e5cb702aad77f2$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if ((prefix === null || prefix === void 0 ? void 0 : prefix['@type']) === 'atlassian:Emoji') {
        const emojiId = $e0e5cb702aad77f2$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers === null || renderers === void 0 ? void 0 : renderers.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $e0e5cb702aad77f2$export$2e2bcd8739ae039 = $e0e5cb702aad77f2$var$extractIconRenderer;

});

parcelRegister("6Jgbo", function(module, exports) {
$parcel$export(module.exports, "default", () => $57dfb0b36bea5e7c$export$2e2bcd8739ae039);

var $5kJPq = parcelRequire("5kJPq");

var $b2NV8 = parcelRequire("b2NV8");

var $cPP74 = parcelRequire("cPP74");

var $gpxtq = parcelRequire("gpxtq");

var $68DJM = parcelRequire("68DJM");

var $VenEJ = parcelRequire("VenEJ");

var $jchxU = parcelRequire("jchxU");

var $3sTwM = parcelRequire("3sTwM");

var $g5BC8 = parcelRequire("g5BC8");

var $5zMie = parcelRequire("5zMie");
const $57dfb0b36bea5e7c$var$extractTask = (data)=>{
    const { id: id, icon: url, name: name } = (0, $gpxtq.extractTaskType)(data) || {};
    const taskType = id === null || id === void 0 ? void 0 : id.split('#').pop();
    const taskIconLabel = (name === null || name === void 0 ? void 0 : name.trim()) || 'Task';
    const taskIcon = url ? {
        label: taskIconLabel,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $57dfb0b36bea5e7c$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $cPP74.extractorPriorityMap)[b] - (0, $cPP74.extractorPriorityMap)[a])[0] : type;
};
const $57dfb0b36bea5e7c$var$isJiraProvider = (provider)=>provider === (0, $68DJM.JIRA_GENERATOR_ID);
function $57dfb0b36bea5e7c$var$chooseIcon({ type: type, data: data, providerIcon: providerIcon }) {
    var _data$generator;
    const providerId = (_data$generator = data.generator) === null || _data$generator === void 0 ? void 0 : _data$generator['@id'];
    const fileFormat = data === null || data === void 0 ? void 0 : data['schema:fileFormat'];
    const fileFormatIcon = (0, $jchxU.default)(fileFormat);
    const iconDescriptor = $57dfb0b36bea5e7c$var$typeToIconDescriptor({
        type: type,
        providerId: providerId,
        data: data
    });
    const extractedDocumentTypeIcon = (0, $VenEJ.default)(type, providerId);
    const documentTypeIcon = iconDescriptor || extractedDocumentTypeIcon;
    const urlIcon = (0, $5zMie.default)(data.icon, documentTypeIcon === null || documentTypeIcon === void 0 ? void 0 : documentTypeIcon.label);
    return (0, $b2NV8.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $57dfb0b36bea5e7c$var$typeToIconDescriptor({ type: type, providerId: providerId, data: data }) {
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(type){
        case 'atlassian:Goal':
            return getIconDescriptor((0, $5kJPq.IconType).Task, 'goal');
        case 'atlassian:Project':
            // FIXME: atlassian:Project seem to be returned for many things, including Confluence space or Trello board,
            // But `IconType.Project` actual value is `BitBucket:Project`!
            return getIconDescriptor((0, $5kJPq.IconType).Project, 'project');
        case 'atlassian:SourceCodeCommit':
            return getIconDescriptor((0, $5kJPq.IconType).Commit, 'commit');
        case 'atlassian:SourceCodePullRequest':
            return getIconDescriptor((0, $5kJPq.IconType).PullRequest, 'pull request');
        case 'atlassian:SourceCodeReference':
            return getIconDescriptor((0, $5kJPq.IconType).Branch, 'branch');
        case 'atlassian:SourceCodeRepository':
            return getIconDescriptor((0, $5kJPq.IconType).Repo, 'repository');
        case 'atlassian:Task':
            const taskIconDescriptor = {
                icon: (0, $5kJPq.IconType).Task,
                label: 'task'
            };
            if ($57dfb0b36bea5e7c$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $57dfb0b36bea5e7c$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $3sTwM.default)(taskType);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $57dfb0b36bea5e7c$var$extractJsonldDataIcon = (data)=>{
    const type = $57dfb0b36bea5e7c$var$extractType(data);
    const providerIcon = (0, $g5BC8.default)(data);
    return $57dfb0b36bea5e7c$var$chooseIcon({
        type: type,
        data: data,
        providerIcon: providerIcon
    });
};
var $57dfb0b36bea5e7c$export$2e2bcd8739ae039 = $57dfb0b36bea5e7c$var$extractJsonldDataIcon;

});
parcelRegister("b2NV8", function(module, exports) {
$parcel$export(module.exports, "prioritiseIcon", () => $381076a348fff722$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $381076a348fff722$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("cPP74", function(module, exports) {
$parcel$export(module.exports, "extractorPriorityMap", () => $ea24987ed7916491$export$e0deaeb4a2dfe2b4);
const $ea24987ed7916491$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("gpxtq", function(module, exports) {
$parcel$export(module.exports, "extractTaskType", () => $888b9a4bac7bd686$export$ed3fd59180514d27);

var $cdeW6 = parcelRequire("cdeW6");
const $888b9a4bac7bd686$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $cdeW6.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("VenEJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b6c4a234c591668$export$2e2bcd8739ae039);

var $jhgZE = parcelRequire("jhgZE");

var $5kJPq = parcelRequire("5kJPq");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $4b6c4a234c591668$var$extractDocumentTypeIcon = (documentType, providerId)=>{
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(documentType){
        case 'schema:BlogPosting':
            return getIconDescriptor((0, $5kJPq.IconType).Blog, 'blog');
        case 'schema:DigitalDocument':
            if (providerId && (0, $jhgZE.isConfluenceGenerator)(providerId)) return getIconDescriptor((0, $5kJPq.IconType).LiveDocument, 'live document');
            else return getIconDescriptor((0, $5kJPq.IconType).File, 'file');
        case 'schema:TextDigitalDocument':
            return getIconDescriptor((0, $5kJPq.IconType).Document, 'document');
        case 'schema:PresentationDigitalDocument':
            return getIconDescriptor((0, $5kJPq.IconType).Presentation, 'presentation');
        case 'schema:SpreadsheetDigitalDocument':
            return getIconDescriptor((0, $5kJPq.IconType).Spreadsheet, 'spreadsheet');
        case 'atlassian:Template':
            return getIconDescriptor((0, $5kJPq.IconType).Template, 'template');
        case 'atlassian:UndefinedLink':
            return getIconDescriptor((0, $5kJPq.IconType).Document, 'document');
        default:
            return undefined;
    }
};
var $4b6c4a234c591668$export$2e2bcd8739ae039 = $4b6c4a234c591668$var$extractDocumentTypeIcon;

});
parcelRegister("jhgZE", function(module, exports) {
$parcel$export(module.exports, "isConfluenceGenerator", () => $6aea9fea66d51dbb$export$38df542ff03a4183);

var $lnxPF = parcelRequire("lnxPF");
const $6aea9fea66d51dbb$export$38df542ff03a4183 = (id)=>{
    return id === (0, $lnxPF.CONFLUENCE_GENERATOR_ID);
};

});


parcelRegister("jchxU", function(module, exports) {
$parcel$export(module.exports, "default", () => $66213ffb67e7ee2c$export$2e2bcd8739ae039);

var $5kJPq = parcelRequire("5kJPq");
const $66213ffb67e7ee2c$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return getIconDescriptor((0, $5kJPq.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $5kJPq.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $5kJPq.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $5kJPq.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $5kJPq.IconType).Spreadsheet, 'spreadsheet');
        // Google Drive
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $5kJPq.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $5kJPq.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $5kJPq.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $5kJPq.IconType).GoogleSlides, 'google slide');
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $5kJPq.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $5kJPq.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $5kJPq.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $5kJPq.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $5kJPq.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $5kJPq.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $5kJPq.IconType).Video, 'video');
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $5kJPq.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $5kJPq.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $5kJPq.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $5kJPq.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
            return getIconDescriptor((0, $5kJPq.IconType).Generic, 'file');
        case 'application/invision.prototype':
            return getIconDescriptor((0, $5kJPq.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $66213ffb67e7ee2c$export$2e2bcd8739ae039 = $66213ffb67e7ee2c$var$extractFileFormatIcon;

});

parcelRegister("3sTwM", function(module, exports) {
$parcel$export(module.exports, "default", () => $62677055b53f1f85$export$2e2bcd8739ae039);

var $5kJPq = parcelRequire("5kJPq");
const $62677055b53f1f85$var$extractJiraTaskIcon = (taskType)=>{
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(taskType){
        case 'JiraBug':
            return getIconDescriptor((0, $5kJPq.IconType).Bug, 'Bug');
        case 'JiraChange':
            return getIconDescriptor((0, $5kJPq.IconType).Change, 'Change');
        case 'JiraEpic':
            return getIconDescriptor((0, $5kJPq.IconType).Epic, 'Epic');
        case 'JiraIncident':
            return getIconDescriptor((0, $5kJPq.IconType).Incident, 'Incident');
        case 'JiraProblem':
            return getIconDescriptor((0, $5kJPq.IconType).Problem, 'Problem');
        case 'JiraServiceRequest':
            return getIconDescriptor((0, $5kJPq.IconType).ServiceRequest, 'Service request');
        case 'JiraStory':
            return getIconDescriptor((0, $5kJPq.IconType).Story, 'Story');
        case 'JiraSubTask':
            return getIconDescriptor((0, $5kJPq.IconType).SubTask, 'Sub-task');
        case 'JiraTask':
        default:
            return getIconDescriptor((0, $5kJPq.IconType).Task, 'Task');
    }
};
var $62677055b53f1f85$export$2e2bcd8739ae039 = $62677055b53f1f85$var$extractJiraTaskIcon;

});

parcelRegister("g5BC8", function(module, exports) {
$parcel$export(module.exports, "default", () => $a628bff1bf66d178$export$2e2bcd8739ae039);

var $jzkAp = parcelRequire("jzkAp");

var $5kJPq = parcelRequire("5kJPq");

var $68DJM = parcelRequire("68DJM");

var $5zMie = parcelRequire("5zMie");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $a628bff1bf66d178$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator === null || generator === void 0 ? void 0 : generator['@id'];
    const icon = generator === null || generator === void 0 ? void 0 : generator.icon;
    const label = (generator === null || generator === void 0 ? void 0 : generator.name) || (0, $jzkAp.extractTitle)(data);
    if (provider === (0, $68DJM.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5kJPq.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $68DJM.JIRA_GENERATOR_ID)) return {
        icon: (0, $5kJPq.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $5zMie.default)(icon, label);
};
var $a628bff1bf66d178$export$2e2bcd8739ae039 = $a628bff1bf66d178$var$extractProviderIcon;

});
parcelRegister("5zMie", function(module, exports) {
$parcel$export(module.exports, "default", () => $06c6fd8c2b644573$export$2e2bcd8739ae039);

var $cdeW6 = parcelRequire("cdeW6");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $06c6fd8c2b644573$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $cdeW6.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $06c6fd8c2b644573$export$2e2bcd8739ae039 = $06c6fd8c2b644573$var$extractUrlIcon;

});




parcelRegister("ddr4G", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkIcon", () => $f107d37776894043$export$35040aed9264b11c);

var $5NFld = parcelRequire("5NFld");

var $4gDvk = parcelRequire("4gDvk");

var $a7Q8l = parcelRequire("a7Q8l");
const $f107d37776894043$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !(response !== null && response !== void 0 && response.data)) return undefined;
    if ((0, $4gDvk.isEntityPresent)(response)) {
        const entityIcon = (0, $5NFld.extractEntityIcon)(response);
        if (entityIcon) return entityIcon;
    }
    return (0, $a7Q8l.extractLinkIcon)(response, renderers);
};

});

parcelRegister("d8hHF", function(module, exports) {
$parcel$export(module.exports, "extractInvokeViewAction", () => $31e58b91acb095a1$export$88c5813cfbbe4e4c);

var $fLcUZ = parcelRequire("fLcUZ");

var $5kJPq = parcelRequire("5kJPq");

var $3p1gi = parcelRequire("3p1gi");

var $gy3md = parcelRequire("gy3md");

var $2lrWO = parcelRequire("2lrWO");

var $2BgG1 = parcelRequire("2BgG1");

var $3nwpV = parcelRequire("3nwpV");

var $9t0dZ = parcelRequire("9t0dZ");
const $31e58b91acb095a1$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, transformUrl: transformUrl, id: id, response: response }, force)=>{
    if (!(0, $2BgG1.canShowAction)((0, $5kJPq.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $fLcUZ.extractLink)(data);
    const viewActionExists = (0, $9t0dZ.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>{
            const destinationUrl = (transformUrl === null || transformUrl === void 0 ? void 0 : transformUrl(url)) ?? url;
            return (0, $3nwpV.openUrl)(destinationUrl);
        },
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $3p1gi.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $gy3md.getExtensionKey)(response),
        id: id,
        resourceType: (0, $2lrWO.getResourceType)(response)
    };
};

});
parcelRegister("3nwpV", function(module, exports) {
$parcel$export(module.exports, "openUrl", () => $8be1e4b5fb57be09$export$a238cfe4a10e6279);
const $8be1e4b5fb57be09$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};

});




parcelRegister("abuKh", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b8ef738f8c5ead2$export$2e2bcd8739ae039);

var $del70 = parcelRequire("del70");

var $5kJPq = parcelRequire("5kJPq");

var $3p1gi = parcelRequire("3p1gi");

var $gy3md = parcelRequire("gy3md");

var $2lrWO = parcelRequire("2lrWO");

var $2BgG1 = parcelRequire("2BgG1");

var $1R1LG = parcelRequire("1R1LG");
const $8b8ef738f8c5ead2$var$extractRovoChatAction = ({ actionOptions: actionOptions, appearance: appearance, id: id, product: product, response: response, rovoConfig: rovoConfig })=>{
    var _actionOptions$rovoCh;
    if (!(0, $2BgG1.canShowAction)((0, $5kJPq.CardAction).RovoChatAction, actionOptions)) return;
    const isRovoChatEnabled = (0, $1R1LG.getIsRovoChatEnabled)(rovoConfig === null || rovoConfig === void 0 ? void 0 : rovoConfig.rovoOptions);
    if (!isRovoChatEnabled) return;
    const extensionKey = (0, $gy3md.getExtensionKey)(response);
    const url = (0, $del70.extractSmartLinkUrl)(response);
    return actionOptions !== null && actionOptions !== void 0 && (_actionOptions$rovoCh = actionOptions.rovoChatAction) !== null && _actionOptions$rovoCh !== void 0 && _actionOptions$rovoCh.optIn ? {
        invokeAction: {
            actionSubjectId: 'rovoChatPrompt',
            actionType: (0, $5kJPq.ActionName).RovoChatAction,
            definitionId: (0, $3p1gi.getDefinitionId)(response),
            display: appearance,
            extensionKey: extensionKey,
            id: id,
            resourceType: (0, $2lrWO.getResourceType)(response)
        },
        product: product,
        url: url
    } : undefined;
};
var $8b8ef738f8c5ead2$export$2e2bcd8739ae039 = $8b8ef738f8c5ead2$var$extractRovoChatAction;

});

parcelRegister("1ZiPx", function(module, exports) {
$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $c95f0d0b684ba73c$export$debae7424a0231b9);

var $2NFkZ = parcelRequire("2NFkZ");
const $c95f0d0b684ba73c$export$debae7424a0231b9 = (response)=>{
    var _response$meta;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && (_response$meta = _response$meta.supportedFeature) !== null && _response$meta !== void 0 && _response$meta.includes('RelatedLinks'))) return;
    const ari = (0, $2NFkZ.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("T8D3J", function(module, exports) {
$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $328900279c273d92$export$216e4f6aa7c169b8);

var $l4P6U = parcelRequire("l4P6U");

var $aVkT0 = parcelRequire("aVkT0");
const $328900279c273d92$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $l4P6U.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $aVkT0.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("l4P6U", function(module, exports) {
$parcel$export(module.exports, "extractMembers", () => $2f03a2b40fb90748$export$6281d080d62a0719);

var $aVkT0 = parcelRequire("aVkT0");
const $2f03a2b40fb90748$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $aVkT0.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $aVkT0.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};

});


parcelRegister("aO9xE", function(module, exports) {
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $576cd2cb09db123c$export$4356c594f5c138d6);

var $hSChA = parcelRequire("hSChA");
const $576cd2cb09db123c$export$4356c594f5c138d6 = (data)=>(0, $hSChA.extractValue)(data, 'atlassian:appliedToComponentsCount');

});
parcelRegister("hSChA", function(module, exports) {
$parcel$export(module.exports, "extractValue", () => $43de054cd96b5f82$export$e66823f955487935);
const $43de054cd96b5f82$export$e66823f955487935 = (data, key)=>{
    return data === null || data === void 0 ? void 0 : data[key];
};

});


parcelRegister("bvW2k", function(module, exports) {
$parcel$export(module.exports, "extractAssignedTo", () => $d5141da3b4cad5af$export$5546969a505305);

var $h08yA = parcelRequire("h08yA");
const $d5141da3b4cad5af$export$5546969a505305 = (data)=>{
    const person = (0, $h08yA.extractPersonAssignedTo)(data);
    if (person) return person.name;
};

});
parcelRegister("h08yA", function(module, exports) {
$parcel$export(module.exports, "extractPersonAssignedTo", () => $1da821ace6e6fa0b$export$38a0979ebf273662);

var $aVkT0 = parcelRequire("aVkT0");
const $1da821ace6e6fa0b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $aVkT0.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};

});


parcelRegister("ijIpD", function(module, exports) {
$parcel$export(module.exports, "extractAttachmentCount", () => $992c22356c61cf26$export$65362ff78a97fd8);

var $hSChA = parcelRequire("hSChA");
const $992c22356c61cf26$export$65362ff78a97fd8 = (data)=>(0, $hSChA.extractValue)(data, 'atlassian:attachmentCount');

});

parcelRegister("20svu", function(module, exports) {
$parcel$export(module.exports, "extractChecklistProgress", () => $fe857315444d3a68$export$dd980f9881b65d9c);

var $hSChA = parcelRequire("hSChA");
const $fe857315444d3a68$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = (0, $hSChA.extractValue)(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};

});

parcelRegister("kZSLk", function(module, exports) {
$parcel$export(module.exports, "extractDueOn", () => $e75d7214255aeacc$export$ac56bd7a37249b48);

var $hSChA = parcelRequire("hSChA");
const $e75d7214255aeacc$export$ac56bd7a37249b48 = (data)=>(0, $hSChA.extractValue)(data, 'endTime');

});

parcelRegister("hnrQI", function(module, exports) {
$parcel$export(module.exports, "extractHostName", () => $c3e58470785bef18$export$f222ff3355b608d8);

var $del70 = parcelRequire("del70");
const $c3e58470785bef18$export$f222ff3355b608d8 = (response)=>{
    try {
        const url = (0, $del70.extractSmartLinkUrl)(response);
        const hostName = url ? new URL(url).hostname : undefined;
        return hostName;
    } catch  {
        return undefined;
    }
};

});

parcelRegister("bA7XK", function(module, exports) {
$parcel$export(module.exports, "default", () => $6695aad580a0013b$export$2e2bcd8739ae039);

var $fUOZn = parcelRequire("fUOZn");

var $del70 = parcelRequire("del70");

var $5kJPq = parcelRequire("5kJPq");
const $6695aad580a0013b$var$extractLinkTitle = (status, propUrl, response, onClick, onAuxClick, onContextMenu)=>{
    const responseUrl = (0, $del70.extractSmartLinkUrl)(response);
    const url = status === (0, $5kJPq.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $fUOZn.extractSmartLinkTitle)(response);
    const text = status === (0, $5kJPq.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        text: text,
        url: url
    };
};
var $6695aad580a0013b$export$2e2bcd8739ae039 = $6695aad580a0013b$var$extractLinkTitle;

});

parcelRegister("jfEhp", function(module, exports) {
$parcel$export(module.exports, "extractLocation", () => $970875e9fc8db7fa$export$9df94c77b0746c3c);

var $hSChA = parcelRequire("hSChA");
const $970875e9fc8db7fa$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = (0, $hSChA.extractValue)(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};

});

parcelRegister("iUj0p", function(module, exports) {
$parcel$export(module.exports, "extractMetaObjectId", () => $1424ff38f2e0ad55$export$bec1443e3e33b166);
const $1424ff38f2e0ad55$export$bec1443e3e33b166 = (meta)=>meta.objectId;

});

parcelRegister("bMmmp", function(module, exports) {
$parcel$export(module.exports, "extractMetaResourceType", () => $f6c544561e6a572a$export$11d1314ebbee594e);
const $f6c544561e6a572a$export$11d1314ebbee594e = (meta)=>meta.resourceType;

});

parcelRegister("1BKH7", function(module, exports) {
$parcel$export(module.exports, "extractMetaTenantId", () => $399dc6882d792619$export$92037aea7f27bf7f);
const $399dc6882d792619$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});

parcelRegister("cUGMG", function(module, exports) {
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $e297c316d140c2c4$export$edb8a7a44b91274e);

var $h08yA = parcelRequire("h08yA");
const $e297c316d140c2c4$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $h08yA.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};

});

parcelRegister("ipyyL", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3c91a8ed824be7f$export$2e2bcd8739ae039);

var $cdeW6 = parcelRequire("cdeW6");

var $5kJPq = parcelRequire("5kJPq");
const $f3c91a8ed824be7f$var$priorityMapper = {
    blocker: (0, $5kJPq.IconType).PriorityBlocker,
    critical: (0, $5kJPq.IconType).PriorityCritical,
    high: (0, $5kJPq.IconType).PriorityHigh,
    highest: (0, $5kJPq.IconType).PriorityHighest,
    low: (0, $5kJPq.IconType).PriorityLow,
    lowest: (0, $5kJPq.IconType).PriorityLowest,
    major: (0, $5kJPq.IconType).PriorityMajor,
    medium: (0, $5kJPq.IconType).PriorityMedium,
    minor: (0, $5kJPq.IconType).PriorityMinor,
    trivial: (0, $5kJPq.IconType).PriorityTrivial,
    undefined: (0, $5kJPq.IconType).PriorityUndefined
};
const $f3c91a8ed824be7f$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $f3c91a8ed824be7f$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $cdeW6.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $f3c91a8ed824be7f$export$2e2bcd8739ae039 = $f3c91a8ed824be7f$var$extractPriority;

});

parcelRegister("lIti3", function(module, exports) {
$parcel$export(module.exports, "extractProgrammingLanguage", () => $d95f544af19cc7e2$export$43e54589935a1ff);

var $hSChA = parcelRequire("hSChA");
const $d95f544af19cc7e2$export$43e54589935a1ff = (data)=>(0, $hSChA.extractValue)(data, 'schema:programmingLanguage');

});

parcelRegister("2p62B", function(module, exports) {
$parcel$export(module.exports, "default", () => $a649df2db023704a$export$2e2bcd8739ae039);

var $gxIo9 = parcelRequire("gxIo9");

var $5kJPq = parcelRequire("5kJPq");

var $68DJM = parcelRequire("68DJM");
const $a649df2db023704a$var$extractProvider = (response)=>{
    const provider = (0, $gxIo9.extractSmartLinkProvider)(response);
    if (!provider) return;
    const providerName = provider.text;
    if (provider.id === (0, $68DJM.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5kJPq.IconType).Confluence,
        label: providerName || 'Confluence'
    };
    if (provider.id === (0, $68DJM.JIRA_GENERATOR_ID)) return {
        icon: (0, $5kJPq.IconType).Jira,
        label: providerName || 'Jira'
    };
    if (providerName) return {
        label: providerName,
        url: typeof provider.icon === 'string' ? provider.icon : undefined
    };
};
var $a649df2db023704a$export$2e2bcd8739ae039 = $a649df2db023704a$var$extractProvider;

});

parcelRegister("4JLDa", function(module, exports) {
$parcel$export(module.exports, "extractReadTime", () => $101467fded1d9725$export$cc4028b2878d0675);

var $hSChA = parcelRequire("hSChA");
const $101467fded1d9725$export$cc4028b2878d0675 = (data)=>{
    return (0, $hSChA.extractValue)(data, 'atlassian:readTimeInMinutes');
};

});

parcelRegister("Z5RbA", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkCommentCount", () => $5cb9520c1501af96$export$fb0960a89fb9c17b);

var $3pz0i = parcelRequire("3pz0i");

var $4gDvk = parcelRequire("4gDvk");

var $5YEJ9 = parcelRequire("5YEJ9");
const $5cb9520c1501af96$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $4gDvk.isEntityPresent)(response)) {
        const entity = (0, $3pz0i.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity === null || entity === void 0 ? void 0 : entity.commentCount : undefined;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $5YEJ9.extractCommentCount)(response === null || response === void 0 ? void 0 : response.data);
};

});
parcelRegister("5YEJ9", function(module, exports) {
$parcel$export(module.exports, "extractCommentCount", () => $8d78b73a926ef438$export$b68822b76d5d51d5);

var $hSChA = parcelRequire("hSChA");
const $8d78b73a926ef438$export$b68822b76d5d51d5 = (data)=>(0, $hSChA.extractValue)(data, 'schema:commentCount');

});


parcelRegister("2vry8", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkReactCount", () => $11ffaebc625910e9$export$bb52c21c67a309ca);

var $3pz0i = parcelRequire("3pz0i");

var $4gDvk = parcelRequire("4gDvk");

var $MeM1h = parcelRequire("MeM1h");
const $11ffaebc625910e9$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $4gDvk.isEntityPresent)(response)) {
        const entity = (0, $3pz0i.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions === null || reactions === void 0 ? void 0 : reactions.reduce((total, reaction)=>total + (reaction === null || reaction === void 0 ? void 0 : reaction.total), 0);
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $MeM1h.extractReactCount)(response === null || response === void 0 ? void 0 : response.data);
};

});
parcelRegister("MeM1h", function(module, exports) {
$parcel$export(module.exports, "extractReactCount", () => $eae0e3947fe371b6$export$44130aa92252501);

var $hSChA = parcelRequire("hSChA");
const $eae0e3947fe371b6$export$44130aa92252501 = (data)=>(0, $hSChA.extractValue)(data, 'atlassian:reactCount');

});


parcelRegister("ao6i6", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkSentOn", () => $2b4fc8e9daae541c$export$5c05c5b7ca37e36e);

var $3pz0i = parcelRequire("3pz0i");

var $4gDvk = parcelRequire("4gDvk");

var $4Er3b = parcelRequire("4Er3b");
const $2b4fc8e9daae541c$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $3pz0i.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.createdAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $4Er3b.extractSentOn)(response === null || response === void 0 ? void 0 : response.data);
};

});
parcelRegister("4Er3b", function(module, exports) {
$parcel$export(module.exports, "extractSentOn", () => $a8456ac0531b74fe$export$b592ddecae70b61d);

var $hSChA = parcelRequire("hSChA");
const $a8456ac0531b74fe$export$b592ddecae70b61d = (data)=>{
    return (0, $hSChA.extractValue)(data, 'dateSent');
};

});


parcelRegister("f1XV8", function(module, exports) {
$parcel$export(module.exports, "extractSourceBranch", () => $c25a4a26c5fe1b40$export$949ac6a8325b3fdb);

var $dOyr9 = parcelRequire("dOyr9");
const $c25a4a26c5fe1b40$export$949ac6a8325b3fdb = (data)=>(0, $dOyr9.extractLinkName)(data['atlassian:mergeSource']);

});
parcelRegister("dOyr9", function(module, exports) {
$parcel$export(module.exports, "extractLinkName", () => $f39a674beb43d2c2$export$ec5923ec479b7275);
const $f39a674beb43d2c2$export$ec5923ec479b7275 = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};

});


parcelRegister("kXEi5", function(module, exports) {
$parcel$export(module.exports, "default", () => $7aa7676bcc16d2ab$export$2e2bcd8739ae039);

var $fLcUZ = parcelRequire("fLcUZ");

var $gdUUy = parcelRequire("gdUUy");

var $5kJPq = parcelRequire("5kJPq");

var $gy3md = parcelRequire("gy3md");

var $2BgG1 = parcelRequire("2BgG1");

var $aQflG = parcelRequire("aQflG");

var $hTsyk = parcelRequire("hTsyk");

var $183nD = parcelRequire("183nD");
const $7aa7676bcc16d2ab$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $7aa7676bcc16d2ab$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, isPreviewRestricted)=>{
    var _action$dataRetrieval, _extractInvokePreview, _action$dataUpdateAct;
    const extensionKey = (0, $gy3md.getExtensionKey)(response);
    const data = response === null || response === void 0 ? void 0 : response.data;
    const actions = (0, $183nD.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>(item === null || item === void 0 ? void 0 : item.name) === 'UpdateAction' && (item === null || item === void 0 ? void 0 : item.refField) === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $7aa7676bcc16d2ab$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, (_action$dataRetrieval = action.dataRetrievalAction) === null || _action$dataRetrieval === void 0 ? void 0 : _action$dataRetrieval.name);
    const url = (0, $fLcUZ.extractLink)(data);
    const invokePreviewAction = response ? (_extractInvokePreview = (0, $aQflG.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve({
                url: url,
                isReloading: true
            }) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        ...(0, $gdUUy.fg)('preview_panel_unit_check') ? {
            isPreviewRestricted: isPreviewRestricted
        } : undefined,
        openPreviewPanel: openPreviewPanel,
        transformUrl: transformUrl
    })) === null || _extractInvokePreview === void 0 ? void 0 : _extractInvokePreview.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $7aa7676bcc16d2ab$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, (_action$dataUpdateAct = action.dataUpdateAction) === null || _action$dataUpdateAct === void 0 ? void 0 : _action$dataUpdateAct.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $7aa7676bcc16d2ab$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, isPreviewRestricted)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $hTsyk.extractLozenge)(response === null || response === void 0 ? void 0 : response.data);
    if (!lozenge) return;
    if (!(0, $2BgG1.canShowAction)((0, $5kJPq.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $7aa7676bcc16d2ab$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, (0, $gdUUy.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined);
    return {
        ...lozenge,
        action: action
    };
};
var $7aa7676bcc16d2ab$export$2e2bcd8739ae039 = $7aa7676bcc16d2ab$var$extractState;

});
parcelRegister("hTsyk", function(module, exports) {
$parcel$export(module.exports, "extractLozenge", () => $09641186eae70446$export$e5da155556a77bca);

var $fZvKv = parcelRequire("fZvKv");

var $gImcQ = parcelRequire("gImcQ");

var $hApKM = parcelRequire("hApKM");

var $eGq23 = parcelRequire("eGq23");

var $gpxtq = parcelRequire("gpxtq");
const $09641186eae70446$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $fZvKv.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $hApKM.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $eGq23.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $09641186eae70446$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $gImcQ.extractState)(jsonLd);
    }
};
const $09641186eae70446$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $gpxtq.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("gImcQ", function(module, exports) {
$parcel$export(module.exports, "extractState", () => $19ac4d1161a0568f$export$5e4074cbce6574c7);

var $5MmNI = parcelRequire("5MmNI");
// Maps accent color short names to their corresponding background and text colors
const $19ac4d1161a0568f$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        color: "var(--ds-text-accent-blue, #1558BC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        color: "var(--ds-text-accent-gray, #505258)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
        color: "var(--ds-text-accent-orange, #9E4C00)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
        color: "var(--ds-text-accent-purple, #803FA5)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $19ac4d1161a0568f$var$capitalize = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $19ac4d1161a0568f$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $5MmNI.OMIT_STATES).includes(linkState)) return {
                text: $19ac4d1161a0568f$var$capitalize(linkState),
                appearance: (0, $5MmNI.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $19ac4d1161a0568f$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("5MmNI", function(module, exports) {
$parcel$export(module.exports, "isValidAppearance", () => $8527df626e718fd9$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $8527df626e718fd9$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $8527df626e718fd9$export$772610da74ddbc07);
const $8527df626e718fd9$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $8527df626e718fd9$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $8527df626e718fd9$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $8527df626e718fd9$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default',
    'queued to merge': 'moved'
};
const $8527df626e718fd9$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("hApKM", function(module, exports) {
$parcel$export(module.exports, "extractTag", () => $71a2d7ee899e7e37$export$962a8da34cf78a4f);

var $5MmNI = parcelRequire("5MmNI");
const $71a2d7ee899e7e37$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($71a2d7ee899e7e37$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $71a2d7ee899e7e37$var$extractTagItem(tag);
    }
};
const $71a2d7ee899e7e37$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $5MmNI.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("eGq23", function(module, exports) {
$parcel$export(module.exports, "extractTaskStatus", () => $bf434471ee4be3c5$export$7698df1946deda72);
const $bf434471ee4be3c5$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("2JwUT", function(module, exports) {
$parcel$export(module.exports, "extractStoryPoints", () => $3c5a6931180934fa$export$bdcea84d1550eb9d);

var $hSChA = parcelRequire("hSChA");
const $3c5a6931180934fa$export$bdcea84d1550eb9d = (data)=>{
    return (0, $hSChA.extractValue)(data, 'atlassian:storyPoints');
};

});

parcelRegister("fkpOf", function(module, exports) {
$parcel$export(module.exports, "extractSubTasksProgress", () => $08cfaf0f2eb91881$export$744e3a2674114c1d);

var $hSChA = parcelRequire("hSChA");
const $08cfaf0f2eb91881$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = (0, $hSChA.extractValue)(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};

});

parcelRegister("fqZU4", function(module, exports) {
$parcel$export(module.exports, "extractSubscriberCount", () => $08619b46251863d4$export$8bd03a7beb5badf1);

var $hSChA = parcelRequire("hSChA");
const $08619b46251863d4$export$8bd03a7beb5badf1 = (data)=>(0, $hSChA.extractValue)(data, 'atlassian:subscriberCount');

});

parcelRegister("jhIGk", function(module, exports) {
$parcel$export(module.exports, "extractTargetBranch", () => $5296aaa37145dc09$export$29b0ac5d2f9890cf);

var $dOyr9 = parcelRequire("dOyr9");
const $5296aaa37145dc09$export$29b0ac5d2f9890cf = (data)=>(0, $dOyr9.extractLinkName)(data['atlassian:mergeDestination']);

});

parcelRegister("dFrGy", function(module, exports) {
$parcel$export(module.exports, "extractTeamMemberCount", () => $03be29671089759d$export$9fc8706c6cb5343a);
const $03be29671089759d$export$9fc8706c6cb5343a = (data)=>{
    const val = data !== null && data !== void 0 && data.attributedTo ? Array.isArray(data === null || data === void 0 ? void 0 : data.attributedTo) ? data === null || data === void 0 ? void 0 : data.attributedTo.length : 0 : 0;
    return val;
};

});

parcelRegister("gi9Kl", function(module, exports) {
$parcel$export(module.exports, "extractUserAttributes", () => $e67553574ab5e0db$export$6052f26bb463e370);
const $e67553574ab5e0db$export$6052f26bb463e370 = (data)=>{
    return data === null || data === void 0 ? void 0 : data.userAttributes;
};

});

parcelRegister("9uq6V", function(module, exports) {
$parcel$export(module.exports, "extractViewCount", () => $aa529b475f09e46b$export$e57334ce4738e29d);

var $hSChA = parcelRequire("hSChA");
const $aa529b475f09e46b$export$e57334ce4738e29d = (data)=>(0, $hSChA.extractValue)(data, 'atlassian:viewCount');

});

parcelRegister("akWIi", function(module, exports) {
$parcel$export(module.exports, "extractVoteCount", () => $155fe5de59bf6540$export$c8bef3d5e550a3a);

var $hSChA = parcelRequire("hSChA");
const $155fe5de59bf6540$export$c8bef3d5e550a3a = (data)=>(0, $hSChA.extractValue)(data, 'atlassian:voteCount');

});

parcelRegister("ldLJp", function(module, exports) {
$parcel$export(module.exports, "extractLatestCommit", () => $b7df6993d0d9da75$export$f222392162cff0d8);
const $b7df6993d0d9da75$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});


parcelRegister("tM3zz", function(module, exports) {
$parcel$export(module.exports, "extractErrorIcon", () => $718e647982e336a3$export$bdd29be9b0395931);

var $5kJPq = parcelRequire("5kJPq");

var $g5BC8 = parcelRequire("g5BC8");
const $718e647982e336a3$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $g5BC8.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5kJPq.SmartLinkStatus).Forbidden:
        case (0, $5kJPq.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5kJPq.IconType).Forbidden
            };
        case (0, $5kJPq.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5kJPq.IconType).Error
            };
        case (0, $5kJPq.SmartLinkStatus).Errored:
        case (0, $5kJPq.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5kJPq.IconType).Default
            };
    }
};

});

parcelRegister("5ppN2", function(module, exports) {
$parcel$export(module.exports, "getRetryOptions", () => $59953bb09f5f64fe$export$f3d3482baaff4bf6);

var $gxIo9 = parcelRequire("gxIo9");

var $gdUUy = parcelRequire("gdUUy");

var $5kJPq = parcelRequire("5kJPq");

var $fqW9V = parcelRequire("fqW9V");

var $7wYyA = parcelRequire("7wYyA");

var $hdeqO = parcelRequire("hdeqO");

var $65AjV = parcelRequire("65AjV");
const $59953bb09f5f64fe$var$getForbiddenMessageKey = (meta)=>{
    var _meta$requestAccess;
    const accessType = meta === null || meta === void 0 || (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $59953bb09f5f64fe$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    var _access$action;
    const provider = (0, $gxIo9.extractSmartLinkProvider)(response);
    const context = provider === null || provider === void 0 ? void 0 : provider.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5kJPq.SmartLinkStatus).Forbidden:
            const meta = (response === null || response === void 0 ? void 0 : response.meta) ?? (0, $hdeqO.getForbiddenJsonLd)().meta;
            const access = (0, $fqW9V.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $59953bb09f5f64fe$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $7wYyA.messages)[messageKey];
            const retry = onAuthorize || (access === null || access === void 0 || (_access$action = access.action) === null || _access$action === void 0 ? void 0 : _access$action.promise);
            const onClick = retry && !((access === null || access === void 0 ? void 0 : access.buttonDisabled) ?? false) ? (0, $65AjV.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5kJPq.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $7wYyA.messages).connect_link_account_card_name,
                onClick: (0, $65AjV.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5kJPq.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $7wYyA.messages).cannot_find_link
            };
    }
};

});
parcelRegister("hdeqO", function(module, exports) {
$parcel$export(module.exports, "getForbiddenJsonLd", () => $9d4cfad3f993b778$export$e32193033a594efb);

var $kr2in = parcelRequire("kr2in");
const $9d4cfad3f993b778$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...(0, $kr2in.emptyData)
        }
    });

});





//# sourceMappingURL=shared.97fd2cfd.js.map
